/* tslint:disable */
/* eslint-disable */
/**
 * Tagged Hardware API V2
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface AssignDto
 */
export interface AssignDto {
    /**
     * 
     * @type {string}
     * @memberof AssignDto
     */
    'boltConnectionId': string;
    /**
     * 
     * @type {number}
     * @memberof AssignDto
     */
    'index': number;
}
/**
 * 
 * @export
 * @interface AssignmentDto
 */
export interface AssignmentDto {
    /**
     * 
     * @type {string}
     * @memberof AssignmentDto
     */
    'tenant'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssignmentDto
     */
    'boltConnection'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AssignmentDto
     */
    'index'?: number;
    /**
     * 
     * @type {string}
     * @memberof AssignmentDto
     */
    'assignedAt'?: string;
}
/**
 * 
 * @export
 * @interface BoltChangePhysicalPropertiesDto
 */
export interface BoltChangePhysicalPropertiesDto {
    /**
     * 
     * @type {BoltDiameter}
     * @memberof BoltChangePhysicalPropertiesDto
     */
    'diameter'?: BoltDiameter;
    /**
     * 
     * @type {BoltType}
     * @memberof BoltChangePhysicalPropertiesDto
     */
    'type'?: BoltType;
    /**
     * 
     * @type {Material}
     * @memberof BoltChangePhysicalPropertiesDto
     */
    'material'?: Material;
    /**
     * 
     * @type {number}
     * @memberof BoltChangePhysicalPropertiesDto
     */
    'nominalLengthMm'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof BoltChangePhysicalPropertiesDto
     */
    'apxTotalLengthMm'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof BoltChangePhysicalPropertiesDto
     */
    'springConstantKnMm'?: number | null;
}


/**
 * 
 * @export
 * @interface BoltConnectionBoltDetailsDto
 */
export interface BoltConnectionBoltDetailsDto {
    /**
     * 
     * @type {number}
     * @memberof BoltConnectionBoltDetailsDto
     */
    'characteristicPretensionForceKn': number;
    /**
     * 
     * @type {number}
     * @memberof BoltConnectionBoltDetailsDto
     */
    'numberOfBoltsInCalculation': number;
    /**
     * 
     * @type {number}
     * @memberof BoltConnectionBoltDetailsDto
     */
    'totalNumberOfBolts': number;
    /**
     * 
     * @type {number}
     * @memberof BoltConnectionBoltDetailsDto
     */
    'averagePretensionForceKn': number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const BoltDiameter = {
    None: 'none',
    M12: 'm12',
    M16: 'm16',
    M20: 'm20',
    M24: 'm24',
    M30: 'm30',
    M36: 'm36',
    M42: 'm42',
    M48: 'm48',
    M56: 'm56',
    M64: 'm64',
    M72: 'm72',
    M14: 'm14',
    M18: 'm18',
    M22: 'm22',
    M27: 'm27',
    M33: 'm33',
    M39: 'm39',
    M45: 'm45',
    M52: 'm52',
    M60: 'm60',
    M80: 'm80',
    M90: 'm90',
    M100: 'm100'
} as const;

export type BoltDiameter = typeof BoltDiameter[keyof typeof BoltDiameter];


/**
 * 
 * @export
 * @interface BoltReadDto
 */
export interface BoltReadDto {
    /**
     * 
     * @type {string}
     * @memberof BoltReadDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof BoltReadDto
     */
    'aggregateId': string;
    /**
     * 
     * @type {BoltDiameter}
     * @memberof BoltReadDto
     */
    'diameter': BoltDiameter;
    /**
     * 
     * @type {BoltType}
     * @memberof BoltReadDto
     */
    'type': BoltType;
    /**
     * 
     * @type {number}
     * @memberof BoltReadDto
     */
    'nominalLengthMm': number;
    /**
     * 
     * @type {number}
     * @memberof BoltReadDto
     */
    'apxTotalLengthMm': number;
    /**
     * 
     * @type {Material}
     * @memberof BoltReadDto
     */
    'material': Material;
    /**
     * 
     * @type {MaterialFactors}
     * @memberof BoltReadDto
     */
    'materialFactors': MaterialFactors;
    /**
     * 
     * @type {ManufacturingDetailsDto}
     * @memberof BoltReadDto
     */
    'manufacturingDetails': ManufacturingDetailsDto;
    /**
     * 
     * @type {TraceabilityTagDto}
     * @memberof BoltReadDto
     */
    'currentTag': TraceabilityTagDto;
    /**
     * 
     * @type {Array<TraceabilityTagDto>}
     * @memberof BoltReadDto
     */
    'previousTags': Array<TraceabilityTagDto>;
    /**
     * 
     * @type {Array<MeasurementRecordReadDto>}
     * @memberof BoltReadDto
     */
    'measurementHistory': Array<MeasurementRecordReadDto>;
    /**
     * 
     * @type {MeasurementRecordReadDto}
     * @memberof BoltReadDto
     */
    'activeReferenceMeasurement'?: MeasurementRecordReadDto;
    /**
     * 
     * @type {MeasurementRecordReadDto}
     * @memberof BoltReadDto
     */
    'latestElongationMeasurement'?: MeasurementRecordReadDto;
    /**
     * 
     * @type {string}
     * @memberof BoltReadDto
     */
    'createdBy': string;
    /**
     * 
     * @type {string}
     * @memberof BoltReadDto
     */
    'createdAt': string;
    /**
     * 
     * @type {number}
     * @memberof BoltReadDto
     */
    'pretensionKn': number | null;
    /**
     * 
     * @type {AssignmentDto}
     * @memberof BoltReadDto
     */
    'assignment'?: AssignmentDto;
    /**
     * 
     * @type {string}
     * @memberof BoltReadDto
     */
    'updatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BoltReadDto
     */
    'lastUpdatedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BoltReadDto
     */
    'archivedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BoltReadDto
     */
    'archivedAt'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof BoltReadDto
     */
    'ultrasonicLengthMm'?: number;
    /**
     * 
     * @type {number}
     * @memberof BoltReadDto
     */
    'springConstantKnMm'?: number | null;
}


/**
 * 
 * @export
 * @interface BoltReadDtoPageDto
 */
export interface BoltReadDtoPageDto {
    /**
     * 
     * @type {Array<BoltReadDto>}
     * @memberof BoltReadDtoPageDto
     */
    'items': Array<BoltReadDto>;
    /**
     * 
     * @type {number}
     * @memberof BoltReadDtoPageDto
     */
    'skip': number;
    /**
     * 
     * @type {number}
     * @memberof BoltReadDtoPageDto
     */
    'take': number;
    /**
     * 
     * @type {number}
     * @memberof BoltReadDtoPageDto
     */
    'pageNumber': number;
    /**
     * 
     * @type {number}
     * @memberof BoltReadDtoPageDto
     */
    'pageSize': number;
    /**
     * 
     * @type {number}
     * @memberof BoltReadDtoPageDto
     */
    'totalCount': number;
    /**
     * 
     * @type {number}
     * @memberof BoltReadDtoPageDto
     */
    'totalPages': number;
    /**
     * 
     * @type {boolean}
     * @memberof BoltReadDtoPageDto
     */
    'hasPreviousPage': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BoltReadDtoPageDto
     */
    'hasNextPage': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BoltReadDtoPageDto
     */
    'isFirstPage': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BoltReadDtoPageDto
     */
    'isLastPage': boolean;
}
/**
 * 
 * @export
 * @interface BoltRegisterDto
 */
export interface BoltRegisterDto {
    /**
     * 
     * @type {BoltDiameter}
     * @memberof BoltRegisterDto
     */
    'diameter': BoltDiameter;
    /**
     * 
     * @type {BoltType}
     * @memberof BoltRegisterDto
     */
    'type': BoltType;
    /**
     * 
     * @type {Material}
     * @memberof BoltRegisterDto
     */
    'material': Material;
    /**
     * 
     * @type {number}
     * @memberof BoltRegisterDto
     */
    'nominalLengthMm': number;
    /**
     * 
     * @type {number}
     * @memberof BoltRegisterDto
     */
    'apxTotalLength': number;
    /**
     * 
     * @type {string}
     * @memberof BoltRegisterDto
     */
    'batch': string;
    /**
     * 
     * @type {TraceabilityTagDto}
     * @memberof BoltRegisterDto
     */
    'tag': TraceabilityTagDto;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const BoltType = {
    None: 'none',
    Hv: 'hv',
    IsO4014: 'isO4014',
    ThreadRod: 'threadRod'
} as const;

export type BoltType = typeof BoltType[keyof typeof BoltType];


/**
 * 
 * @export
 * @interface CalibrationReadDto
 */
export interface CalibrationReadDto {
    /**
     * 
     * @type {string}
     * @memberof CalibrationReadDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CalibrationReadDto
     */
    'aggregateId': string;
    /**
     * 
     * @type {string}
     * @memberof CalibrationReadDto
     */
    'sensorId': string;
    /**
     * 
     * @type {string}
     * @memberof CalibrationReadDto
     */
    'deviceId': string;
    /**
     * 
     * @type {string}
     * @memberof CalibrationReadDto
     */
    'calibrationRodId': string;
    /**
     * 
     * @type {string}
     * @memberof CalibrationReadDto
     */
    'tenantId': string;
    /**
     * 
     * @type {ReadingDataDto}
     * @memberof CalibrationReadDto
     */
    'readingData': ReadingDataDto;
    /**
     * 
     * @type {NormalizedCalibrationReadingDto}
     * @memberof CalibrationReadDto
     */
    'normalized': NormalizedCalibrationReadingDto;
    /**
     * 
     * @type {string}
     * @memberof CalibrationReadDto
     */
    'measuredAt': string;
    /**
     * 
     * @type {string}
     * @memberof CalibrationReadDto
     */
    'measuredBy': string;
}
/**
 * 
 * @export
 * @interface CalibrationRodReadDto
 */
export interface CalibrationRodReadDto {
    /**
     * 
     * @type {string}
     * @memberof CalibrationRodReadDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CalibrationRodReadDto
     */
    'aggregateId': string;
    /**
     * 
     * @type {string}
     * @memberof CalibrationRodReadDto
     */
    'serialNo': string;
    /**
     * 
     * @type {number}
     * @memberof CalibrationRodReadDto
     */
    'apxTotalLengthMm': number;
    /**
     * 
     * @type {Material}
     * @memberof CalibrationRodReadDto
     */
    'material': Material;
    /**
     * 
     * @type {MaterialFactors}
     * @memberof CalibrationRodReadDto
     */
    'materialFactors': MaterialFactors;
    /**
     * 
     * @type {TraceabilityTagDto}
     * @memberof CalibrationRodReadDto
     */
    'currentTag': TraceabilityTagDto;
    /**
     * 
     * @type {Array<TraceabilityTagDto>}
     * @memberof CalibrationRodReadDto
     */
    'previousTags': Array<TraceabilityTagDto>;
    /**
     * 
     * @type {Array<MeasurementRecordReadDto>}
     * @memberof CalibrationRodReadDto
     */
    'measurementHistory': Array<MeasurementRecordReadDto>;
    /**
     * 
     * @type {MeasurementRecordReadDto}
     * @memberof CalibrationRodReadDto
     */
    'activeReferenceMeasurement': MeasurementRecordReadDto;
    /**
     * 
     * @type {string}
     * @memberof CalibrationRodReadDto
     */
    'createdBy': string;
    /**
     * 
     * @type {string}
     * @memberof CalibrationRodReadDto
     */
    'updatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CalibrationRodReadDto
     */
    'archivedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CalibrationRodReadDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof CalibrationRodReadDto
     */
    'lastUpdatedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CalibrationRodReadDto
     */
    'archivedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CalibrationRodReadDto
     */
    'lastUsedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CalibrationRodReadDto
     */
    'lastUsedBy'?: string | null;
}


/**
 * 
 * @export
 * @interface CalibrationRodReadDtoPageDto
 */
export interface CalibrationRodReadDtoPageDto {
    /**
     * 
     * @type {Array<CalibrationRodReadDto>}
     * @memberof CalibrationRodReadDtoPageDto
     */
    'items': Array<CalibrationRodReadDto>;
    /**
     * 
     * @type {number}
     * @memberof CalibrationRodReadDtoPageDto
     */
    'skip': number;
    /**
     * 
     * @type {number}
     * @memberof CalibrationRodReadDtoPageDto
     */
    'take': number;
    /**
     * 
     * @type {number}
     * @memberof CalibrationRodReadDtoPageDto
     */
    'pageNumber': number;
    /**
     * 
     * @type {number}
     * @memberof CalibrationRodReadDtoPageDto
     */
    'pageSize': number;
    /**
     * 
     * @type {number}
     * @memberof CalibrationRodReadDtoPageDto
     */
    'totalCount': number;
    /**
     * 
     * @type {number}
     * @memberof CalibrationRodReadDtoPageDto
     */
    'totalPages': number;
    /**
     * 
     * @type {boolean}
     * @memberof CalibrationRodReadDtoPageDto
     */
    'hasPreviousPage': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CalibrationRodReadDtoPageDto
     */
    'hasNextPage': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CalibrationRodReadDtoPageDto
     */
    'isFirstPage': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CalibrationRodReadDtoPageDto
     */
    'isLastPage': boolean;
}
/**
 * 
 * @export
 * @interface CalibrationWithRelatedHardwareReadDto
 */
export interface CalibrationWithRelatedHardwareReadDto {
    /**
     * 
     * @type {string}
     * @memberof CalibrationWithRelatedHardwareReadDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CalibrationWithRelatedHardwareReadDto
     */
    'aggregateId': string;
    /**
     * 
     * @type {string}
     * @memberof CalibrationWithRelatedHardwareReadDto
     */
    'sensorId': string;
    /**
     * 
     * @type {string}
     * @memberof CalibrationWithRelatedHardwareReadDto
     */
    'deviceId': string;
    /**
     * 
     * @type {string}
     * @memberof CalibrationWithRelatedHardwareReadDto
     */
    'calibrationRodId': string;
    /**
     * 
     * @type {string}
     * @memberof CalibrationWithRelatedHardwareReadDto
     */
    'tenantId': string;
    /**
     * 
     * @type {ReadingDataDto}
     * @memberof CalibrationWithRelatedHardwareReadDto
     */
    'readingData': ReadingDataDto;
    /**
     * 
     * @type {NormalizedCalibrationReadingDto}
     * @memberof CalibrationWithRelatedHardwareReadDto
     */
    'normalized': NormalizedCalibrationReadingDto;
    /**
     * 
     * @type {string}
     * @memberof CalibrationWithRelatedHardwareReadDto
     */
    'measuredAt': string;
    /**
     * 
     * @type {string}
     * @memberof CalibrationWithRelatedHardwareReadDto
     */
    'measuredBy': string;
    /**
     * 
     * @type {SensorReadDto}
     * @memberof CalibrationWithRelatedHardwareReadDto
     */
    'sensor'?: SensorReadDto;
    /**
     * 
     * @type {DeviceReadDto}
     * @memberof CalibrationWithRelatedHardwareReadDto
     */
    'device'?: DeviceReadDto;
    /**
     * 
     * @type {CalibrationRodReadDto}
     * @memberof CalibrationWithRelatedHardwareReadDto
     */
    'calibrationRod'?: CalibrationRodReadDto;
}
/**
 * 
 * @export
 * @interface CalibrationWithRelatedHardwareReadDtoPageDto
 */
export interface CalibrationWithRelatedHardwareReadDtoPageDto {
    /**
     * 
     * @type {Array<CalibrationWithRelatedHardwareReadDto>}
     * @memberof CalibrationWithRelatedHardwareReadDtoPageDto
     */
    'items': Array<CalibrationWithRelatedHardwareReadDto>;
    /**
     * 
     * @type {number}
     * @memberof CalibrationWithRelatedHardwareReadDtoPageDto
     */
    'skip': number;
    /**
     * 
     * @type {number}
     * @memberof CalibrationWithRelatedHardwareReadDtoPageDto
     */
    'take': number;
    /**
     * 
     * @type {number}
     * @memberof CalibrationWithRelatedHardwareReadDtoPageDto
     */
    'pageNumber': number;
    /**
     * 
     * @type {number}
     * @memberof CalibrationWithRelatedHardwareReadDtoPageDto
     */
    'pageSize': number;
    /**
     * 
     * @type {number}
     * @memberof CalibrationWithRelatedHardwareReadDtoPageDto
     */
    'totalCount': number;
    /**
     * 
     * @type {number}
     * @memberof CalibrationWithRelatedHardwareReadDtoPageDto
     */
    'totalPages': number;
    /**
     * 
     * @type {boolean}
     * @memberof CalibrationWithRelatedHardwareReadDtoPageDto
     */
    'hasPreviousPage': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CalibrationWithRelatedHardwareReadDtoPageDto
     */
    'hasNextPage': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CalibrationWithRelatedHardwareReadDtoPageDto
     */
    'isFirstPage': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CalibrationWithRelatedHardwareReadDtoPageDto
     */
    'isLastPage': boolean;
}
/**
 * 
 * @export
 * @interface CharacteristicPretensionDto
 */
export interface CharacteristicPretensionDto {
    /**
     * 
     * @type {number}
     * @memberof CharacteristicPretensionDto
     */
    'characteristicPretensionForceKn': number;
    /**
     * 
     * @type {number}
     * @memberof CharacteristicPretensionDto
     */
    'numberOfBoltsInCalculation': number;
    /**
     * 
     * @type {number}
     * @memberof CharacteristicPretensionDto
     */
    'totalNumberOfBolts': number;
}
/**
 * 
 * @export
 * @interface DeviceReadDto
 */
export interface DeviceReadDto {
    /**
     * 
     * @type {string}
     * @memberof DeviceReadDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof DeviceReadDto
     */
    'aggregateId': string;
    /**
     * 
     * @type {string}
     * @memberof DeviceReadDto
     */
    'caseSerialNo': string;
    /**
     * 
     * @type {string}
     * @memberof DeviceReadDto
     */
    'machineId': string;
    /**
     * 
     * @type {string}
     * @memberof DeviceReadDto
     */
    'multiMaxSerialNo': string;
    /**
     * 
     * @type {string}
     * @memberof DeviceReadDto
     */
    'dateOfPurchase': string;
    /**
     * 
     * @type {string}
     * @memberof DeviceReadDto
     */
    'dateOfSystemCalibrationExpiration': string;
    /**
     * 
     * @type {string}
     * @memberof DeviceReadDto
     */
    'machineType': string;
    /**
     * 
     * @type {string}
     * @memberof DeviceReadDto
     */
    'hardwareVersion': string;
    /**
     * 
     * @type {string}
     * @memberof DeviceReadDto
     */
    'softwareVersion': string;
    /**
     * 
     * @type {string}
     * @memberof DeviceReadDto
     */
    'createdAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceReadDto
     */
    'isArchived': boolean;
    /**
     * 
     * @type {string}
     * @memberof DeviceReadDto
     */
    'createdBy': string;
    /**
     * 
     * @type {string}
     * @memberof DeviceReadDto
     */
    'lastUpdatedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceReadDto
     */
    'archivedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceReadDto
     */
    'updatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceReadDto
     */
    'archivedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceReadDto
     */
    'lastUsedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceReadDto
     */
    'lastUsedBy'?: string | null;
}
/**
 * 
 * @export
 * @interface DeviceReadDtoPageDto
 */
export interface DeviceReadDtoPageDto {
    /**
     * 
     * @type {Array<DeviceReadDto>}
     * @memberof DeviceReadDtoPageDto
     */
    'items': Array<DeviceReadDto>;
    /**
     * 
     * @type {number}
     * @memberof DeviceReadDtoPageDto
     */
    'skip': number;
    /**
     * 
     * @type {number}
     * @memberof DeviceReadDtoPageDto
     */
    'take': number;
    /**
     * 
     * @type {number}
     * @memberof DeviceReadDtoPageDto
     */
    'pageNumber': number;
    /**
     * 
     * @type {number}
     * @memberof DeviceReadDtoPageDto
     */
    'pageSize': number;
    /**
     * 
     * @type {number}
     * @memberof DeviceReadDtoPageDto
     */
    'totalCount': number;
    /**
     * 
     * @type {number}
     * @memberof DeviceReadDtoPageDto
     */
    'totalPages': number;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceReadDtoPageDto
     */
    'hasPreviousPage': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceReadDtoPageDto
     */
    'hasNextPage': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceReadDtoPageDto
     */
    'isFirstPage': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceReadDtoPageDto
     */
    'isLastPage': boolean;
}
/**
 * 
 * @export
 * @interface DeviceSelfRegisterDto
 */
export interface DeviceSelfRegisterDto {
    /**
     * 
     * @type {string}
     * @memberof DeviceSelfRegisterDto
     */
    'machineId': string;
    /**
     * 
     * @type {string}
     * @memberof DeviceSelfRegisterDto
     */
    'machineType': string;
    /**
     * 
     * @type {string}
     * @memberof DeviceSelfRegisterDto
     */
    'hardwareVersion': string;
    /**
     * 
     * @type {string}
     * @memberof DeviceSelfRegisterDto
     */
    'softwareVersion': string;
    /**
     * 
     * @type {string}
     * @memberof DeviceSelfRegisterDto
     */
    'multiMaxSerialNo'?: string | null;
}
/**
 * 
 * @export
 * @interface DeviceSettingsDto
 */
export interface DeviceSettingsDto {
    /**
     * 
     * @type {number}
     * @memberof DeviceSettingsDto
     */
    'delayMm': number;
    /**
     * 
     * @type {number}
     * @memberof DeviceSettingsDto
     */
    'gain': number;
    /**
     * 
     * @type {number}
     * @memberof DeviceSettingsDto
     */
    'gateMm': number;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceSettingsDto
     */
    'polarity': boolean;
    /**
     * 
     * @type {number}
     * @memberof DeviceSettingsDto
     */
    'threshold': number;
    /**
     * 
     * @type {number}
     * @memberof DeviceSettingsDto
     */
    'rangeMm': number;
}
/**
 * 
 * @export
 * @interface DeviceVersionPatchDto
 */
export interface DeviceVersionPatchDto {
    /**
     * 
     * @type {string}
     * @memberof DeviceVersionPatchDto
     */
    'hardwareVersion'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceVersionPatchDto
     */
    'softwareVersion'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceVersionPatchDto
     */
    'multiMaxSerialNo'?: string | null;
}
/**
 * 
 * @export
 * @interface GraphDto
 */
export interface GraphDto {
    /**
     * 
     * @type {string}
     * @memberof GraphDto
     */
    'waveformGraphBase64': string | null;
    /**
     * 
     * @type {string}
     * @memberof GraphDto
     */
    'originalWaveformDataBase64'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GraphDto
     */
    'version'?: string | null;
    /**
     * 
     * @type {PlotPoint}
     * @memberof GraphDto
     */
    'triggerStart'?: PlotPoint;
    /**
     * 
     * @type {PlotPoint}
     * @memberof GraphDto
     */
    'triggerEnd': PlotPoint;
    /**
     * 
     * @type {PlotPoint}
     * @memberof GraphDto
     */
    'correctedTiggerStart'?: PlotPoint;
    /**
     * 
     * @type {PlotPoint}
     * @memberof GraphDto
     */
    'correctedTiggerEnd'?: PlotPoint;
    /**
     * 
     * @type {number}
     * @memberof GraphDto
     */
    'overlayThreshold'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GraphDto
     */
    'overlayZeroX'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GraphDto
     */
    'overlayStart'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GraphDto
     */
    'overlayStop'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GraphDto
     */
    'overlayFlank'?: number | null;
}
/**
 * 
 * @export
 * @interface Location
 */
export interface Location {
    /**
     * 
     * @type {number}
     * @memberof Location
     */
    'longitude'?: number;
    /**
     * 
     * @type {number}
     * @memberof Location
     */
    'latitude'?: number;
}
/**
 * 
 * @export
 * @interface ManufacturingDetailsDto
 */
export interface ManufacturingDetailsDto {
    /**
     * 
     * @type {string}
     * @memberof ManufacturingDetailsDto
     */
    'tenant'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ManufacturingDetailsDto
     */
    'batch'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const Material = {
    None: 'none',
    Gr88: 'gr8_8',
    Gr109: 'gr10_9',
    Gr129: 'gr12_9'
} as const;

export type Material = typeof Material[keyof typeof Material];


/**
 * 
 * @export
 * @interface MaterialFactors
 */
export interface MaterialFactors {
    /**
     * 
     * @type {number}
     * @memberof MaterialFactors
     */
    'velocity'?: number;
    /**
     * 
     * @type {number}
     * @memberof MaterialFactors
     */
    'stressFactor'?: number;
    /**
     * 
     * @type {number}
     * @memberof MaterialFactors
     */
    'tempCoef'?: number;
}
/**
 * 
 * @export
 * @interface MeasurementRecordReadDto
 */
export interface MeasurementRecordReadDto {
    /**
     * 
     * @type {string}
     * @memberof MeasurementRecordReadDto
     */
    'id': string;
    /**
     * 
     * @type {MeasurementType}
     * @memberof MeasurementRecordReadDto
     */
    'type': MeasurementType;
    /**
     * 
     * @type {Location}
     * @memberof MeasurementRecordReadDto
     */
    'location'?: Location;
    /**
     * 
     * @type {ReadingDataDto}
     * @memberof MeasurementRecordReadDto
     */
    'readingData': ReadingDataDto;
    /**
     * 
     * @type {NormalizedReadingDto}
     * @memberof MeasurementRecordReadDto
     */
    'normalized': NormalizedReadingDto;
    /**
     * 
     * @type {string}
     * @memberof MeasurementRecordReadDto
     */
    'measuredAt': string;
    /**
     * 
     * @type {string}
     * @memberof MeasurementRecordReadDto
     */
    'measuredBy': string;
    /**
     * 
     * @type {MeasurementSource}
     * @memberof MeasurementRecordReadDto
     */
    'source': MeasurementSource;
    /**
     * 
     * @type {string}
     * @memberof MeasurementRecordReadDto
     */
    'comment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MeasurementRecordReadDto
     */
    'overwritableComment'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MeasurementRecordReadDto
     */
    'pretensionForceKn'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MeasurementRecordReadDto
     */
    'archivedBy': string;
    /**
     * 
     * @type {string}
     * @memberof MeasurementRecordReadDto
     */
    'archivedAt': string;
    /**
     * 
     * @type {string}
     * @memberof MeasurementRecordReadDto
     */
    'basedOnMeasurement': string;
    /**
     * 
     * @type {string}
     * @memberof MeasurementRecordReadDto
     */
    'calibrationId': string;
    /**
     * 
     * @type {string}
     * @memberof MeasurementRecordReadDto
     */
    'sensorId': string;
    /**
     * 
     * @type {string}
     * @memberof MeasurementRecordReadDto
     */
    'deviceId': string;
    /**
     * 
     * @type {string}
     * @memberof MeasurementRecordReadDto
     */
    'deviceSoftwareVersion': string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const MeasurementSource = {
    None: 'none',
    Measured: 'measured',
    Manual: 'manual'
} as const;

export type MeasurementSource = typeof MeasurementSource[keyof typeof MeasurementSource];


/**
 * 
 * @export
 * @enum {string}
 */

export const MeasurementType = {
    None: 'none',
    Reference: 'reference',
    Elongation: 'elongation'
} as const;

export type MeasurementType = typeof MeasurementType[keyof typeof MeasurementType];


/**
 * 
 * @export
 * @interface NormalizedCalibrationReadingDto
 */
export interface NormalizedCalibrationReadingDto {
    /**
     * 
     * @type {string}
     * @memberof NormalizedCalibrationReadingDto
     */
    'version': string;
    /**
     * 
     * @type {number}
     * @memberof NormalizedCalibrationReadingDto
     */
    'temperatureC': number;
    /**
     * 
     * @type {number}
     * @memberof NormalizedCalibrationReadingDto
     */
    'resultTofNs': number;
}
/**
 * 
 * @export
 * @interface NormalizedReadingDto
 */
export interface NormalizedReadingDto {
    /**
     * 
     * @type {string}
     * @memberof NormalizedReadingDto
     */
    'version': string;
    /**
     * 
     * @type {number}
     * @memberof NormalizedReadingDto
     */
    'temperatureC': number;
    /**
     * 
     * @type {number}
     * @memberof NormalizedReadingDto
     */
    'resultMm': number;
    /**
     * 
     * @type {number}
     * @memberof NormalizedReadingDto
     */
    'offsetMm': number | null;
    /**
     * 
     * @type {Array<PlotPoint>}
     * @memberof NormalizedReadingDto
     */
    'waveformGraph'?: Array<PlotPoint> | null;
    /**
     * 
     * @type {PlotPoint}
     * @memberof NormalizedReadingDto
     */
    'triggerStart'?: PlotPoint;
    /**
     * 
     * @type {PlotPoint}
     * @memberof NormalizedReadingDto
     */
    'triggerEnd'?: PlotPoint;
}
/**
 * 
 * @export
 * @interface PlotPoint
 */
export interface PlotPoint {
    /**
     * 
     * @type {number}
     * @memberof PlotPoint
     */
    'x'?: number;
    /**
     * 
     * @type {number}
     * @memberof PlotPoint
     */
    'y'?: number;
}
/**
 * 
 * @export
 * @interface ProblemDetails
 */
export interface ProblemDetails {
    [key: string]: any;

    /**
     * 
     * @type {string}
     * @memberof ProblemDetails
     */
    'type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProblemDetails
     */
    'title'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProblemDetails
     */
    'status'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ProblemDetails
     */
    'detail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProblemDetails
     */
    'instance'?: string | null;
}
/**
 * 
 * @export
 * @interface QualityRatingDto
 */
export interface QualityRatingDto {
    /**
     * 
     * @type {number}
     * @memberof QualityRatingDto
     */
    'value'?: number;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof QualityRatingDto
     */
    'individualScores'?: { [key: string]: number; } | null;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof QualityRatingDto
     */
    'individualWeights'?: { [key: string]: number; } | null;
}
/**
 * 
 * @export
 * @interface ReadingDataDto
 */
export interface ReadingDataDto {
    /**
     * 
     * @type {GraphDto}
     * @memberof ReadingDataDto
     */
    'graph'?: GraphDto;
    /**
     * 
     * @type {QualityRatingDto}
     * @memberof ReadingDataDto
     */
    'quality'?: QualityRatingDto;
    /**
     * 
     * @type {number}
     * @memberof ReadingDataDto
     */
    'timeOfFlightNs'?: number;
    /**
     * 
     * @type {number}
     * @memberof ReadingDataDto
     */
    'temperatureC'?: number;
    /**
     * 
     * @type {DeviceSettingsDto}
     * @memberof ReadingDataDto
     */
    'settings': DeviceSettingsDto;
}
/**
 * 
 * @export
 * @interface RecordCalibrationDto
 */
export interface RecordCalibrationDto {
    /**
     * 
     * @type {QualityRatingDto}
     * @memberof RecordCalibrationDto
     */
    'quality': QualityRatingDto;
    /**
     * 
     * @type {string}
     * @memberof RecordCalibrationDto
     */
    'measuredAt': string;
    /**
     * 
     * @type {GraphDto}
     * @memberof RecordCalibrationDto
     */
    'graph': GraphDto;
    /**
     * 
     * @type {number}
     * @memberof RecordCalibrationDto
     */
    'timeOfFlightNs': number;
    /**
     * 
     * @type {number}
     * @memberof RecordCalibrationDto
     */
    'temperatureC': number;
    /**
     * 
     * @type {DeviceSettingsDto}
     * @memberof RecordCalibrationDto
     */
    'settings': DeviceSettingsDto;
    /**
     * 
     * @type {string}
     * @memberof RecordCalibrationDto
     */
    'calibrationRodId': string;
    /**
     * 
     * @type {string}
     * @memberof RecordCalibrationDto
     */
    'sensorId': string;
    /**
     * 
     * @type {string}
     * @memberof RecordCalibrationDto
     */
    'deviceId': string;
}
/**
 * 
 * @export
 * @interface RecordManualMeasurementDto
 */
export interface RecordManualMeasurementDto {
    /**
     * 
     * @type {string}
     * @memberof RecordManualMeasurementDto
     */
    'basedOnMeasurementId': string;
    /**
     * 
     * @type {string}
     * @memberof RecordManualMeasurementDto
     */
    'comment': string;
    /**
     * 
     * @type {number}
     * @memberof RecordManualMeasurementDto
     */
    'newResult': number;
    /**
     * 
     * @type {MeasurementType}
     * @memberof RecordManualMeasurementDto
     */
    'nextMeasurementType': MeasurementType;
}


/**
 * 
 * @export
 * @interface RecordMeasurementDto
 */
export interface RecordMeasurementDto {
    /**
     * 
     * @type {Location}
     * @memberof RecordMeasurementDto
     */
    'locationAt'?: Location;
    /**
     * 
     * @type {string}
     * @memberof RecordMeasurementDto
     */
    'comment'?: string | null;
    /**
     * 
     * @type {QualityRatingDto}
     * @memberof RecordMeasurementDto
     */
    'quality'?: QualityRatingDto;
    /**
     * 
     * @type {string}
     * @memberof RecordMeasurementDto
     */
    'measuredAt': string;
    /**
     * 
     * @type {GraphDto}
     * @memberof RecordMeasurementDto
     */
    'graph': GraphDto;
    /**
     * 
     * @type {number}
     * @memberof RecordMeasurementDto
     */
    'timeOfFlightNs': number;
    /**
     * 
     * @type {number}
     * @memberof RecordMeasurementDto
     */
    'temperatureC': number;
    /**
     * 
     * @type {DeviceSettingsDto}
     * @memberof RecordMeasurementDto
     */
    'settings': DeviceSettingsDto;
    /**
     * 
     * @type {string}
     * @memberof RecordMeasurementDto
     */
    'calibrationId': string;
    /**
     * 
     * @type {string}
     * @memberof RecordMeasurementDto
     */
    'sensorId': string;
    /**
     * 
     * @type {string}
     * @memberof RecordMeasurementDto
     */
    'deviceId': string;
}
/**
 * 
 * @export
 * @interface RegisterCalibrationRodDto
 */
export interface RegisterCalibrationRodDto {
    /**
     * 
     * @type {string}
     * @memberof RegisterCalibrationRodDto
     */
    'serialNo': string;
    /**
     * 
     * @type {Material}
     * @memberof RegisterCalibrationRodDto
     */
    'material': Material;
    /**
     * 
     * @type {number}
     * @memberof RegisterCalibrationRodDto
     */
    'apxTotalLength': number;
    /**
     * 
     * @type {TraceabilityTagDto}
     * @memberof RegisterCalibrationRodDto
     */
    'tag': TraceabilityTagDto;
}


/**
 * 
 * @export
 * @interface ReplaceTagDto
 */
export interface ReplaceTagDto {
    /**
     * 
     * @type {TraceabilityTagDto}
     * @memberof ReplaceTagDto
     */
    'nextTag': TraceabilityTagDto;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const SensorFrequency = {
    None: 'none',
    MHz225: 'mHz2_25',
    MHz5: 'mHz5'
} as const;

export type SensorFrequency = typeof SensorFrequency[keyof typeof SensorFrequency];


/**
 * 
 * @export
 * @interface SensorFrequencySettingDto
 */
export interface SensorFrequencySettingDto {
    /**
     * 
     * @type {string}
     * @memberof SensorFrequencySettingDto
     */
    'displayName': string;
    /**
     * 
     * @type {SensorFrequency}
     * @memberof SensorFrequencySettingDto
     */
    'value': SensorFrequency;
}


/**
 * 
 * @export
 * @interface SensorPostDto
 */
export interface SensorPostDto {
    /**
     * 
     * @type {string}
     * @memberof SensorPostDto
     */
    'serialNo': string;
    /**
     * 
     * @type {SensorSize}
     * @memberof SensorPostDto
     */
    'size': SensorSize;
    /**
     * 
     * @type {SensorFrequency}
     * @memberof SensorPostDto
     */
    'frequency': SensorFrequency;
    /**
     * 
     * @type {TraceabilityTagDto}
     * @memberof SensorPostDto
     */
    'tag': TraceabilityTagDto;
}


/**
 * 
 * @export
 * @interface SensorPutDto
 */
export interface SensorPutDto {
    /**
     * 
     * @type {string}
     * @memberof SensorPutDto
     */
    'serialNo': string;
    /**
     * 
     * @type {SensorSize}
     * @memberof SensorPutDto
     */
    'size': SensorSize;
    /**
     * 
     * @type {SensorFrequency}
     * @memberof SensorPutDto
     */
    'frequency': SensorFrequency;
}


/**
 * 
 * @export
 * @interface SensorReadDto
 */
export interface SensorReadDto {
    /**
     * 
     * @type {string}
     * @memberof SensorReadDto
     */
    'id': string | null;
    /**
     * 
     * @type {string}
     * @memberof SensorReadDto
     */
    'aggregateId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SensorReadDto
     */
    'serialNo': string | null;
    /**
     * 
     * @type {number}
     * @memberof SensorReadDto
     */
    'numberOfMeasurementsUsed': number;
    /**
     * 
     * @type {SensorSize}
     * @memberof SensorReadDto
     */
    'size': SensorSize;
    /**
     * 
     * @type {SensorFrequency}
     * @memberof SensorReadDto
     */
    'frequency': SensorFrequency;
    /**
     * 
     * @type {TraceabilityTagDto}
     * @memberof SensorReadDto
     */
    'currentTag': TraceabilityTagDto;
    /**
     * 
     * @type {Array<TraceabilityTagDto>}
     * @memberof SensorReadDto
     */
    'previousTags': Array<TraceabilityTagDto> | null;
    /**
     * 
     * @type {string}
     * @memberof SensorReadDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof SensorReadDto
     */
    'lastUpdatedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SensorReadDto
     */
    'archivedAt'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SensorReadDto
     */
    'isArchived': boolean;
    /**
     * 
     * @type {string}
     * @memberof SensorReadDto
     */
    'createdBy': string | null;
    /**
     * 
     * @type {string}
     * @memberof SensorReadDto
     */
    'updatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SensorReadDto
     */
    'archivedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SensorReadDto
     */
    'lastUsedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SensorReadDto
     */
    'lastUsedBy'?: string | null;
}


/**
 * 
 * @export
 * @interface SensorReadDtoPageDto
 */
export interface SensorReadDtoPageDto {
    /**
     * 
     * @type {Array<SensorReadDto>}
     * @memberof SensorReadDtoPageDto
     */
    'items': Array<SensorReadDto>;
    /**
     * 
     * @type {number}
     * @memberof SensorReadDtoPageDto
     */
    'skip': number;
    /**
     * 
     * @type {number}
     * @memberof SensorReadDtoPageDto
     */
    'take': number;
    /**
     * 
     * @type {number}
     * @memberof SensorReadDtoPageDto
     */
    'pageNumber': number;
    /**
     * 
     * @type {number}
     * @memberof SensorReadDtoPageDto
     */
    'pageSize': number;
    /**
     * 
     * @type {number}
     * @memberof SensorReadDtoPageDto
     */
    'totalCount': number;
    /**
     * 
     * @type {number}
     * @memberof SensorReadDtoPageDto
     */
    'totalPages': number;
    /**
     * 
     * @type {boolean}
     * @memberof SensorReadDtoPageDto
     */
    'hasPreviousPage': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SensorReadDtoPageDto
     */
    'hasNextPage': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SensorReadDtoPageDto
     */
    'isFirstPage': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SensorReadDtoPageDto
     */
    'isLastPage': boolean;
}
/**
 * 
 * @export
 * @interface SensorSettingsDto
 */
export interface SensorSettingsDto {
    /**
     * 
     * @type {Array<SensorSizeSettingDto>}
     * @memberof SensorSettingsDto
     */
    'sizes': Array<SensorSizeSettingDto>;
    /**
     * 
     * @type {Array<SensorFrequencySettingDto>}
     * @memberof SensorSettingsDto
     */
    'frequencies': Array<SensorFrequencySettingDto>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const SensorSize = {
    None: 'none',
    OneEighth: 'oneEighth',
    OneQuarter: 'oneQuarter',
    ThreeEighths: 'threeEighths',
    OneHalf: 'oneHalf',
    ThreeQuarters: 'threeQuarters'
} as const;

export type SensorSize = typeof SensorSize[keyof typeof SensorSize];


/**
 * 
 * @export
 * @interface SensorSizeSettingDto
 */
export interface SensorSizeSettingDto {
    /**
     * 
     * @type {string}
     * @memberof SensorSizeSettingDto
     */
    'displayName': string;
    /**
     * 
     * @type {SensorSize}
     * @memberof SensorSizeSettingDto
     */
    'value': SensorSize;
}


/**
 * 
 * @export
 * @interface SetMeasurementCommentDto
 */
export interface SetMeasurementCommentDto {
    /**
     * 
     * @type {string}
     * @memberof SetMeasurementCommentDto
     */
    'comment': string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const TaggedHardwareKind = {
    Bolt: 'bolt',
    Sensor: 'sensor',
    CalibrationRod: 'calibrationRod'
} as const;

export type TaggedHardwareKind = typeof TaggedHardwareKind[keyof typeof TaggedHardwareKind];


/**
 * 
 * @export
 * @interface TaggedHardwareLookupByTagReadDto
 */
export interface TaggedHardwareLookupByTagReadDto {
    /**
     * 
     * @type {TaggedHardwareKind}
     * @memberof TaggedHardwareLookupByTagReadDto
     */
    'kind': TaggedHardwareKind;
    /**
     * 
     * @type {any}
     * @memberof TaggedHardwareLookupByTagReadDto
     */
    'item': any;
}


/**
 * 
 * @export
 * @interface TraceabilityTagDto
 */
export interface TraceabilityTagDto {
    /**
     * 
     * @type {string}
     * @memberof TraceabilityTagDto
     */
    'tagId': string;
}

/**
 * BoltApi - axios parameter creator
 * @export
 */
export const BoltApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Required permissions: `hardware:write`
         * @param {string} boltId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveBoltV2: async (boltId: string, tenantId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'boltId' is not null or undefined
            assertParamExists('archiveBoltV2', 'boltId', boltId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('archiveBoltV2', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/tagged-hardware/v2/bolt/{boltId}/archive`
                .replace(`{${"boltId"}}`, encodeURIComponent(String(boltId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: `hardware:write`
         * @param {string} boltId 
         * @param {string} measurementId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveMeasurementV2: async (boltId: string, measurementId: string, tenantId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'boltId' is not null or undefined
            assertParamExists('archiveMeasurementV2', 'boltId', boltId)
            // verify required parameter 'measurementId' is not null or undefined
            assertParamExists('archiveMeasurementV2', 'measurementId', measurementId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('archiveMeasurementV2', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/tagged-hardware/v2/bolt/{boltId}/measurement/{measurementId}/archive`
                .replace(`{${"boltId"}}`, encodeURIComponent(String(boltId)))
                .replace(`{${"measurementId"}}`, encodeURIComponent(String(measurementId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: `device-app:*`
         * @param {string} boltId 
         * @param {string} tenantId 
         * @param {AssignDto} [assignDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignBoltToBoltConnectionV2: async (boltId: string, tenantId: string, assignDto?: AssignDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'boltId' is not null or undefined
            assertParamExists('assignBoltToBoltConnectionV2', 'boltId', boltId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('assignBoltToBoltConnectionV2', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/tagged-hardware/v2/bolt/{boltId}/assign`
                .replace(`{${"boltId"}}`, encodeURIComponent(String(boltId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: `hardware:write`
         * @param {string} boltId 
         * @param {string} measurementId 
         * @param {string} tenantId 
         * @param {SetMeasurementCommentDto} [setMeasurementCommentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeMeasurementCommentV2: async (boltId: string, measurementId: string, tenantId: string, setMeasurementCommentDto?: SetMeasurementCommentDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'boltId' is not null or undefined
            assertParamExists('changeMeasurementCommentV2', 'boltId', boltId)
            // verify required parameter 'measurementId' is not null or undefined
            assertParamExists('changeMeasurementCommentV2', 'measurementId', measurementId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('changeMeasurementCommentV2', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/tagged-hardware/v2/bolt/{boltId}/measurement/{measurementId}/comment`
                .replace(`{${"boltId"}}`, encodeURIComponent(String(boltId)))
                .replace(`{${"measurementId"}}`, encodeURIComponent(String(measurementId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setMeasurementCommentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: `hardware:write`
         * @param {string} boltId 
         * @param {string} tenantId 
         * @param {BoltChangePhysicalPropertiesDto} [boltChangePhysicalPropertiesDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePhysicalPropertiesOnBoltV2: async (boltId: string, tenantId: string, boltChangePhysicalPropertiesDto?: BoltChangePhysicalPropertiesDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'boltId' is not null or undefined
            assertParamExists('changePhysicalPropertiesOnBoltV2', 'boltId', boltId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('changePhysicalPropertiesOnBoltV2', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/tagged-hardware/v2/bolt/{boltId}/physical-properties`
                .replace(`{${"boltId"}}`, encodeURIComponent(String(boltId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(boltChangePhysicalPropertiesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: `hardware:write`
         * @param {string} boltId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eraseBoltV2: async (boltId: string, tenantId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'boltId' is not null or undefined
            assertParamExists('eraseBoltV2', 'boltId', boltId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('eraseBoltV2', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/tagged-hardware/v2/bolt/{boltId}`
                .replace(`{${"boltId"}}`, encodeURIComponent(String(boltId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: `hardware:write`
         * @param {string} boltId 
         * @param {string} measurementId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eraseMeasurementV2: async (boltId: string, measurementId: string, tenantId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'boltId' is not null or undefined
            assertParamExists('eraseMeasurementV2', 'boltId', boltId)
            // verify required parameter 'measurementId' is not null or undefined
            assertParamExists('eraseMeasurementV2', 'measurementId', measurementId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('eraseMeasurementV2', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/tagged-hardware/v2/bolt/{boltId}/measurement/{measurementId}`
                .replace(`{${"boltId"}}`, encodeURIComponent(String(boltId)))
                .replace(`{${"measurementId"}}`, encodeURIComponent(String(measurementId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: `hardware:read`
         * @param {string} tenantId 
         * @param {string} [sortBy] 
         * @param {boolean} [ascending] 
         * @param {number} [nominalLengthStart] 
         * @param {number} [nominalLengthEnd] 
         * @param {number} [ultrasonicLengthEnd] 
         * @param {number} [ultrasonicLengthStart] 
         * @param {BoltDiameter} [boltDiameter] 
         * @param {Material} [material] 
         * @param {BoltType} [boltType] 
         * @param {boolean} [includeArchived] 
         * @param {boolean} [onlyArchived] 
         * @param {string} [includeArchivedAfter] 
         * @param {string} [createdAtStart] 
         * @param {string} [createdAtEnd] 
         * @param {string} [updatedAtStart] 
         * @param {string} [updatedAtEnd] 
         * @param {string} [archivedAtStart] 
         * @param {string} [archivedAtEnd] 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {boolean} [includeMeasurements] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBoltsV2: async (tenantId: string, sortBy?: string, ascending?: boolean, nominalLengthStart?: number, nominalLengthEnd?: number, ultrasonicLengthEnd?: number, ultrasonicLengthStart?: number, boltDiameter?: BoltDiameter, material?: Material, boltType?: BoltType, includeArchived?: boolean, onlyArchived?: boolean, includeArchivedAfter?: string, createdAtStart?: string, createdAtEnd?: string, updatedAtStart?: string, updatedAtEnd?: string, archivedAtStart?: string, archivedAtEnd?: string, skip?: number, take?: number, includeMeasurements?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getAllBoltsV2', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/tagged-hardware/v2/bolt`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (sortBy !== undefined) {
                localVarQueryParameter['SortBy'] = sortBy;
            }

            if (ascending !== undefined) {
                localVarQueryParameter['Ascending'] = ascending;
            }

            if (nominalLengthStart !== undefined) {
                localVarQueryParameter['NominalLengthStart'] = nominalLengthStart;
            }

            if (nominalLengthEnd !== undefined) {
                localVarQueryParameter['NominalLengthEnd'] = nominalLengthEnd;
            }

            if (ultrasonicLengthEnd !== undefined) {
                localVarQueryParameter['UltrasonicLengthEnd'] = ultrasonicLengthEnd;
            }

            if (ultrasonicLengthStart !== undefined) {
                localVarQueryParameter['UltrasonicLengthStart'] = ultrasonicLengthStart;
            }

            if (boltDiameter !== undefined) {
                localVarQueryParameter['BoltDiameter'] = boltDiameter;
            }

            if (material !== undefined) {
                localVarQueryParameter['Material'] = material;
            }

            if (boltType !== undefined) {
                localVarQueryParameter['BoltType'] = boltType;
            }

            if (includeArchived !== undefined) {
                localVarQueryParameter['IncludeArchived'] = includeArchived;
            }

            if (onlyArchived !== undefined) {
                localVarQueryParameter['OnlyArchived'] = onlyArchived;
            }

            if (includeArchivedAfter !== undefined) {
                localVarQueryParameter['IncludeArchivedAfter'] = (includeArchivedAfter as any instanceof Date) ?
                    (includeArchivedAfter as any).toISOString() :
                    includeArchivedAfter;
            }

            if (createdAtStart !== undefined) {
                localVarQueryParameter['CreatedAtStart'] = (createdAtStart as any instanceof Date) ?
                    (createdAtStart as any).toISOString() :
                    createdAtStart;
            }

            if (createdAtEnd !== undefined) {
                localVarQueryParameter['CreatedAtEnd'] = (createdAtEnd as any instanceof Date) ?
                    (createdAtEnd as any).toISOString() :
                    createdAtEnd;
            }

            if (updatedAtStart !== undefined) {
                localVarQueryParameter['UpdatedAtStart'] = (updatedAtStart as any instanceof Date) ?
                    (updatedAtStart as any).toISOString() :
                    updatedAtStart;
            }

            if (updatedAtEnd !== undefined) {
                localVarQueryParameter['UpdatedAtEnd'] = (updatedAtEnd as any instanceof Date) ?
                    (updatedAtEnd as any).toISOString() :
                    updatedAtEnd;
            }

            if (archivedAtStart !== undefined) {
                localVarQueryParameter['ArchivedAtStart'] = (archivedAtStart as any instanceof Date) ?
                    (archivedAtStart as any).toISOString() :
                    archivedAtStart;
            }

            if (archivedAtEnd !== undefined) {
                localVarQueryParameter['ArchivedAtEnd'] = (archivedAtEnd as any instanceof Date) ?
                    (archivedAtEnd as any).toISOString() :
                    archivedAtEnd;
            }

            if (skip !== undefined) {
                localVarQueryParameter['Skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['Take'] = take;
            }

            if (includeMeasurements !== undefined) {
                localVarQueryParameter['includeMeasurements'] = includeMeasurements;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: `hardware:read`
         * @param {string} tagId 
         * @param {boolean} [includeArchived] 
         * @param {boolean} [includeMeasurements] 
         * @param {boolean} [generateWaveForm] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getBoltByTagGlobalV2: async (tagId: string, includeArchived?: boolean, includeMeasurements?: boolean, generateWaveForm?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tagId' is not null or undefined
            assertParamExists('getBoltByTagGlobalV2', 'tagId', tagId)
            const localVarPath = `/tagged-hardware/v2/bolt/tag/{tagId}`
                .replace(`{${"tagId"}}`, encodeURIComponent(String(tagId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (includeArchived !== undefined) {
                localVarQueryParameter['includeArchived'] = includeArchived;
            }

            if (includeMeasurements !== undefined) {
                localVarQueryParameter['includeMeasurements'] = includeMeasurements;
            }

            if (generateWaveForm !== undefined) {
                localVarQueryParameter['generateWaveForm'] = generateWaveForm;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: [`hardware:read` OR `device-app:*`]
         * @param {string} tagId 
         * @param {string} tenantId 
         * @param {boolean} [includeArchived] 
         * @param {boolean} [includeMeasurements] 
         * @param {boolean} [generateWaveForm] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getBoltByTagV2: async (tagId: string, tenantId: string, includeArchived?: boolean, includeMeasurements?: boolean, generateWaveForm?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tagId' is not null or undefined
            assertParamExists('getBoltByTagV2', 'tagId', tagId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getBoltByTagV2', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/tagged-hardware/v2/bolt/tag/{tagId}`
                .replace(`{${"tagId"}}`, encodeURIComponent(String(tagId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (includeArchived !== undefined) {
                localVarQueryParameter['includeArchived'] = includeArchived;
            }

            if (includeMeasurements !== undefined) {
                localVarQueryParameter['includeMeasurements'] = includeMeasurements;
            }

            if (generateWaveForm !== undefined) {
                localVarQueryParameter['generateWaveForm'] = generateWaveForm;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: [`hardware:read` OR `device-app:*`]
         * @param {string} boltConnectionId 
         * @param {string} tenantId 
         * @param {string} [measuredAtStart] 
         * @param {string} [measuredAtEnd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBoltConnectionBoltDetailsV2: async (boltConnectionId: string, tenantId: string, measuredAtStart?: string, measuredAtEnd?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'boltConnectionId' is not null or undefined
            assertParamExists('getBoltConnectionBoltDetailsV2', 'boltConnectionId', boltConnectionId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getBoltConnectionBoltDetailsV2', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/tagged-hardware/v2/bolt-connection/{boltConnectionId}/bolt-details`
                .replace(`{${"boltConnectionId"}}`, encodeURIComponent(String(boltConnectionId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (measuredAtStart !== undefined) {
                localVarQueryParameter['measuredAtStart'] = (measuredAtStart as any instanceof Date) ?
                    (measuredAtStart as any).toISOString() :
                    measuredAtStart;
            }

            if (measuredAtEnd !== undefined) {
                localVarQueryParameter['measuredAtEnd'] = (measuredAtEnd as any instanceof Date) ?
                    (measuredAtEnd as any).toISOString() :
                    measuredAtEnd;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: `hardware:read`
         * @param {string} boltId 
         * @param {boolean} [includeArchived] 
         * @param {boolean} [includeMeasurements] 
         * @param {boolean} [generateWaveForm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBoltGlobalV2: async (boltId: string, includeArchived?: boolean, includeMeasurements?: boolean, generateWaveForm?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'boltId' is not null or undefined
            assertParamExists('getBoltGlobalV2', 'boltId', boltId)
            const localVarPath = `/tagged-hardware/v2/bolt/{boltId}`
                .replace(`{${"boltId"}}`, encodeURIComponent(String(boltId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (includeArchived !== undefined) {
                localVarQueryParameter['includeArchived'] = includeArchived;
            }

            if (includeMeasurements !== undefined) {
                localVarQueryParameter['includeMeasurements'] = includeMeasurements;
            }

            if (generateWaveForm !== undefined) {
                localVarQueryParameter['generateWaveForm'] = generateWaveForm;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: [`hardware:read` OR `device-app:*`]
         * @param {string} boltId 
         * @param {string} tenantId 
         * @param {boolean} [includeArchived] 
         * @param {boolean} [includeMeasurements] 
         * @param {boolean} [generateWaveForm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBoltV2: async (boltId: string, tenantId: string, includeArchived?: boolean, includeMeasurements?: boolean, generateWaveForm?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'boltId' is not null or undefined
            assertParamExists('getBoltV2', 'boltId', boltId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getBoltV2', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/tagged-hardware/v2/bolt/{boltId}`
                .replace(`{${"boltId"}}`, encodeURIComponent(String(boltId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (includeArchived !== undefined) {
                localVarQueryParameter['includeArchived'] = includeArchived;
            }

            if (includeMeasurements !== undefined) {
                localVarQueryParameter['includeMeasurements'] = includeMeasurements;
            }

            if (generateWaveForm !== undefined) {
                localVarQueryParameter['generateWaveForm'] = generateWaveForm;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: [`hardware:read` OR `device-app:*`]
         * @param {string} tenantId 
         * @param {boolean} [includeArchived] 
         * @param {Array<string>} [ids] 
         * @param {boolean} [includeMeasurements] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBoltsByIdsV2: async (tenantId: string, includeArchived?: boolean, ids?: Array<string>, includeMeasurements?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getBoltsByIdsV2', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/tagged-hardware/v2/bolt/ids`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (includeArchived !== undefined) {
                localVarQueryParameter['includeArchived'] = includeArchived;
            }

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }

            if (includeMeasurements !== undefined) {
                localVarQueryParameter['includeMeasurements'] = includeMeasurements;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: [`hardware:read` OR `device-app:*`]
         * @param {string} boltConnectionId 
         * @param {string} tenantId 
         * @param {string} [sortBy] 
         * @param {boolean} [ascending] 
         * @param {number} [nominalLengthStart] 
         * @param {number} [nominalLengthEnd] 
         * @param {number} [ultrasonicLengthEnd] 
         * @param {number} [ultrasonicLengthStart] 
         * @param {BoltDiameter} [boltDiameter] 
         * @param {Material} [material] 
         * @param {BoltType} [boltType] 
         * @param {boolean} [includeArchived] 
         * @param {boolean} [onlyArchived] 
         * @param {string} [includeArchivedAfter] 
         * @param {string} [createdAtStart] 
         * @param {string} [createdAtEnd] 
         * @param {string} [updatedAtStart] 
         * @param {string} [updatedAtEnd] 
         * @param {string} [archivedAtStart] 
         * @param {string} [archivedAtEnd] 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {boolean} [includeMeasurements] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBoltsOfBoltConnectionV2: async (boltConnectionId: string, tenantId: string, sortBy?: string, ascending?: boolean, nominalLengthStart?: number, nominalLengthEnd?: number, ultrasonicLengthEnd?: number, ultrasonicLengthStart?: number, boltDiameter?: BoltDiameter, material?: Material, boltType?: BoltType, includeArchived?: boolean, onlyArchived?: boolean, includeArchivedAfter?: string, createdAtStart?: string, createdAtEnd?: string, updatedAtStart?: string, updatedAtEnd?: string, archivedAtStart?: string, archivedAtEnd?: string, skip?: number, take?: number, includeMeasurements?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'boltConnectionId' is not null or undefined
            assertParamExists('getBoltsOfBoltConnectionV2', 'boltConnectionId', boltConnectionId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getBoltsOfBoltConnectionV2', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/tagged-hardware/v2/bolt-connection/{boltConnectionId}/bolt`
                .replace(`{${"boltConnectionId"}}`, encodeURIComponent(String(boltConnectionId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (sortBy !== undefined) {
                localVarQueryParameter['SortBy'] = sortBy;
            }

            if (ascending !== undefined) {
                localVarQueryParameter['Ascending'] = ascending;
            }

            if (nominalLengthStart !== undefined) {
                localVarQueryParameter['NominalLengthStart'] = nominalLengthStart;
            }

            if (nominalLengthEnd !== undefined) {
                localVarQueryParameter['NominalLengthEnd'] = nominalLengthEnd;
            }

            if (ultrasonicLengthEnd !== undefined) {
                localVarQueryParameter['UltrasonicLengthEnd'] = ultrasonicLengthEnd;
            }

            if (ultrasonicLengthStart !== undefined) {
                localVarQueryParameter['UltrasonicLengthStart'] = ultrasonicLengthStart;
            }

            if (boltDiameter !== undefined) {
                localVarQueryParameter['BoltDiameter'] = boltDiameter;
            }

            if (material !== undefined) {
                localVarQueryParameter['Material'] = material;
            }

            if (boltType !== undefined) {
                localVarQueryParameter['BoltType'] = boltType;
            }

            if (includeArchived !== undefined) {
                localVarQueryParameter['IncludeArchived'] = includeArchived;
            }

            if (onlyArchived !== undefined) {
                localVarQueryParameter['OnlyArchived'] = onlyArchived;
            }

            if (includeArchivedAfter !== undefined) {
                localVarQueryParameter['IncludeArchivedAfter'] = (includeArchivedAfter as any instanceof Date) ?
                    (includeArchivedAfter as any).toISOString() :
                    includeArchivedAfter;
            }

            if (createdAtStart !== undefined) {
                localVarQueryParameter['CreatedAtStart'] = (createdAtStart as any instanceof Date) ?
                    (createdAtStart as any).toISOString() :
                    createdAtStart;
            }

            if (createdAtEnd !== undefined) {
                localVarQueryParameter['CreatedAtEnd'] = (createdAtEnd as any instanceof Date) ?
                    (createdAtEnd as any).toISOString() :
                    createdAtEnd;
            }

            if (updatedAtStart !== undefined) {
                localVarQueryParameter['UpdatedAtStart'] = (updatedAtStart as any instanceof Date) ?
                    (updatedAtStart as any).toISOString() :
                    updatedAtStart;
            }

            if (updatedAtEnd !== undefined) {
                localVarQueryParameter['UpdatedAtEnd'] = (updatedAtEnd as any instanceof Date) ?
                    (updatedAtEnd as any).toISOString() :
                    updatedAtEnd;
            }

            if (archivedAtStart !== undefined) {
                localVarQueryParameter['ArchivedAtStart'] = (archivedAtStart as any instanceof Date) ?
                    (archivedAtStart as any).toISOString() :
                    archivedAtStart;
            }

            if (archivedAtEnd !== undefined) {
                localVarQueryParameter['ArchivedAtEnd'] = (archivedAtEnd as any instanceof Date) ?
                    (archivedAtEnd as any).toISOString() :
                    archivedAtEnd;
            }

            if (skip !== undefined) {
                localVarQueryParameter['Skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['Take'] = take;
            }

            if (includeMeasurements !== undefined) {
                localVarQueryParameter['includeMeasurements'] = includeMeasurements;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: `hardware:read`
         * @param {string} tenantId 
         * @param {string} [sortBy] 
         * @param {boolean} [ascending] 
         * @param {number} [nominalLengthStart] 
         * @param {number} [nominalLengthEnd] 
         * @param {number} [ultrasonicLengthEnd] 
         * @param {number} [ultrasonicLengthStart] 
         * @param {BoltDiameter} [boltDiameter] 
         * @param {Material} [material] 
         * @param {BoltType} [boltType] 
         * @param {boolean} [includeArchived] 
         * @param {boolean} [onlyArchived] 
         * @param {string} [includeArchivedAfter] 
         * @param {string} [createdAtStart] 
         * @param {string} [createdAtEnd] 
         * @param {string} [updatedAtStart] 
         * @param {string} [updatedAtEnd] 
         * @param {string} [archivedAtStart] 
         * @param {string} [archivedAtEnd] 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {boolean} [includeMeasurements] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBoltsOfManufacturerV2: async (tenantId: string, sortBy?: string, ascending?: boolean, nominalLengthStart?: number, nominalLengthEnd?: number, ultrasonicLengthEnd?: number, ultrasonicLengthStart?: number, boltDiameter?: BoltDiameter, material?: Material, boltType?: BoltType, includeArchived?: boolean, onlyArchived?: boolean, includeArchivedAfter?: string, createdAtStart?: string, createdAtEnd?: string, updatedAtStart?: string, updatedAtEnd?: string, archivedAtStart?: string, archivedAtEnd?: string, skip?: number, take?: number, includeMeasurements?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getBoltsOfManufacturerV2', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/tagged-hardware/v2/bolt/manufactured`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (sortBy !== undefined) {
                localVarQueryParameter['SortBy'] = sortBy;
            }

            if (ascending !== undefined) {
                localVarQueryParameter['Ascending'] = ascending;
            }

            if (nominalLengthStart !== undefined) {
                localVarQueryParameter['NominalLengthStart'] = nominalLengthStart;
            }

            if (nominalLengthEnd !== undefined) {
                localVarQueryParameter['NominalLengthEnd'] = nominalLengthEnd;
            }

            if (ultrasonicLengthEnd !== undefined) {
                localVarQueryParameter['UltrasonicLengthEnd'] = ultrasonicLengthEnd;
            }

            if (ultrasonicLengthStart !== undefined) {
                localVarQueryParameter['UltrasonicLengthStart'] = ultrasonicLengthStart;
            }

            if (boltDiameter !== undefined) {
                localVarQueryParameter['BoltDiameter'] = boltDiameter;
            }

            if (material !== undefined) {
                localVarQueryParameter['Material'] = material;
            }

            if (boltType !== undefined) {
                localVarQueryParameter['BoltType'] = boltType;
            }

            if (includeArchived !== undefined) {
                localVarQueryParameter['IncludeArchived'] = includeArchived;
            }

            if (onlyArchived !== undefined) {
                localVarQueryParameter['OnlyArchived'] = onlyArchived;
            }

            if (includeArchivedAfter !== undefined) {
                localVarQueryParameter['IncludeArchivedAfter'] = (includeArchivedAfter as any instanceof Date) ?
                    (includeArchivedAfter as any).toISOString() :
                    includeArchivedAfter;
            }

            if (createdAtStart !== undefined) {
                localVarQueryParameter['CreatedAtStart'] = (createdAtStart as any instanceof Date) ?
                    (createdAtStart as any).toISOString() :
                    createdAtStart;
            }

            if (createdAtEnd !== undefined) {
                localVarQueryParameter['CreatedAtEnd'] = (createdAtEnd as any instanceof Date) ?
                    (createdAtEnd as any).toISOString() :
                    createdAtEnd;
            }

            if (updatedAtStart !== undefined) {
                localVarQueryParameter['UpdatedAtStart'] = (updatedAtStart as any instanceof Date) ?
                    (updatedAtStart as any).toISOString() :
                    updatedAtStart;
            }

            if (updatedAtEnd !== undefined) {
                localVarQueryParameter['UpdatedAtEnd'] = (updatedAtEnd as any instanceof Date) ?
                    (updatedAtEnd as any).toISOString() :
                    updatedAtEnd;
            }

            if (archivedAtStart !== undefined) {
                localVarQueryParameter['ArchivedAtStart'] = (archivedAtStart as any instanceof Date) ?
                    (archivedAtStart as any).toISOString() :
                    archivedAtStart;
            }

            if (archivedAtEnd !== undefined) {
                localVarQueryParameter['ArchivedAtEnd'] = (archivedAtEnd as any instanceof Date) ?
                    (archivedAtEnd as any).toISOString() :
                    archivedAtEnd;
            }

            if (skip !== undefined) {
                localVarQueryParameter['Skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['Take'] = take;
            }

            if (includeMeasurements !== undefined) {
                localVarQueryParameter['includeMeasurements'] = includeMeasurements;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: [`hardware:read` OR `device-app:*`]
         * @param {string} boltConnectionId 
         * @param {string} tenantId 
         * @param {string} [measuredAtStart] 
         * @param {string} [measuredAtEnd] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getCharacteristicPretensionOfBoltConnectionV2: async (boltConnectionId: string, tenantId: string, measuredAtStart?: string, measuredAtEnd?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'boltConnectionId' is not null or undefined
            assertParamExists('getCharacteristicPretensionOfBoltConnectionV2', 'boltConnectionId', boltConnectionId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getCharacteristicPretensionOfBoltConnectionV2', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/tagged-hardware/v2/bolt-connection/{boltConnectionId}/characteristic-pretension`
                .replace(`{${"boltConnectionId"}}`, encodeURIComponent(String(boltConnectionId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (measuredAtStart !== undefined) {
                localVarQueryParameter['measuredAtStart'] = (measuredAtStart as any instanceof Date) ?
                    (measuredAtStart as any).toISOString() :
                    measuredAtStart;
            }

            if (measuredAtEnd !== undefined) {
                localVarQueryParameter['measuredAtEnd'] = (measuredAtEnd as any instanceof Date) ?
                    (measuredAtEnd as any).toISOString() :
                    measuredAtEnd;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [sortBy] 
         * @param {boolean} [ascending] 
         * @param {number} [nominalLengthStart] 
         * @param {number} [nominalLengthEnd] 
         * @param {number} [ultrasonicLengthEnd] 
         * @param {number} [ultrasonicLengthStart] 
         * @param {BoltDiameter} [boltDiameter] 
         * @param {Material} [material] 
         * @param {BoltType} [boltType] 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {boolean} [includeArchived] 
         * @param {boolean} [onlyArchived] 
         * @param {string} [includeArchivedAfter] 
         * @param {string} [createdAtStart] 
         * @param {string} [createdAtEnd] 
         * @param {string} [updatedAtStart] 
         * @param {string} [updatedAtEnd] 
         * @param {string} [archivedAtStart] 
         * @param {string} [archivedAtEnd] 
         * @param {boolean} [includeMeasurements] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnassignedBoltsGlobalV2: async (sortBy?: string, ascending?: boolean, nominalLengthStart?: number, nominalLengthEnd?: number, ultrasonicLengthEnd?: number, ultrasonicLengthStart?: number, boltDiameter?: BoltDiameter, material?: Material, boltType?: BoltType, skip?: number, take?: number, includeArchived?: boolean, onlyArchived?: boolean, includeArchivedAfter?: string, createdAtStart?: string, createdAtEnd?: string, updatedAtStart?: string, updatedAtEnd?: string, archivedAtStart?: string, archivedAtEnd?: string, includeMeasurements?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/tagged-hardware/v2/bolt/unassigned`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (sortBy !== undefined) {
                localVarQueryParameter['SortBy'] = sortBy;
            }

            if (ascending !== undefined) {
                localVarQueryParameter['Ascending'] = ascending;
            }

            if (nominalLengthStart !== undefined) {
                localVarQueryParameter['NominalLengthStart'] = nominalLengthStart;
            }

            if (nominalLengthEnd !== undefined) {
                localVarQueryParameter['NominalLengthEnd'] = nominalLengthEnd;
            }

            if (ultrasonicLengthEnd !== undefined) {
                localVarQueryParameter['UltrasonicLengthEnd'] = ultrasonicLengthEnd;
            }

            if (ultrasonicLengthStart !== undefined) {
                localVarQueryParameter['UltrasonicLengthStart'] = ultrasonicLengthStart;
            }

            if (boltDiameter !== undefined) {
                localVarQueryParameter['BoltDiameter'] = boltDiameter;
            }

            if (material !== undefined) {
                localVarQueryParameter['Material'] = material;
            }

            if (boltType !== undefined) {
                localVarQueryParameter['BoltType'] = boltType;
            }

            if (skip !== undefined) {
                localVarQueryParameter['Skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['Take'] = take;
            }

            if (includeArchived !== undefined) {
                localVarQueryParameter['IncludeArchived'] = includeArchived;
            }

            if (onlyArchived !== undefined) {
                localVarQueryParameter['OnlyArchived'] = onlyArchived;
            }

            if (includeArchivedAfter !== undefined) {
                localVarQueryParameter['IncludeArchivedAfter'] = (includeArchivedAfter as any instanceof Date) ?
                    (includeArchivedAfter as any).toISOString() :
                    includeArchivedAfter;
            }

            if (createdAtStart !== undefined) {
                localVarQueryParameter['CreatedAtStart'] = (createdAtStart as any instanceof Date) ?
                    (createdAtStart as any).toISOString() :
                    createdAtStart;
            }

            if (createdAtEnd !== undefined) {
                localVarQueryParameter['CreatedAtEnd'] = (createdAtEnd as any instanceof Date) ?
                    (createdAtEnd as any).toISOString() :
                    createdAtEnd;
            }

            if (updatedAtStart !== undefined) {
                localVarQueryParameter['UpdatedAtStart'] = (updatedAtStart as any instanceof Date) ?
                    (updatedAtStart as any).toISOString() :
                    updatedAtStart;
            }

            if (updatedAtEnd !== undefined) {
                localVarQueryParameter['UpdatedAtEnd'] = (updatedAtEnd as any instanceof Date) ?
                    (updatedAtEnd as any).toISOString() :
                    updatedAtEnd;
            }

            if (archivedAtStart !== undefined) {
                localVarQueryParameter['ArchivedAtStart'] = (archivedAtStart as any instanceof Date) ?
                    (archivedAtStart as any).toISOString() :
                    archivedAtStart;
            }

            if (archivedAtEnd !== undefined) {
                localVarQueryParameter['ArchivedAtEnd'] = (archivedAtEnd as any instanceof Date) ?
                    (archivedAtEnd as any).toISOString() :
                    archivedAtEnd;
            }

            if (includeMeasurements !== undefined) {
                localVarQueryParameter['includeMeasurements'] = includeMeasurements;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: [`hardware:read` OR `device-app:*`]
         * @param {string} tenantId 
         * @param {string} [sortBy] 
         * @param {boolean} [ascending] 
         * @param {number} [nominalLengthStart] 
         * @param {number} [nominalLengthEnd] 
         * @param {number} [ultrasonicLengthEnd] 
         * @param {number} [ultrasonicLengthStart] 
         * @param {BoltDiameter} [boltDiameter] 
         * @param {Material} [material] 
         * @param {BoltType} [boltType] 
         * @param {boolean} [includeArchived] 
         * @param {boolean} [onlyArchived] 
         * @param {string} [includeArchivedAfter] 
         * @param {string} [createdAtStart] 
         * @param {string} [createdAtEnd] 
         * @param {string} [updatedAtStart] 
         * @param {string} [updatedAtEnd] 
         * @param {string} [archivedAtStart] 
         * @param {string} [archivedAtEnd] 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {boolean} [includeMeasurements] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnassignedBoltsV2: async (tenantId: string, sortBy?: string, ascending?: boolean, nominalLengthStart?: number, nominalLengthEnd?: number, ultrasonicLengthEnd?: number, ultrasonicLengthStart?: number, boltDiameter?: BoltDiameter, material?: Material, boltType?: BoltType, includeArchived?: boolean, onlyArchived?: boolean, includeArchivedAfter?: string, createdAtStart?: string, createdAtEnd?: string, updatedAtStart?: string, updatedAtEnd?: string, archivedAtStart?: string, archivedAtEnd?: string, skip?: number, take?: number, includeMeasurements?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getUnassignedBoltsV2', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/tagged-hardware/v2/bolt/unassigned`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (sortBy !== undefined) {
                localVarQueryParameter['SortBy'] = sortBy;
            }

            if (ascending !== undefined) {
                localVarQueryParameter['Ascending'] = ascending;
            }

            if (nominalLengthStart !== undefined) {
                localVarQueryParameter['NominalLengthStart'] = nominalLengthStart;
            }

            if (nominalLengthEnd !== undefined) {
                localVarQueryParameter['NominalLengthEnd'] = nominalLengthEnd;
            }

            if (ultrasonicLengthEnd !== undefined) {
                localVarQueryParameter['UltrasonicLengthEnd'] = ultrasonicLengthEnd;
            }

            if (ultrasonicLengthStart !== undefined) {
                localVarQueryParameter['UltrasonicLengthStart'] = ultrasonicLengthStart;
            }

            if (boltDiameter !== undefined) {
                localVarQueryParameter['BoltDiameter'] = boltDiameter;
            }

            if (material !== undefined) {
                localVarQueryParameter['Material'] = material;
            }

            if (boltType !== undefined) {
                localVarQueryParameter['BoltType'] = boltType;
            }

            if (includeArchived !== undefined) {
                localVarQueryParameter['IncludeArchived'] = includeArchived;
            }

            if (onlyArchived !== undefined) {
                localVarQueryParameter['OnlyArchived'] = onlyArchived;
            }

            if (includeArchivedAfter !== undefined) {
                localVarQueryParameter['IncludeArchivedAfter'] = (includeArchivedAfter as any instanceof Date) ?
                    (includeArchivedAfter as any).toISOString() :
                    includeArchivedAfter;
            }

            if (createdAtStart !== undefined) {
                localVarQueryParameter['CreatedAtStart'] = (createdAtStart as any instanceof Date) ?
                    (createdAtStart as any).toISOString() :
                    createdAtStart;
            }

            if (createdAtEnd !== undefined) {
                localVarQueryParameter['CreatedAtEnd'] = (createdAtEnd as any instanceof Date) ?
                    (createdAtEnd as any).toISOString() :
                    createdAtEnd;
            }

            if (updatedAtStart !== undefined) {
                localVarQueryParameter['UpdatedAtStart'] = (updatedAtStart as any instanceof Date) ?
                    (updatedAtStart as any).toISOString() :
                    updatedAtStart;
            }

            if (updatedAtEnd !== undefined) {
                localVarQueryParameter['UpdatedAtEnd'] = (updatedAtEnd as any instanceof Date) ?
                    (updatedAtEnd as any).toISOString() :
                    updatedAtEnd;
            }

            if (archivedAtStart !== undefined) {
                localVarQueryParameter['ArchivedAtStart'] = (archivedAtStart as any instanceof Date) ?
                    (archivedAtStart as any).toISOString() :
                    archivedAtStart;
            }

            if (archivedAtEnd !== undefined) {
                localVarQueryParameter['ArchivedAtEnd'] = (archivedAtEnd as any instanceof Date) ?
                    (archivedAtEnd as any).toISOString() :
                    archivedAtEnd;
            }

            if (skip !== undefined) {
                localVarQueryParameter['Skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['Take'] = take;
            }

            if (includeMeasurements !== undefined) {
                localVarQueryParameter['includeMeasurements'] = includeMeasurements;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: `hardware:write` (global scope)
         * @param {string} boltId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        invalidateBoltTagV2: async (boltId: string, tenantId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'boltId' is not null or undefined
            assertParamExists('invalidateBoltTagV2', 'boltId', boltId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('invalidateBoltTagV2', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/tagged-hardware/v2/bolt/{boltId}/invalidate-tag`
                .replace(`{${"boltId"}}`, encodeURIComponent(String(boltId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: `device-app:*`
         * @param {string} boltId 
         * @param {string} tenantId 
         * @param {RecordMeasurementDto} [recordMeasurementDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recordElongationBoltMeasurementV2: async (boltId: string, tenantId: string, recordMeasurementDto?: RecordMeasurementDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'boltId' is not null or undefined
            assertParamExists('recordElongationBoltMeasurementV2', 'boltId', boltId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('recordElongationBoltMeasurementV2', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/tagged-hardware/v2/bolt/{boltId}/elongation-measurement`
                .replace(`{${"boltId"}}`, encodeURIComponent(String(boltId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(recordMeasurementDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: `hardware:write`
         * @param {string} boltId 
         * @param {string} tenantId 
         * @param {RecordManualMeasurementDto} [recordManualMeasurementDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recordManualBoltMeasurementV2: async (boltId: string, tenantId: string, recordManualMeasurementDto?: RecordManualMeasurementDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'boltId' is not null or undefined
            assertParamExists('recordManualBoltMeasurementV2', 'boltId', boltId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('recordManualBoltMeasurementV2', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/tagged-hardware/v2/bolt/{boltId}/manual-measurement`
                .replace(`{${"boltId"}}`, encodeURIComponent(String(boltId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(recordManualMeasurementDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: `device-app:*`
         * @param {string} boltId 
         * @param {string} tenantId 
         * @param {RecordMeasurementDto} [recordMeasurementDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recordReferenceBoltMeasurementV2: async (boltId: string, tenantId: string, recordMeasurementDto?: RecordMeasurementDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'boltId' is not null or undefined
            assertParamExists('recordReferenceBoltMeasurementV2', 'boltId', boltId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('recordReferenceBoltMeasurementV2', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/tagged-hardware/v2/bolt/{boltId}/reference-measurement`
                .replace(`{${"boltId"}}`, encodeURIComponent(String(boltId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(recordMeasurementDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: `device-app:*`
         * @param {string} tenantId 
         * @param {BoltRegisterDto} [boltRegisterDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerBoltV2: async (tenantId: string, boltRegisterDto?: BoltRegisterDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('registerBoltV2', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/tagged-hardware/v2/bolt`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(boltRegisterDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: [`hardware:write` OR `device-app:*`]
         * @param {string} boltId 
         * @param {string} tenantId 
         * @param {ReplaceTagDto} [replaceTagDto] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        replaceBoltTagV2: async (boltId: string, tenantId: string, replaceTagDto?: ReplaceTagDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'boltId' is not null or undefined
            assertParamExists('replaceBoltTagV2', 'boltId', boltId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('replaceBoltTagV2', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/tagged-hardware/v2/bolt/{boltId}/replace-tag`
                .replace(`{${"boltId"}}`, encodeURIComponent(String(boltId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(replaceTagDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: `hardware:write`
         * @param {string} boltId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreBoltV2: async (boltId: string, tenantId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'boltId' is not null or undefined
            assertParamExists('restoreBoltV2', 'boltId', boltId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('restoreBoltV2', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/tagged-hardware/v2/bolt/{boltId}/restore`
                .replace(`{${"boltId"}}`, encodeURIComponent(String(boltId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: `hardware:write`
         * @param {string} boltId 
         * @param {string} measurementId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreMeasurementV2: async (boltId: string, measurementId: string, tenantId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'boltId' is not null or undefined
            assertParamExists('restoreMeasurementV2', 'boltId', boltId)
            // verify required parameter 'measurementId' is not null or undefined
            assertParamExists('restoreMeasurementV2', 'measurementId', measurementId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('restoreMeasurementV2', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/tagged-hardware/v2/bolt/{boltId}/measurement/{measurementId}/restore`
                .replace(`{${"boltId"}}`, encodeURIComponent(String(boltId)))
                .replace(`{${"measurementId"}}`, encodeURIComponent(String(measurementId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: `hardware:write`
         * @param {string} boltId 
         * @param {string} measurementId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setActiveReferenceMeasurementOnBoltV2: async (boltId: string, measurementId: string, tenantId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'boltId' is not null or undefined
            assertParamExists('setActiveReferenceMeasurementOnBoltV2', 'boltId', boltId)
            // verify required parameter 'measurementId' is not null or undefined
            assertParamExists('setActiveReferenceMeasurementOnBoltV2', 'measurementId', measurementId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('setActiveReferenceMeasurementOnBoltV2', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/tagged-hardware/v2/bolt/{boltId}/reference-measurement/{measurementId}/active`
                .replace(`{${"boltId"}}`, encodeURIComponent(String(boltId)))
                .replace(`{${"measurementId"}}`, encodeURIComponent(String(measurementId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: [`hardware:write` OR `device-app:*`]
         * @param {string} boltId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unassignBoltV2: async (boltId: string, tenantId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'boltId' is not null or undefined
            assertParamExists('unassignBoltV2', 'boltId', boltId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('unassignBoltV2', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/tagged-hardware/v2/bolt/{boltId}/unassign`
                .replace(`{${"boltId"}}`, encodeURIComponent(String(boltId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BoltApi - functional programming interface
 * @export
 */
export const BoltApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BoltApiAxiosParamCreator(configuration)
    return {
        /**
         * Required permissions: `hardware:write`
         * @param {string} boltId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async archiveBoltV2(boltId: string, tenantId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BoltReadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.archiveBoltV2(boltId, tenantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BoltApi.archiveBoltV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: `hardware:write`
         * @param {string} boltId 
         * @param {string} measurementId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async archiveMeasurementV2(boltId: string, measurementId: string, tenantId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BoltReadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.archiveMeasurementV2(boltId, measurementId, tenantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BoltApi.archiveMeasurementV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: `device-app:*`
         * @param {string} boltId 
         * @param {string} tenantId 
         * @param {AssignDto} [assignDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignBoltToBoltConnectionV2(boltId: string, tenantId: string, assignDto?: AssignDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BoltReadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignBoltToBoltConnectionV2(boltId, tenantId, assignDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BoltApi.assignBoltToBoltConnectionV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: `hardware:write`
         * @param {string} boltId 
         * @param {string} measurementId 
         * @param {string} tenantId 
         * @param {SetMeasurementCommentDto} [setMeasurementCommentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeMeasurementCommentV2(boltId: string, measurementId: string, tenantId: string, setMeasurementCommentDto?: SetMeasurementCommentDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BoltReadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeMeasurementCommentV2(boltId, measurementId, tenantId, setMeasurementCommentDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BoltApi.changeMeasurementCommentV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: `hardware:write`
         * @param {string} boltId 
         * @param {string} tenantId 
         * @param {BoltChangePhysicalPropertiesDto} [boltChangePhysicalPropertiesDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changePhysicalPropertiesOnBoltV2(boltId: string, tenantId: string, boltChangePhysicalPropertiesDto?: BoltChangePhysicalPropertiesDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BoltReadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changePhysicalPropertiesOnBoltV2(boltId, tenantId, boltChangePhysicalPropertiesDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BoltApi.changePhysicalPropertiesOnBoltV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: `hardware:write`
         * @param {string} boltId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async eraseBoltV2(boltId: string, tenantId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BoltReadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.eraseBoltV2(boltId, tenantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BoltApi.eraseBoltV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: `hardware:write`
         * @param {string} boltId 
         * @param {string} measurementId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async eraseMeasurementV2(boltId: string, measurementId: string, tenantId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BoltReadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.eraseMeasurementV2(boltId, measurementId, tenantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BoltApi.eraseMeasurementV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: `hardware:read`
         * @param {string} tenantId 
         * @param {string} [sortBy] 
         * @param {boolean} [ascending] 
         * @param {number} [nominalLengthStart] 
         * @param {number} [nominalLengthEnd] 
         * @param {number} [ultrasonicLengthEnd] 
         * @param {number} [ultrasonicLengthStart] 
         * @param {BoltDiameter} [boltDiameter] 
         * @param {Material} [material] 
         * @param {BoltType} [boltType] 
         * @param {boolean} [includeArchived] 
         * @param {boolean} [onlyArchived] 
         * @param {string} [includeArchivedAfter] 
         * @param {string} [createdAtStart] 
         * @param {string} [createdAtEnd] 
         * @param {string} [updatedAtStart] 
         * @param {string} [updatedAtEnd] 
         * @param {string} [archivedAtStart] 
         * @param {string} [archivedAtEnd] 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {boolean} [includeMeasurements] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllBoltsV2(tenantId: string, sortBy?: string, ascending?: boolean, nominalLengthStart?: number, nominalLengthEnd?: number, ultrasonicLengthEnd?: number, ultrasonicLengthStart?: number, boltDiameter?: BoltDiameter, material?: Material, boltType?: BoltType, includeArchived?: boolean, onlyArchived?: boolean, includeArchivedAfter?: string, createdAtStart?: string, createdAtEnd?: string, updatedAtStart?: string, updatedAtEnd?: string, archivedAtStart?: string, archivedAtEnd?: string, skip?: number, take?: number, includeMeasurements?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BoltReadDtoPageDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllBoltsV2(tenantId, sortBy, ascending, nominalLengthStart, nominalLengthEnd, ultrasonicLengthEnd, ultrasonicLengthStart, boltDiameter, material, boltType, includeArchived, onlyArchived, includeArchivedAfter, createdAtStart, createdAtEnd, updatedAtStart, updatedAtEnd, archivedAtStart, archivedAtEnd, skip, take, includeMeasurements, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BoltApi.getAllBoltsV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: `hardware:read`
         * @param {string} tagId 
         * @param {boolean} [includeArchived] 
         * @param {boolean} [includeMeasurements] 
         * @param {boolean} [generateWaveForm] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async getBoltByTagGlobalV2(tagId: string, includeArchived?: boolean, includeMeasurements?: boolean, generateWaveForm?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BoltReadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBoltByTagGlobalV2(tagId, includeArchived, includeMeasurements, generateWaveForm, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BoltApi.getBoltByTagGlobalV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: [`hardware:read` OR `device-app:*`]
         * @param {string} tagId 
         * @param {string} tenantId 
         * @param {boolean} [includeArchived] 
         * @param {boolean} [includeMeasurements] 
         * @param {boolean} [generateWaveForm] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async getBoltByTagV2(tagId: string, tenantId: string, includeArchived?: boolean, includeMeasurements?: boolean, generateWaveForm?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BoltReadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBoltByTagV2(tagId, tenantId, includeArchived, includeMeasurements, generateWaveForm, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BoltApi.getBoltByTagV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: [`hardware:read` OR `device-app:*`]
         * @param {string} boltConnectionId 
         * @param {string} tenantId 
         * @param {string} [measuredAtStart] 
         * @param {string} [measuredAtEnd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBoltConnectionBoltDetailsV2(boltConnectionId: string, tenantId: string, measuredAtStart?: string, measuredAtEnd?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BoltConnectionBoltDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBoltConnectionBoltDetailsV2(boltConnectionId, tenantId, measuredAtStart, measuredAtEnd, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BoltApi.getBoltConnectionBoltDetailsV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: `hardware:read`
         * @param {string} boltId 
         * @param {boolean} [includeArchived] 
         * @param {boolean} [includeMeasurements] 
         * @param {boolean} [generateWaveForm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBoltGlobalV2(boltId: string, includeArchived?: boolean, includeMeasurements?: boolean, generateWaveForm?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BoltReadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBoltGlobalV2(boltId, includeArchived, includeMeasurements, generateWaveForm, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BoltApi.getBoltGlobalV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: [`hardware:read` OR `device-app:*`]
         * @param {string} boltId 
         * @param {string} tenantId 
         * @param {boolean} [includeArchived] 
         * @param {boolean} [includeMeasurements] 
         * @param {boolean} [generateWaveForm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBoltV2(boltId: string, tenantId: string, includeArchived?: boolean, includeMeasurements?: boolean, generateWaveForm?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BoltReadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBoltV2(boltId, tenantId, includeArchived, includeMeasurements, generateWaveForm, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BoltApi.getBoltV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: [`hardware:read` OR `device-app:*`]
         * @param {string} tenantId 
         * @param {boolean} [includeArchived] 
         * @param {Array<string>} [ids] 
         * @param {boolean} [includeMeasurements] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBoltsByIdsV2(tenantId: string, includeArchived?: boolean, ids?: Array<string>, includeMeasurements?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BoltReadDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBoltsByIdsV2(tenantId, includeArchived, ids, includeMeasurements, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BoltApi.getBoltsByIdsV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: [`hardware:read` OR `device-app:*`]
         * @param {string} boltConnectionId 
         * @param {string} tenantId 
         * @param {string} [sortBy] 
         * @param {boolean} [ascending] 
         * @param {number} [nominalLengthStart] 
         * @param {number} [nominalLengthEnd] 
         * @param {number} [ultrasonicLengthEnd] 
         * @param {number} [ultrasonicLengthStart] 
         * @param {BoltDiameter} [boltDiameter] 
         * @param {Material} [material] 
         * @param {BoltType} [boltType] 
         * @param {boolean} [includeArchived] 
         * @param {boolean} [onlyArchived] 
         * @param {string} [includeArchivedAfter] 
         * @param {string} [createdAtStart] 
         * @param {string} [createdAtEnd] 
         * @param {string} [updatedAtStart] 
         * @param {string} [updatedAtEnd] 
         * @param {string} [archivedAtStart] 
         * @param {string} [archivedAtEnd] 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {boolean} [includeMeasurements] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBoltsOfBoltConnectionV2(boltConnectionId: string, tenantId: string, sortBy?: string, ascending?: boolean, nominalLengthStart?: number, nominalLengthEnd?: number, ultrasonicLengthEnd?: number, ultrasonicLengthStart?: number, boltDiameter?: BoltDiameter, material?: Material, boltType?: BoltType, includeArchived?: boolean, onlyArchived?: boolean, includeArchivedAfter?: string, createdAtStart?: string, createdAtEnd?: string, updatedAtStart?: string, updatedAtEnd?: string, archivedAtStart?: string, archivedAtEnd?: string, skip?: number, take?: number, includeMeasurements?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BoltReadDtoPageDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBoltsOfBoltConnectionV2(boltConnectionId, tenantId, sortBy, ascending, nominalLengthStart, nominalLengthEnd, ultrasonicLengthEnd, ultrasonicLengthStart, boltDiameter, material, boltType, includeArchived, onlyArchived, includeArchivedAfter, createdAtStart, createdAtEnd, updatedAtStart, updatedAtEnd, archivedAtStart, archivedAtEnd, skip, take, includeMeasurements, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BoltApi.getBoltsOfBoltConnectionV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: `hardware:read`
         * @param {string} tenantId 
         * @param {string} [sortBy] 
         * @param {boolean} [ascending] 
         * @param {number} [nominalLengthStart] 
         * @param {number} [nominalLengthEnd] 
         * @param {number} [ultrasonicLengthEnd] 
         * @param {number} [ultrasonicLengthStart] 
         * @param {BoltDiameter} [boltDiameter] 
         * @param {Material} [material] 
         * @param {BoltType} [boltType] 
         * @param {boolean} [includeArchived] 
         * @param {boolean} [onlyArchived] 
         * @param {string} [includeArchivedAfter] 
         * @param {string} [createdAtStart] 
         * @param {string} [createdAtEnd] 
         * @param {string} [updatedAtStart] 
         * @param {string} [updatedAtEnd] 
         * @param {string} [archivedAtStart] 
         * @param {string} [archivedAtEnd] 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {boolean} [includeMeasurements] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBoltsOfManufacturerV2(tenantId: string, sortBy?: string, ascending?: boolean, nominalLengthStart?: number, nominalLengthEnd?: number, ultrasonicLengthEnd?: number, ultrasonicLengthStart?: number, boltDiameter?: BoltDiameter, material?: Material, boltType?: BoltType, includeArchived?: boolean, onlyArchived?: boolean, includeArchivedAfter?: string, createdAtStart?: string, createdAtEnd?: string, updatedAtStart?: string, updatedAtEnd?: string, archivedAtStart?: string, archivedAtEnd?: string, skip?: number, take?: number, includeMeasurements?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BoltReadDtoPageDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBoltsOfManufacturerV2(tenantId, sortBy, ascending, nominalLengthStart, nominalLengthEnd, ultrasonicLengthEnd, ultrasonicLengthStart, boltDiameter, material, boltType, includeArchived, onlyArchived, includeArchivedAfter, createdAtStart, createdAtEnd, updatedAtStart, updatedAtEnd, archivedAtStart, archivedAtEnd, skip, take, includeMeasurements, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BoltApi.getBoltsOfManufacturerV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: [`hardware:read` OR `device-app:*`]
         * @param {string} boltConnectionId 
         * @param {string} tenantId 
         * @param {string} [measuredAtStart] 
         * @param {string} [measuredAtEnd] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async getCharacteristicPretensionOfBoltConnectionV2(boltConnectionId: string, tenantId: string, measuredAtStart?: string, measuredAtEnd?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CharacteristicPretensionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCharacteristicPretensionOfBoltConnectionV2(boltConnectionId, tenantId, measuredAtStart, measuredAtEnd, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BoltApi.getCharacteristicPretensionOfBoltConnectionV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [sortBy] 
         * @param {boolean} [ascending] 
         * @param {number} [nominalLengthStart] 
         * @param {number} [nominalLengthEnd] 
         * @param {number} [ultrasonicLengthEnd] 
         * @param {number} [ultrasonicLengthStart] 
         * @param {BoltDiameter} [boltDiameter] 
         * @param {Material} [material] 
         * @param {BoltType} [boltType] 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {boolean} [includeArchived] 
         * @param {boolean} [onlyArchived] 
         * @param {string} [includeArchivedAfter] 
         * @param {string} [createdAtStart] 
         * @param {string} [createdAtEnd] 
         * @param {string} [updatedAtStart] 
         * @param {string} [updatedAtEnd] 
         * @param {string} [archivedAtStart] 
         * @param {string} [archivedAtEnd] 
         * @param {boolean} [includeMeasurements] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUnassignedBoltsGlobalV2(sortBy?: string, ascending?: boolean, nominalLengthStart?: number, nominalLengthEnd?: number, ultrasonicLengthEnd?: number, ultrasonicLengthStart?: number, boltDiameter?: BoltDiameter, material?: Material, boltType?: BoltType, skip?: number, take?: number, includeArchived?: boolean, onlyArchived?: boolean, includeArchivedAfter?: string, createdAtStart?: string, createdAtEnd?: string, updatedAtStart?: string, updatedAtEnd?: string, archivedAtStart?: string, archivedAtEnd?: string, includeMeasurements?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BoltReadDtoPageDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUnassignedBoltsGlobalV2(sortBy, ascending, nominalLengthStart, nominalLengthEnd, ultrasonicLengthEnd, ultrasonicLengthStart, boltDiameter, material, boltType, skip, take, includeArchived, onlyArchived, includeArchivedAfter, createdAtStart, createdAtEnd, updatedAtStart, updatedAtEnd, archivedAtStart, archivedAtEnd, includeMeasurements, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BoltApi.getUnassignedBoltsGlobalV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: [`hardware:read` OR `device-app:*`]
         * @param {string} tenantId 
         * @param {string} [sortBy] 
         * @param {boolean} [ascending] 
         * @param {number} [nominalLengthStart] 
         * @param {number} [nominalLengthEnd] 
         * @param {number} [ultrasonicLengthEnd] 
         * @param {number} [ultrasonicLengthStart] 
         * @param {BoltDiameter} [boltDiameter] 
         * @param {Material} [material] 
         * @param {BoltType} [boltType] 
         * @param {boolean} [includeArchived] 
         * @param {boolean} [onlyArchived] 
         * @param {string} [includeArchivedAfter] 
         * @param {string} [createdAtStart] 
         * @param {string} [createdAtEnd] 
         * @param {string} [updatedAtStart] 
         * @param {string} [updatedAtEnd] 
         * @param {string} [archivedAtStart] 
         * @param {string} [archivedAtEnd] 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {boolean} [includeMeasurements] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUnassignedBoltsV2(tenantId: string, sortBy?: string, ascending?: boolean, nominalLengthStart?: number, nominalLengthEnd?: number, ultrasonicLengthEnd?: number, ultrasonicLengthStart?: number, boltDiameter?: BoltDiameter, material?: Material, boltType?: BoltType, includeArchived?: boolean, onlyArchived?: boolean, includeArchivedAfter?: string, createdAtStart?: string, createdAtEnd?: string, updatedAtStart?: string, updatedAtEnd?: string, archivedAtStart?: string, archivedAtEnd?: string, skip?: number, take?: number, includeMeasurements?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BoltReadDtoPageDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUnassignedBoltsV2(tenantId, sortBy, ascending, nominalLengthStart, nominalLengthEnd, ultrasonicLengthEnd, ultrasonicLengthStart, boltDiameter, material, boltType, includeArchived, onlyArchived, includeArchivedAfter, createdAtStart, createdAtEnd, updatedAtStart, updatedAtEnd, archivedAtStart, archivedAtEnd, skip, take, includeMeasurements, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BoltApi.getUnassignedBoltsV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: `hardware:write` (global scope)
         * @param {string} boltId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async invalidateBoltTagV2(boltId: string, tenantId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BoltReadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.invalidateBoltTagV2(boltId, tenantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BoltApi.invalidateBoltTagV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: `device-app:*`
         * @param {string} boltId 
         * @param {string} tenantId 
         * @param {RecordMeasurementDto} [recordMeasurementDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async recordElongationBoltMeasurementV2(boltId: string, tenantId: string, recordMeasurementDto?: RecordMeasurementDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BoltReadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.recordElongationBoltMeasurementV2(boltId, tenantId, recordMeasurementDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BoltApi.recordElongationBoltMeasurementV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: `hardware:write`
         * @param {string} boltId 
         * @param {string} tenantId 
         * @param {RecordManualMeasurementDto} [recordManualMeasurementDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async recordManualBoltMeasurementV2(boltId: string, tenantId: string, recordManualMeasurementDto?: RecordManualMeasurementDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BoltReadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.recordManualBoltMeasurementV2(boltId, tenantId, recordManualMeasurementDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BoltApi.recordManualBoltMeasurementV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: `device-app:*`
         * @param {string} boltId 
         * @param {string} tenantId 
         * @param {RecordMeasurementDto} [recordMeasurementDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async recordReferenceBoltMeasurementV2(boltId: string, tenantId: string, recordMeasurementDto?: RecordMeasurementDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BoltReadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.recordReferenceBoltMeasurementV2(boltId, tenantId, recordMeasurementDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BoltApi.recordReferenceBoltMeasurementV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: `device-app:*`
         * @param {string} tenantId 
         * @param {BoltRegisterDto} [boltRegisterDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registerBoltV2(tenantId: string, boltRegisterDto?: BoltRegisterDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BoltReadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registerBoltV2(tenantId, boltRegisterDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BoltApi.registerBoltV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: [`hardware:write` OR `device-app:*`]
         * @param {string} boltId 
         * @param {string} tenantId 
         * @param {ReplaceTagDto} [replaceTagDto] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async replaceBoltTagV2(boltId: string, tenantId: string, replaceTagDto?: ReplaceTagDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BoltReadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.replaceBoltTagV2(boltId, tenantId, replaceTagDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BoltApi.replaceBoltTagV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: `hardware:write`
         * @param {string} boltId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restoreBoltV2(boltId: string, tenantId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BoltReadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restoreBoltV2(boltId, tenantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BoltApi.restoreBoltV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: `hardware:write`
         * @param {string} boltId 
         * @param {string} measurementId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restoreMeasurementV2(boltId: string, measurementId: string, tenantId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BoltReadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restoreMeasurementV2(boltId, measurementId, tenantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BoltApi.restoreMeasurementV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: `hardware:write`
         * @param {string} boltId 
         * @param {string} measurementId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setActiveReferenceMeasurementOnBoltV2(boltId: string, measurementId: string, tenantId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BoltReadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setActiveReferenceMeasurementOnBoltV2(boltId, measurementId, tenantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BoltApi.setActiveReferenceMeasurementOnBoltV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: [`hardware:write` OR `device-app:*`]
         * @param {string} boltId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unassignBoltV2(boltId: string, tenantId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BoltReadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unassignBoltV2(boltId, tenantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BoltApi.unassignBoltV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BoltApi - factory interface
 * @export
 */
export const BoltApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BoltApiFp(configuration)
    return {
        /**
         * Required permissions: `hardware:write`
         * @param {BoltApiArchiveBoltV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveBoltV2(requestParameters: BoltApiArchiveBoltV2Request, options?: RawAxiosRequestConfig): AxiosPromise<BoltReadDto> {
            return localVarFp.archiveBoltV2(requestParameters.boltId, requestParameters.tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: `hardware:write`
         * @param {BoltApiArchiveMeasurementV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveMeasurementV2(requestParameters: BoltApiArchiveMeasurementV2Request, options?: RawAxiosRequestConfig): AxiosPromise<BoltReadDto> {
            return localVarFp.archiveMeasurementV2(requestParameters.boltId, requestParameters.measurementId, requestParameters.tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: `device-app:*`
         * @param {BoltApiAssignBoltToBoltConnectionV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignBoltToBoltConnectionV2(requestParameters: BoltApiAssignBoltToBoltConnectionV2Request, options?: RawAxiosRequestConfig): AxiosPromise<BoltReadDto> {
            return localVarFp.assignBoltToBoltConnectionV2(requestParameters.boltId, requestParameters.tenantId, requestParameters.assignDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: `hardware:write`
         * @param {BoltApiChangeMeasurementCommentV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeMeasurementCommentV2(requestParameters: BoltApiChangeMeasurementCommentV2Request, options?: RawAxiosRequestConfig): AxiosPromise<BoltReadDto> {
            return localVarFp.changeMeasurementCommentV2(requestParameters.boltId, requestParameters.measurementId, requestParameters.tenantId, requestParameters.setMeasurementCommentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: `hardware:write`
         * @param {BoltApiChangePhysicalPropertiesOnBoltV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePhysicalPropertiesOnBoltV2(requestParameters: BoltApiChangePhysicalPropertiesOnBoltV2Request, options?: RawAxiosRequestConfig): AxiosPromise<BoltReadDto> {
            return localVarFp.changePhysicalPropertiesOnBoltV2(requestParameters.boltId, requestParameters.tenantId, requestParameters.boltChangePhysicalPropertiesDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: `hardware:write`
         * @param {BoltApiEraseBoltV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eraseBoltV2(requestParameters: BoltApiEraseBoltV2Request, options?: RawAxiosRequestConfig): AxiosPromise<BoltReadDto> {
            return localVarFp.eraseBoltV2(requestParameters.boltId, requestParameters.tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: `hardware:write`
         * @param {BoltApiEraseMeasurementV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eraseMeasurementV2(requestParameters: BoltApiEraseMeasurementV2Request, options?: RawAxiosRequestConfig): AxiosPromise<BoltReadDto> {
            return localVarFp.eraseMeasurementV2(requestParameters.boltId, requestParameters.measurementId, requestParameters.tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: `hardware:read`
         * @param {BoltApiGetAllBoltsV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBoltsV2(requestParameters: BoltApiGetAllBoltsV2Request, options?: RawAxiosRequestConfig): AxiosPromise<BoltReadDtoPageDto> {
            return localVarFp.getAllBoltsV2(requestParameters.tenantId, requestParameters.sortBy, requestParameters.ascending, requestParameters.nominalLengthStart, requestParameters.nominalLengthEnd, requestParameters.ultrasonicLengthEnd, requestParameters.ultrasonicLengthStart, requestParameters.boltDiameter, requestParameters.material, requestParameters.boltType, requestParameters.includeArchived, requestParameters.onlyArchived, requestParameters.includeArchivedAfter, requestParameters.createdAtStart, requestParameters.createdAtEnd, requestParameters.updatedAtStart, requestParameters.updatedAtEnd, requestParameters.archivedAtStart, requestParameters.archivedAtEnd, requestParameters.skip, requestParameters.take, requestParameters.includeMeasurements, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: `hardware:read`
         * @param {BoltApiGetBoltByTagGlobalV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getBoltByTagGlobalV2(requestParameters: BoltApiGetBoltByTagGlobalV2Request, options?: RawAxiosRequestConfig): AxiosPromise<BoltReadDto> {
            return localVarFp.getBoltByTagGlobalV2(requestParameters.tagId, requestParameters.includeArchived, requestParameters.includeMeasurements, requestParameters.generateWaveForm, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: [`hardware:read` OR `device-app:*`]
         * @param {BoltApiGetBoltByTagV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getBoltByTagV2(requestParameters: BoltApiGetBoltByTagV2Request, options?: RawAxiosRequestConfig): AxiosPromise<BoltReadDto> {
            return localVarFp.getBoltByTagV2(requestParameters.tagId, requestParameters.tenantId, requestParameters.includeArchived, requestParameters.includeMeasurements, requestParameters.generateWaveForm, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: [`hardware:read` OR `device-app:*`]
         * @param {BoltApiGetBoltConnectionBoltDetailsV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBoltConnectionBoltDetailsV2(requestParameters: BoltApiGetBoltConnectionBoltDetailsV2Request, options?: RawAxiosRequestConfig): AxiosPromise<BoltConnectionBoltDetailsDto> {
            return localVarFp.getBoltConnectionBoltDetailsV2(requestParameters.boltConnectionId, requestParameters.tenantId, requestParameters.measuredAtStart, requestParameters.measuredAtEnd, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: `hardware:read`
         * @param {BoltApiGetBoltGlobalV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBoltGlobalV2(requestParameters: BoltApiGetBoltGlobalV2Request, options?: RawAxiosRequestConfig): AxiosPromise<BoltReadDto> {
            return localVarFp.getBoltGlobalV2(requestParameters.boltId, requestParameters.includeArchived, requestParameters.includeMeasurements, requestParameters.generateWaveForm, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: [`hardware:read` OR `device-app:*`]
         * @param {BoltApiGetBoltV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBoltV2(requestParameters: BoltApiGetBoltV2Request, options?: RawAxiosRequestConfig): AxiosPromise<BoltReadDto> {
            return localVarFp.getBoltV2(requestParameters.boltId, requestParameters.tenantId, requestParameters.includeArchived, requestParameters.includeMeasurements, requestParameters.generateWaveForm, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: [`hardware:read` OR `device-app:*`]
         * @param {BoltApiGetBoltsByIdsV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBoltsByIdsV2(requestParameters: BoltApiGetBoltsByIdsV2Request, options?: RawAxiosRequestConfig): AxiosPromise<Array<BoltReadDto>> {
            return localVarFp.getBoltsByIdsV2(requestParameters.tenantId, requestParameters.includeArchived, requestParameters.ids, requestParameters.includeMeasurements, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: [`hardware:read` OR `device-app:*`]
         * @param {BoltApiGetBoltsOfBoltConnectionV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBoltsOfBoltConnectionV2(requestParameters: BoltApiGetBoltsOfBoltConnectionV2Request, options?: RawAxiosRequestConfig): AxiosPromise<BoltReadDtoPageDto> {
            return localVarFp.getBoltsOfBoltConnectionV2(requestParameters.boltConnectionId, requestParameters.tenantId, requestParameters.sortBy, requestParameters.ascending, requestParameters.nominalLengthStart, requestParameters.nominalLengthEnd, requestParameters.ultrasonicLengthEnd, requestParameters.ultrasonicLengthStart, requestParameters.boltDiameter, requestParameters.material, requestParameters.boltType, requestParameters.includeArchived, requestParameters.onlyArchived, requestParameters.includeArchivedAfter, requestParameters.createdAtStart, requestParameters.createdAtEnd, requestParameters.updatedAtStart, requestParameters.updatedAtEnd, requestParameters.archivedAtStart, requestParameters.archivedAtEnd, requestParameters.skip, requestParameters.take, requestParameters.includeMeasurements, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: `hardware:read`
         * @param {BoltApiGetBoltsOfManufacturerV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBoltsOfManufacturerV2(requestParameters: BoltApiGetBoltsOfManufacturerV2Request, options?: RawAxiosRequestConfig): AxiosPromise<BoltReadDtoPageDto> {
            return localVarFp.getBoltsOfManufacturerV2(requestParameters.tenantId, requestParameters.sortBy, requestParameters.ascending, requestParameters.nominalLengthStart, requestParameters.nominalLengthEnd, requestParameters.ultrasonicLengthEnd, requestParameters.ultrasonicLengthStart, requestParameters.boltDiameter, requestParameters.material, requestParameters.boltType, requestParameters.includeArchived, requestParameters.onlyArchived, requestParameters.includeArchivedAfter, requestParameters.createdAtStart, requestParameters.createdAtEnd, requestParameters.updatedAtStart, requestParameters.updatedAtEnd, requestParameters.archivedAtStart, requestParameters.archivedAtEnd, requestParameters.skip, requestParameters.take, requestParameters.includeMeasurements, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: [`hardware:read` OR `device-app:*`]
         * @param {BoltApiGetCharacteristicPretensionOfBoltConnectionV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getCharacteristicPretensionOfBoltConnectionV2(requestParameters: BoltApiGetCharacteristicPretensionOfBoltConnectionV2Request, options?: RawAxiosRequestConfig): AxiosPromise<CharacteristicPretensionDto> {
            return localVarFp.getCharacteristicPretensionOfBoltConnectionV2(requestParameters.boltConnectionId, requestParameters.tenantId, requestParameters.measuredAtStart, requestParameters.measuredAtEnd, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BoltApiGetUnassignedBoltsGlobalV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnassignedBoltsGlobalV2(requestParameters: BoltApiGetUnassignedBoltsGlobalV2Request = {}, options?: RawAxiosRequestConfig): AxiosPromise<BoltReadDtoPageDto> {
            return localVarFp.getUnassignedBoltsGlobalV2(requestParameters.sortBy, requestParameters.ascending, requestParameters.nominalLengthStart, requestParameters.nominalLengthEnd, requestParameters.ultrasonicLengthEnd, requestParameters.ultrasonicLengthStart, requestParameters.boltDiameter, requestParameters.material, requestParameters.boltType, requestParameters.skip, requestParameters.take, requestParameters.includeArchived, requestParameters.onlyArchived, requestParameters.includeArchivedAfter, requestParameters.createdAtStart, requestParameters.createdAtEnd, requestParameters.updatedAtStart, requestParameters.updatedAtEnd, requestParameters.archivedAtStart, requestParameters.archivedAtEnd, requestParameters.includeMeasurements, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: [`hardware:read` OR `device-app:*`]
         * @param {BoltApiGetUnassignedBoltsV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnassignedBoltsV2(requestParameters: BoltApiGetUnassignedBoltsV2Request, options?: RawAxiosRequestConfig): AxiosPromise<BoltReadDtoPageDto> {
            return localVarFp.getUnassignedBoltsV2(requestParameters.tenantId, requestParameters.sortBy, requestParameters.ascending, requestParameters.nominalLengthStart, requestParameters.nominalLengthEnd, requestParameters.ultrasonicLengthEnd, requestParameters.ultrasonicLengthStart, requestParameters.boltDiameter, requestParameters.material, requestParameters.boltType, requestParameters.includeArchived, requestParameters.onlyArchived, requestParameters.includeArchivedAfter, requestParameters.createdAtStart, requestParameters.createdAtEnd, requestParameters.updatedAtStart, requestParameters.updatedAtEnd, requestParameters.archivedAtStart, requestParameters.archivedAtEnd, requestParameters.skip, requestParameters.take, requestParameters.includeMeasurements, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: `hardware:write` (global scope)
         * @param {BoltApiInvalidateBoltTagV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        invalidateBoltTagV2(requestParameters: BoltApiInvalidateBoltTagV2Request, options?: RawAxiosRequestConfig): AxiosPromise<BoltReadDto> {
            return localVarFp.invalidateBoltTagV2(requestParameters.boltId, requestParameters.tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: `device-app:*`
         * @param {BoltApiRecordElongationBoltMeasurementV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recordElongationBoltMeasurementV2(requestParameters: BoltApiRecordElongationBoltMeasurementV2Request, options?: RawAxiosRequestConfig): AxiosPromise<BoltReadDto> {
            return localVarFp.recordElongationBoltMeasurementV2(requestParameters.boltId, requestParameters.tenantId, requestParameters.recordMeasurementDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: `hardware:write`
         * @param {BoltApiRecordManualBoltMeasurementV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recordManualBoltMeasurementV2(requestParameters: BoltApiRecordManualBoltMeasurementV2Request, options?: RawAxiosRequestConfig): AxiosPromise<BoltReadDto> {
            return localVarFp.recordManualBoltMeasurementV2(requestParameters.boltId, requestParameters.tenantId, requestParameters.recordManualMeasurementDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: `device-app:*`
         * @param {BoltApiRecordReferenceBoltMeasurementV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recordReferenceBoltMeasurementV2(requestParameters: BoltApiRecordReferenceBoltMeasurementV2Request, options?: RawAxiosRequestConfig): AxiosPromise<BoltReadDto> {
            return localVarFp.recordReferenceBoltMeasurementV2(requestParameters.boltId, requestParameters.tenantId, requestParameters.recordMeasurementDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: `device-app:*`
         * @param {BoltApiRegisterBoltV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerBoltV2(requestParameters: BoltApiRegisterBoltV2Request, options?: RawAxiosRequestConfig): AxiosPromise<BoltReadDto> {
            return localVarFp.registerBoltV2(requestParameters.tenantId, requestParameters.boltRegisterDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: [`hardware:write` OR `device-app:*`]
         * @param {BoltApiReplaceBoltTagV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        replaceBoltTagV2(requestParameters: BoltApiReplaceBoltTagV2Request, options?: RawAxiosRequestConfig): AxiosPromise<BoltReadDto> {
            return localVarFp.replaceBoltTagV2(requestParameters.boltId, requestParameters.tenantId, requestParameters.replaceTagDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: `hardware:write`
         * @param {BoltApiRestoreBoltV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreBoltV2(requestParameters: BoltApiRestoreBoltV2Request, options?: RawAxiosRequestConfig): AxiosPromise<BoltReadDto> {
            return localVarFp.restoreBoltV2(requestParameters.boltId, requestParameters.tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: `hardware:write`
         * @param {BoltApiRestoreMeasurementV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreMeasurementV2(requestParameters: BoltApiRestoreMeasurementV2Request, options?: RawAxiosRequestConfig): AxiosPromise<BoltReadDto> {
            return localVarFp.restoreMeasurementV2(requestParameters.boltId, requestParameters.measurementId, requestParameters.tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: `hardware:write`
         * @param {BoltApiSetActiveReferenceMeasurementOnBoltV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setActiveReferenceMeasurementOnBoltV2(requestParameters: BoltApiSetActiveReferenceMeasurementOnBoltV2Request, options?: RawAxiosRequestConfig): AxiosPromise<BoltReadDto> {
            return localVarFp.setActiveReferenceMeasurementOnBoltV2(requestParameters.boltId, requestParameters.measurementId, requestParameters.tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: [`hardware:write` OR `device-app:*`]
         * @param {BoltApiUnassignBoltV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unassignBoltV2(requestParameters: BoltApiUnassignBoltV2Request, options?: RawAxiosRequestConfig): AxiosPromise<BoltReadDto> {
            return localVarFp.unassignBoltV2(requestParameters.boltId, requestParameters.tenantId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for archiveBoltV2 operation in BoltApi.
 * @export
 * @interface BoltApiArchiveBoltV2Request
 */
export interface BoltApiArchiveBoltV2Request {
    /**
     * 
     * @type {string}
     * @memberof BoltApiArchiveBoltV2
     */
    readonly boltId: string

    /**
     * 
     * @type {string}
     * @memberof BoltApiArchiveBoltV2
     */
    readonly tenantId: string
}

/**
 * Request parameters for archiveMeasurementV2 operation in BoltApi.
 * @export
 * @interface BoltApiArchiveMeasurementV2Request
 */
export interface BoltApiArchiveMeasurementV2Request {
    /**
     * 
     * @type {string}
     * @memberof BoltApiArchiveMeasurementV2
     */
    readonly boltId: string

    /**
     * 
     * @type {string}
     * @memberof BoltApiArchiveMeasurementV2
     */
    readonly measurementId: string

    /**
     * 
     * @type {string}
     * @memberof BoltApiArchiveMeasurementV2
     */
    readonly tenantId: string
}

/**
 * Request parameters for assignBoltToBoltConnectionV2 operation in BoltApi.
 * @export
 * @interface BoltApiAssignBoltToBoltConnectionV2Request
 */
export interface BoltApiAssignBoltToBoltConnectionV2Request {
    /**
     * 
     * @type {string}
     * @memberof BoltApiAssignBoltToBoltConnectionV2
     */
    readonly boltId: string

    /**
     * 
     * @type {string}
     * @memberof BoltApiAssignBoltToBoltConnectionV2
     */
    readonly tenantId: string

    /**
     * 
     * @type {AssignDto}
     * @memberof BoltApiAssignBoltToBoltConnectionV2
     */
    readonly assignDto?: AssignDto
}

/**
 * Request parameters for changeMeasurementCommentV2 operation in BoltApi.
 * @export
 * @interface BoltApiChangeMeasurementCommentV2Request
 */
export interface BoltApiChangeMeasurementCommentV2Request {
    /**
     * 
     * @type {string}
     * @memberof BoltApiChangeMeasurementCommentV2
     */
    readonly boltId: string

    /**
     * 
     * @type {string}
     * @memberof BoltApiChangeMeasurementCommentV2
     */
    readonly measurementId: string

    /**
     * 
     * @type {string}
     * @memberof BoltApiChangeMeasurementCommentV2
     */
    readonly tenantId: string

    /**
     * 
     * @type {SetMeasurementCommentDto}
     * @memberof BoltApiChangeMeasurementCommentV2
     */
    readonly setMeasurementCommentDto?: SetMeasurementCommentDto
}

/**
 * Request parameters for changePhysicalPropertiesOnBoltV2 operation in BoltApi.
 * @export
 * @interface BoltApiChangePhysicalPropertiesOnBoltV2Request
 */
export interface BoltApiChangePhysicalPropertiesOnBoltV2Request {
    /**
     * 
     * @type {string}
     * @memberof BoltApiChangePhysicalPropertiesOnBoltV2
     */
    readonly boltId: string

    /**
     * 
     * @type {string}
     * @memberof BoltApiChangePhysicalPropertiesOnBoltV2
     */
    readonly tenantId: string

    /**
     * 
     * @type {BoltChangePhysicalPropertiesDto}
     * @memberof BoltApiChangePhysicalPropertiesOnBoltV2
     */
    readonly boltChangePhysicalPropertiesDto?: BoltChangePhysicalPropertiesDto
}

/**
 * Request parameters for eraseBoltV2 operation in BoltApi.
 * @export
 * @interface BoltApiEraseBoltV2Request
 */
export interface BoltApiEraseBoltV2Request {
    /**
     * 
     * @type {string}
     * @memberof BoltApiEraseBoltV2
     */
    readonly boltId: string

    /**
     * 
     * @type {string}
     * @memberof BoltApiEraseBoltV2
     */
    readonly tenantId: string
}

/**
 * Request parameters for eraseMeasurementV2 operation in BoltApi.
 * @export
 * @interface BoltApiEraseMeasurementV2Request
 */
export interface BoltApiEraseMeasurementV2Request {
    /**
     * 
     * @type {string}
     * @memberof BoltApiEraseMeasurementV2
     */
    readonly boltId: string

    /**
     * 
     * @type {string}
     * @memberof BoltApiEraseMeasurementV2
     */
    readonly measurementId: string

    /**
     * 
     * @type {string}
     * @memberof BoltApiEraseMeasurementV2
     */
    readonly tenantId: string
}

/**
 * Request parameters for getAllBoltsV2 operation in BoltApi.
 * @export
 * @interface BoltApiGetAllBoltsV2Request
 */
export interface BoltApiGetAllBoltsV2Request {
    /**
     * 
     * @type {string}
     * @memberof BoltApiGetAllBoltsV2
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof BoltApiGetAllBoltsV2
     */
    readonly sortBy?: string

    /**
     * 
     * @type {boolean}
     * @memberof BoltApiGetAllBoltsV2
     */
    readonly ascending?: boolean

    /**
     * 
     * @type {number}
     * @memberof BoltApiGetAllBoltsV2
     */
    readonly nominalLengthStart?: number

    /**
     * 
     * @type {number}
     * @memberof BoltApiGetAllBoltsV2
     */
    readonly nominalLengthEnd?: number

    /**
     * 
     * @type {number}
     * @memberof BoltApiGetAllBoltsV2
     */
    readonly ultrasonicLengthEnd?: number

    /**
     * 
     * @type {number}
     * @memberof BoltApiGetAllBoltsV2
     */
    readonly ultrasonicLengthStart?: number

    /**
     * 
     * @type {BoltDiameter}
     * @memberof BoltApiGetAllBoltsV2
     */
    readonly boltDiameter?: BoltDiameter

    /**
     * 
     * @type {Material}
     * @memberof BoltApiGetAllBoltsV2
     */
    readonly material?: Material

    /**
     * 
     * @type {BoltType}
     * @memberof BoltApiGetAllBoltsV2
     */
    readonly boltType?: BoltType

    /**
     * 
     * @type {boolean}
     * @memberof BoltApiGetAllBoltsV2
     */
    readonly includeArchived?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof BoltApiGetAllBoltsV2
     */
    readonly onlyArchived?: boolean

    /**
     * 
     * @type {string}
     * @memberof BoltApiGetAllBoltsV2
     */
    readonly includeArchivedAfter?: string

    /**
     * 
     * @type {string}
     * @memberof BoltApiGetAllBoltsV2
     */
    readonly createdAtStart?: string

    /**
     * 
     * @type {string}
     * @memberof BoltApiGetAllBoltsV2
     */
    readonly createdAtEnd?: string

    /**
     * 
     * @type {string}
     * @memberof BoltApiGetAllBoltsV2
     */
    readonly updatedAtStart?: string

    /**
     * 
     * @type {string}
     * @memberof BoltApiGetAllBoltsV2
     */
    readonly updatedAtEnd?: string

    /**
     * 
     * @type {string}
     * @memberof BoltApiGetAllBoltsV2
     */
    readonly archivedAtStart?: string

    /**
     * 
     * @type {string}
     * @memberof BoltApiGetAllBoltsV2
     */
    readonly archivedAtEnd?: string

    /**
     * 
     * @type {number}
     * @memberof BoltApiGetAllBoltsV2
     */
    readonly skip?: number

    /**
     * 
     * @type {number}
     * @memberof BoltApiGetAllBoltsV2
     */
    readonly take?: number

    /**
     * 
     * @type {boolean}
     * @memberof BoltApiGetAllBoltsV2
     */
    readonly includeMeasurements?: boolean
}

/**
 * Request parameters for getBoltByTagGlobalV2 operation in BoltApi.
 * @export
 * @interface BoltApiGetBoltByTagGlobalV2Request
 */
export interface BoltApiGetBoltByTagGlobalV2Request {
    /**
     * 
     * @type {string}
     * @memberof BoltApiGetBoltByTagGlobalV2
     */
    readonly tagId: string

    /**
     * 
     * @type {boolean}
     * @memberof BoltApiGetBoltByTagGlobalV2
     */
    readonly includeArchived?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof BoltApiGetBoltByTagGlobalV2
     */
    readonly includeMeasurements?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof BoltApiGetBoltByTagGlobalV2
     */
    readonly generateWaveForm?: boolean
}

/**
 * Request parameters for getBoltByTagV2 operation in BoltApi.
 * @export
 * @interface BoltApiGetBoltByTagV2Request
 */
export interface BoltApiGetBoltByTagV2Request {
    /**
     * 
     * @type {string}
     * @memberof BoltApiGetBoltByTagV2
     */
    readonly tagId: string

    /**
     * 
     * @type {string}
     * @memberof BoltApiGetBoltByTagV2
     */
    readonly tenantId: string

    /**
     * 
     * @type {boolean}
     * @memberof BoltApiGetBoltByTagV2
     */
    readonly includeArchived?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof BoltApiGetBoltByTagV2
     */
    readonly includeMeasurements?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof BoltApiGetBoltByTagV2
     */
    readonly generateWaveForm?: boolean
}

/**
 * Request parameters for getBoltConnectionBoltDetailsV2 operation in BoltApi.
 * @export
 * @interface BoltApiGetBoltConnectionBoltDetailsV2Request
 */
export interface BoltApiGetBoltConnectionBoltDetailsV2Request {
    /**
     * 
     * @type {string}
     * @memberof BoltApiGetBoltConnectionBoltDetailsV2
     */
    readonly boltConnectionId: string

    /**
     * 
     * @type {string}
     * @memberof BoltApiGetBoltConnectionBoltDetailsV2
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof BoltApiGetBoltConnectionBoltDetailsV2
     */
    readonly measuredAtStart?: string

    /**
     * 
     * @type {string}
     * @memberof BoltApiGetBoltConnectionBoltDetailsV2
     */
    readonly measuredAtEnd?: string
}

/**
 * Request parameters for getBoltGlobalV2 operation in BoltApi.
 * @export
 * @interface BoltApiGetBoltGlobalV2Request
 */
export interface BoltApiGetBoltGlobalV2Request {
    /**
     * 
     * @type {string}
     * @memberof BoltApiGetBoltGlobalV2
     */
    readonly boltId: string

    /**
     * 
     * @type {boolean}
     * @memberof BoltApiGetBoltGlobalV2
     */
    readonly includeArchived?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof BoltApiGetBoltGlobalV2
     */
    readonly includeMeasurements?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof BoltApiGetBoltGlobalV2
     */
    readonly generateWaveForm?: boolean
}

/**
 * Request parameters for getBoltV2 operation in BoltApi.
 * @export
 * @interface BoltApiGetBoltV2Request
 */
export interface BoltApiGetBoltV2Request {
    /**
     * 
     * @type {string}
     * @memberof BoltApiGetBoltV2
     */
    readonly boltId: string

    /**
     * 
     * @type {string}
     * @memberof BoltApiGetBoltV2
     */
    readonly tenantId: string

    /**
     * 
     * @type {boolean}
     * @memberof BoltApiGetBoltV2
     */
    readonly includeArchived?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof BoltApiGetBoltV2
     */
    readonly includeMeasurements?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof BoltApiGetBoltV2
     */
    readonly generateWaveForm?: boolean
}

/**
 * Request parameters for getBoltsByIdsV2 operation in BoltApi.
 * @export
 * @interface BoltApiGetBoltsByIdsV2Request
 */
export interface BoltApiGetBoltsByIdsV2Request {
    /**
     * 
     * @type {string}
     * @memberof BoltApiGetBoltsByIdsV2
     */
    readonly tenantId: string

    /**
     * 
     * @type {boolean}
     * @memberof BoltApiGetBoltsByIdsV2
     */
    readonly includeArchived?: boolean

    /**
     * 
     * @type {Array<string>}
     * @memberof BoltApiGetBoltsByIdsV2
     */
    readonly ids?: Array<string>

    /**
     * 
     * @type {boolean}
     * @memberof BoltApiGetBoltsByIdsV2
     */
    readonly includeMeasurements?: boolean
}

/**
 * Request parameters for getBoltsOfBoltConnectionV2 operation in BoltApi.
 * @export
 * @interface BoltApiGetBoltsOfBoltConnectionV2Request
 */
export interface BoltApiGetBoltsOfBoltConnectionV2Request {
    /**
     * 
     * @type {string}
     * @memberof BoltApiGetBoltsOfBoltConnectionV2
     */
    readonly boltConnectionId: string

    /**
     * 
     * @type {string}
     * @memberof BoltApiGetBoltsOfBoltConnectionV2
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof BoltApiGetBoltsOfBoltConnectionV2
     */
    readonly sortBy?: string

    /**
     * 
     * @type {boolean}
     * @memberof BoltApiGetBoltsOfBoltConnectionV2
     */
    readonly ascending?: boolean

    /**
     * 
     * @type {number}
     * @memberof BoltApiGetBoltsOfBoltConnectionV2
     */
    readonly nominalLengthStart?: number

    /**
     * 
     * @type {number}
     * @memberof BoltApiGetBoltsOfBoltConnectionV2
     */
    readonly nominalLengthEnd?: number

    /**
     * 
     * @type {number}
     * @memberof BoltApiGetBoltsOfBoltConnectionV2
     */
    readonly ultrasonicLengthEnd?: number

    /**
     * 
     * @type {number}
     * @memberof BoltApiGetBoltsOfBoltConnectionV2
     */
    readonly ultrasonicLengthStart?: number

    /**
     * 
     * @type {BoltDiameter}
     * @memberof BoltApiGetBoltsOfBoltConnectionV2
     */
    readonly boltDiameter?: BoltDiameter

    /**
     * 
     * @type {Material}
     * @memberof BoltApiGetBoltsOfBoltConnectionV2
     */
    readonly material?: Material

    /**
     * 
     * @type {BoltType}
     * @memberof BoltApiGetBoltsOfBoltConnectionV2
     */
    readonly boltType?: BoltType

    /**
     * 
     * @type {boolean}
     * @memberof BoltApiGetBoltsOfBoltConnectionV2
     */
    readonly includeArchived?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof BoltApiGetBoltsOfBoltConnectionV2
     */
    readonly onlyArchived?: boolean

    /**
     * 
     * @type {string}
     * @memberof BoltApiGetBoltsOfBoltConnectionV2
     */
    readonly includeArchivedAfter?: string

    /**
     * 
     * @type {string}
     * @memberof BoltApiGetBoltsOfBoltConnectionV2
     */
    readonly createdAtStart?: string

    /**
     * 
     * @type {string}
     * @memberof BoltApiGetBoltsOfBoltConnectionV2
     */
    readonly createdAtEnd?: string

    /**
     * 
     * @type {string}
     * @memberof BoltApiGetBoltsOfBoltConnectionV2
     */
    readonly updatedAtStart?: string

    /**
     * 
     * @type {string}
     * @memberof BoltApiGetBoltsOfBoltConnectionV2
     */
    readonly updatedAtEnd?: string

    /**
     * 
     * @type {string}
     * @memberof BoltApiGetBoltsOfBoltConnectionV2
     */
    readonly archivedAtStart?: string

    /**
     * 
     * @type {string}
     * @memberof BoltApiGetBoltsOfBoltConnectionV2
     */
    readonly archivedAtEnd?: string

    /**
     * 
     * @type {number}
     * @memberof BoltApiGetBoltsOfBoltConnectionV2
     */
    readonly skip?: number

    /**
     * 
     * @type {number}
     * @memberof BoltApiGetBoltsOfBoltConnectionV2
     */
    readonly take?: number

    /**
     * 
     * @type {boolean}
     * @memberof BoltApiGetBoltsOfBoltConnectionV2
     */
    readonly includeMeasurements?: boolean
}

/**
 * Request parameters for getBoltsOfManufacturerV2 operation in BoltApi.
 * @export
 * @interface BoltApiGetBoltsOfManufacturerV2Request
 */
export interface BoltApiGetBoltsOfManufacturerV2Request {
    /**
     * 
     * @type {string}
     * @memberof BoltApiGetBoltsOfManufacturerV2
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof BoltApiGetBoltsOfManufacturerV2
     */
    readonly sortBy?: string

    /**
     * 
     * @type {boolean}
     * @memberof BoltApiGetBoltsOfManufacturerV2
     */
    readonly ascending?: boolean

    /**
     * 
     * @type {number}
     * @memberof BoltApiGetBoltsOfManufacturerV2
     */
    readonly nominalLengthStart?: number

    /**
     * 
     * @type {number}
     * @memberof BoltApiGetBoltsOfManufacturerV2
     */
    readonly nominalLengthEnd?: number

    /**
     * 
     * @type {number}
     * @memberof BoltApiGetBoltsOfManufacturerV2
     */
    readonly ultrasonicLengthEnd?: number

    /**
     * 
     * @type {number}
     * @memberof BoltApiGetBoltsOfManufacturerV2
     */
    readonly ultrasonicLengthStart?: number

    /**
     * 
     * @type {BoltDiameter}
     * @memberof BoltApiGetBoltsOfManufacturerV2
     */
    readonly boltDiameter?: BoltDiameter

    /**
     * 
     * @type {Material}
     * @memberof BoltApiGetBoltsOfManufacturerV2
     */
    readonly material?: Material

    /**
     * 
     * @type {BoltType}
     * @memberof BoltApiGetBoltsOfManufacturerV2
     */
    readonly boltType?: BoltType

    /**
     * 
     * @type {boolean}
     * @memberof BoltApiGetBoltsOfManufacturerV2
     */
    readonly includeArchived?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof BoltApiGetBoltsOfManufacturerV2
     */
    readonly onlyArchived?: boolean

    /**
     * 
     * @type {string}
     * @memberof BoltApiGetBoltsOfManufacturerV2
     */
    readonly includeArchivedAfter?: string

    /**
     * 
     * @type {string}
     * @memberof BoltApiGetBoltsOfManufacturerV2
     */
    readonly createdAtStart?: string

    /**
     * 
     * @type {string}
     * @memberof BoltApiGetBoltsOfManufacturerV2
     */
    readonly createdAtEnd?: string

    /**
     * 
     * @type {string}
     * @memberof BoltApiGetBoltsOfManufacturerV2
     */
    readonly updatedAtStart?: string

    /**
     * 
     * @type {string}
     * @memberof BoltApiGetBoltsOfManufacturerV2
     */
    readonly updatedAtEnd?: string

    /**
     * 
     * @type {string}
     * @memberof BoltApiGetBoltsOfManufacturerV2
     */
    readonly archivedAtStart?: string

    /**
     * 
     * @type {string}
     * @memberof BoltApiGetBoltsOfManufacturerV2
     */
    readonly archivedAtEnd?: string

    /**
     * 
     * @type {number}
     * @memberof BoltApiGetBoltsOfManufacturerV2
     */
    readonly skip?: number

    /**
     * 
     * @type {number}
     * @memberof BoltApiGetBoltsOfManufacturerV2
     */
    readonly take?: number

    /**
     * 
     * @type {boolean}
     * @memberof BoltApiGetBoltsOfManufacturerV2
     */
    readonly includeMeasurements?: boolean
}

/**
 * Request parameters for getCharacteristicPretensionOfBoltConnectionV2 operation in BoltApi.
 * @export
 * @interface BoltApiGetCharacteristicPretensionOfBoltConnectionV2Request
 */
export interface BoltApiGetCharacteristicPretensionOfBoltConnectionV2Request {
    /**
     * 
     * @type {string}
     * @memberof BoltApiGetCharacteristicPretensionOfBoltConnectionV2
     */
    readonly boltConnectionId: string

    /**
     * 
     * @type {string}
     * @memberof BoltApiGetCharacteristicPretensionOfBoltConnectionV2
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof BoltApiGetCharacteristicPretensionOfBoltConnectionV2
     */
    readonly measuredAtStart?: string

    /**
     * 
     * @type {string}
     * @memberof BoltApiGetCharacteristicPretensionOfBoltConnectionV2
     */
    readonly measuredAtEnd?: string
}

/**
 * Request parameters for getUnassignedBoltsGlobalV2 operation in BoltApi.
 * @export
 * @interface BoltApiGetUnassignedBoltsGlobalV2Request
 */
export interface BoltApiGetUnassignedBoltsGlobalV2Request {
    /**
     * 
     * @type {string}
     * @memberof BoltApiGetUnassignedBoltsGlobalV2
     */
    readonly sortBy?: string

    /**
     * 
     * @type {boolean}
     * @memberof BoltApiGetUnassignedBoltsGlobalV2
     */
    readonly ascending?: boolean

    /**
     * 
     * @type {number}
     * @memberof BoltApiGetUnassignedBoltsGlobalV2
     */
    readonly nominalLengthStart?: number

    /**
     * 
     * @type {number}
     * @memberof BoltApiGetUnassignedBoltsGlobalV2
     */
    readonly nominalLengthEnd?: number

    /**
     * 
     * @type {number}
     * @memberof BoltApiGetUnassignedBoltsGlobalV2
     */
    readonly ultrasonicLengthEnd?: number

    /**
     * 
     * @type {number}
     * @memberof BoltApiGetUnassignedBoltsGlobalV2
     */
    readonly ultrasonicLengthStart?: number

    /**
     * 
     * @type {BoltDiameter}
     * @memberof BoltApiGetUnassignedBoltsGlobalV2
     */
    readonly boltDiameter?: BoltDiameter

    /**
     * 
     * @type {Material}
     * @memberof BoltApiGetUnassignedBoltsGlobalV2
     */
    readonly material?: Material

    /**
     * 
     * @type {BoltType}
     * @memberof BoltApiGetUnassignedBoltsGlobalV2
     */
    readonly boltType?: BoltType

    /**
     * 
     * @type {number}
     * @memberof BoltApiGetUnassignedBoltsGlobalV2
     */
    readonly skip?: number

    /**
     * 
     * @type {number}
     * @memberof BoltApiGetUnassignedBoltsGlobalV2
     */
    readonly take?: number

    /**
     * 
     * @type {boolean}
     * @memberof BoltApiGetUnassignedBoltsGlobalV2
     */
    readonly includeArchived?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof BoltApiGetUnassignedBoltsGlobalV2
     */
    readonly onlyArchived?: boolean

    /**
     * 
     * @type {string}
     * @memberof BoltApiGetUnassignedBoltsGlobalV2
     */
    readonly includeArchivedAfter?: string

    /**
     * 
     * @type {string}
     * @memberof BoltApiGetUnassignedBoltsGlobalV2
     */
    readonly createdAtStart?: string

    /**
     * 
     * @type {string}
     * @memberof BoltApiGetUnassignedBoltsGlobalV2
     */
    readonly createdAtEnd?: string

    /**
     * 
     * @type {string}
     * @memberof BoltApiGetUnassignedBoltsGlobalV2
     */
    readonly updatedAtStart?: string

    /**
     * 
     * @type {string}
     * @memberof BoltApiGetUnassignedBoltsGlobalV2
     */
    readonly updatedAtEnd?: string

    /**
     * 
     * @type {string}
     * @memberof BoltApiGetUnassignedBoltsGlobalV2
     */
    readonly archivedAtStart?: string

    /**
     * 
     * @type {string}
     * @memberof BoltApiGetUnassignedBoltsGlobalV2
     */
    readonly archivedAtEnd?: string

    /**
     * 
     * @type {boolean}
     * @memberof BoltApiGetUnassignedBoltsGlobalV2
     */
    readonly includeMeasurements?: boolean
}

/**
 * Request parameters for getUnassignedBoltsV2 operation in BoltApi.
 * @export
 * @interface BoltApiGetUnassignedBoltsV2Request
 */
export interface BoltApiGetUnassignedBoltsV2Request {
    /**
     * 
     * @type {string}
     * @memberof BoltApiGetUnassignedBoltsV2
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof BoltApiGetUnassignedBoltsV2
     */
    readonly sortBy?: string

    /**
     * 
     * @type {boolean}
     * @memberof BoltApiGetUnassignedBoltsV2
     */
    readonly ascending?: boolean

    /**
     * 
     * @type {number}
     * @memberof BoltApiGetUnassignedBoltsV2
     */
    readonly nominalLengthStart?: number

    /**
     * 
     * @type {number}
     * @memberof BoltApiGetUnassignedBoltsV2
     */
    readonly nominalLengthEnd?: number

    /**
     * 
     * @type {number}
     * @memberof BoltApiGetUnassignedBoltsV2
     */
    readonly ultrasonicLengthEnd?: number

    /**
     * 
     * @type {number}
     * @memberof BoltApiGetUnassignedBoltsV2
     */
    readonly ultrasonicLengthStart?: number

    /**
     * 
     * @type {BoltDiameter}
     * @memberof BoltApiGetUnassignedBoltsV2
     */
    readonly boltDiameter?: BoltDiameter

    /**
     * 
     * @type {Material}
     * @memberof BoltApiGetUnassignedBoltsV2
     */
    readonly material?: Material

    /**
     * 
     * @type {BoltType}
     * @memberof BoltApiGetUnassignedBoltsV2
     */
    readonly boltType?: BoltType

    /**
     * 
     * @type {boolean}
     * @memberof BoltApiGetUnassignedBoltsV2
     */
    readonly includeArchived?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof BoltApiGetUnassignedBoltsV2
     */
    readonly onlyArchived?: boolean

    /**
     * 
     * @type {string}
     * @memberof BoltApiGetUnassignedBoltsV2
     */
    readonly includeArchivedAfter?: string

    /**
     * 
     * @type {string}
     * @memberof BoltApiGetUnassignedBoltsV2
     */
    readonly createdAtStart?: string

    /**
     * 
     * @type {string}
     * @memberof BoltApiGetUnassignedBoltsV2
     */
    readonly createdAtEnd?: string

    /**
     * 
     * @type {string}
     * @memberof BoltApiGetUnassignedBoltsV2
     */
    readonly updatedAtStart?: string

    /**
     * 
     * @type {string}
     * @memberof BoltApiGetUnassignedBoltsV2
     */
    readonly updatedAtEnd?: string

    /**
     * 
     * @type {string}
     * @memberof BoltApiGetUnassignedBoltsV2
     */
    readonly archivedAtStart?: string

    /**
     * 
     * @type {string}
     * @memberof BoltApiGetUnassignedBoltsV2
     */
    readonly archivedAtEnd?: string

    /**
     * 
     * @type {number}
     * @memberof BoltApiGetUnassignedBoltsV2
     */
    readonly skip?: number

    /**
     * 
     * @type {number}
     * @memberof BoltApiGetUnassignedBoltsV2
     */
    readonly take?: number

    /**
     * 
     * @type {boolean}
     * @memberof BoltApiGetUnassignedBoltsV2
     */
    readonly includeMeasurements?: boolean
}

/**
 * Request parameters for invalidateBoltTagV2 operation in BoltApi.
 * @export
 * @interface BoltApiInvalidateBoltTagV2Request
 */
export interface BoltApiInvalidateBoltTagV2Request {
    /**
     * 
     * @type {string}
     * @memberof BoltApiInvalidateBoltTagV2
     */
    readonly boltId: string

    /**
     * 
     * @type {string}
     * @memberof BoltApiInvalidateBoltTagV2
     */
    readonly tenantId: string
}

/**
 * Request parameters for recordElongationBoltMeasurementV2 operation in BoltApi.
 * @export
 * @interface BoltApiRecordElongationBoltMeasurementV2Request
 */
export interface BoltApiRecordElongationBoltMeasurementV2Request {
    /**
     * 
     * @type {string}
     * @memberof BoltApiRecordElongationBoltMeasurementV2
     */
    readonly boltId: string

    /**
     * 
     * @type {string}
     * @memberof BoltApiRecordElongationBoltMeasurementV2
     */
    readonly tenantId: string

    /**
     * 
     * @type {RecordMeasurementDto}
     * @memberof BoltApiRecordElongationBoltMeasurementV2
     */
    readonly recordMeasurementDto?: RecordMeasurementDto
}

/**
 * Request parameters for recordManualBoltMeasurementV2 operation in BoltApi.
 * @export
 * @interface BoltApiRecordManualBoltMeasurementV2Request
 */
export interface BoltApiRecordManualBoltMeasurementV2Request {
    /**
     * 
     * @type {string}
     * @memberof BoltApiRecordManualBoltMeasurementV2
     */
    readonly boltId: string

    /**
     * 
     * @type {string}
     * @memberof BoltApiRecordManualBoltMeasurementV2
     */
    readonly tenantId: string

    /**
     * 
     * @type {RecordManualMeasurementDto}
     * @memberof BoltApiRecordManualBoltMeasurementV2
     */
    readonly recordManualMeasurementDto?: RecordManualMeasurementDto
}

/**
 * Request parameters for recordReferenceBoltMeasurementV2 operation in BoltApi.
 * @export
 * @interface BoltApiRecordReferenceBoltMeasurementV2Request
 */
export interface BoltApiRecordReferenceBoltMeasurementV2Request {
    /**
     * 
     * @type {string}
     * @memberof BoltApiRecordReferenceBoltMeasurementV2
     */
    readonly boltId: string

    /**
     * 
     * @type {string}
     * @memberof BoltApiRecordReferenceBoltMeasurementV2
     */
    readonly tenantId: string

    /**
     * 
     * @type {RecordMeasurementDto}
     * @memberof BoltApiRecordReferenceBoltMeasurementV2
     */
    readonly recordMeasurementDto?: RecordMeasurementDto
}

/**
 * Request parameters for registerBoltV2 operation in BoltApi.
 * @export
 * @interface BoltApiRegisterBoltV2Request
 */
export interface BoltApiRegisterBoltV2Request {
    /**
     * 
     * @type {string}
     * @memberof BoltApiRegisterBoltV2
     */
    readonly tenantId: string

    /**
     * 
     * @type {BoltRegisterDto}
     * @memberof BoltApiRegisterBoltV2
     */
    readonly boltRegisterDto?: BoltRegisterDto
}

/**
 * Request parameters for replaceBoltTagV2 operation in BoltApi.
 * @export
 * @interface BoltApiReplaceBoltTagV2Request
 */
export interface BoltApiReplaceBoltTagV2Request {
    /**
     * 
     * @type {string}
     * @memberof BoltApiReplaceBoltTagV2
     */
    readonly boltId: string

    /**
     * 
     * @type {string}
     * @memberof BoltApiReplaceBoltTagV2
     */
    readonly tenantId: string

    /**
     * 
     * @type {ReplaceTagDto}
     * @memberof BoltApiReplaceBoltTagV2
     */
    readonly replaceTagDto?: ReplaceTagDto
}

/**
 * Request parameters for restoreBoltV2 operation in BoltApi.
 * @export
 * @interface BoltApiRestoreBoltV2Request
 */
export interface BoltApiRestoreBoltV2Request {
    /**
     * 
     * @type {string}
     * @memberof BoltApiRestoreBoltV2
     */
    readonly boltId: string

    /**
     * 
     * @type {string}
     * @memberof BoltApiRestoreBoltV2
     */
    readonly tenantId: string
}

/**
 * Request parameters for restoreMeasurementV2 operation in BoltApi.
 * @export
 * @interface BoltApiRestoreMeasurementV2Request
 */
export interface BoltApiRestoreMeasurementV2Request {
    /**
     * 
     * @type {string}
     * @memberof BoltApiRestoreMeasurementV2
     */
    readonly boltId: string

    /**
     * 
     * @type {string}
     * @memberof BoltApiRestoreMeasurementV2
     */
    readonly measurementId: string

    /**
     * 
     * @type {string}
     * @memberof BoltApiRestoreMeasurementV2
     */
    readonly tenantId: string
}

/**
 * Request parameters for setActiveReferenceMeasurementOnBoltV2 operation in BoltApi.
 * @export
 * @interface BoltApiSetActiveReferenceMeasurementOnBoltV2Request
 */
export interface BoltApiSetActiveReferenceMeasurementOnBoltV2Request {
    /**
     * 
     * @type {string}
     * @memberof BoltApiSetActiveReferenceMeasurementOnBoltV2
     */
    readonly boltId: string

    /**
     * 
     * @type {string}
     * @memberof BoltApiSetActiveReferenceMeasurementOnBoltV2
     */
    readonly measurementId: string

    /**
     * 
     * @type {string}
     * @memberof BoltApiSetActiveReferenceMeasurementOnBoltV2
     */
    readonly tenantId: string
}

/**
 * Request parameters for unassignBoltV2 operation in BoltApi.
 * @export
 * @interface BoltApiUnassignBoltV2Request
 */
export interface BoltApiUnassignBoltV2Request {
    /**
     * 
     * @type {string}
     * @memberof BoltApiUnassignBoltV2
     */
    readonly boltId: string

    /**
     * 
     * @type {string}
     * @memberof BoltApiUnassignBoltV2
     */
    readonly tenantId: string
}

/**
 * BoltApi - object-oriented interface
 * @export
 * @class BoltApi
 * @extends {BaseAPI}
 */
export class BoltApi extends BaseAPI {
    /**
     * Required permissions: `hardware:write`
     * @param {BoltApiArchiveBoltV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BoltApi
     */
    public archiveBoltV2(requestParameters: BoltApiArchiveBoltV2Request, options?: RawAxiosRequestConfig) {
        return BoltApiFp(this.configuration).archiveBoltV2(requestParameters.boltId, requestParameters.tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: `hardware:write`
     * @param {BoltApiArchiveMeasurementV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BoltApi
     */
    public archiveMeasurementV2(requestParameters: BoltApiArchiveMeasurementV2Request, options?: RawAxiosRequestConfig) {
        return BoltApiFp(this.configuration).archiveMeasurementV2(requestParameters.boltId, requestParameters.measurementId, requestParameters.tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: `device-app:*`
     * @param {BoltApiAssignBoltToBoltConnectionV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BoltApi
     */
    public assignBoltToBoltConnectionV2(requestParameters: BoltApiAssignBoltToBoltConnectionV2Request, options?: RawAxiosRequestConfig) {
        return BoltApiFp(this.configuration).assignBoltToBoltConnectionV2(requestParameters.boltId, requestParameters.tenantId, requestParameters.assignDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: `hardware:write`
     * @param {BoltApiChangeMeasurementCommentV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BoltApi
     */
    public changeMeasurementCommentV2(requestParameters: BoltApiChangeMeasurementCommentV2Request, options?: RawAxiosRequestConfig) {
        return BoltApiFp(this.configuration).changeMeasurementCommentV2(requestParameters.boltId, requestParameters.measurementId, requestParameters.tenantId, requestParameters.setMeasurementCommentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: `hardware:write`
     * @param {BoltApiChangePhysicalPropertiesOnBoltV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BoltApi
     */
    public changePhysicalPropertiesOnBoltV2(requestParameters: BoltApiChangePhysicalPropertiesOnBoltV2Request, options?: RawAxiosRequestConfig) {
        return BoltApiFp(this.configuration).changePhysicalPropertiesOnBoltV2(requestParameters.boltId, requestParameters.tenantId, requestParameters.boltChangePhysicalPropertiesDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: `hardware:write`
     * @param {BoltApiEraseBoltV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BoltApi
     */
    public eraseBoltV2(requestParameters: BoltApiEraseBoltV2Request, options?: RawAxiosRequestConfig) {
        return BoltApiFp(this.configuration).eraseBoltV2(requestParameters.boltId, requestParameters.tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: `hardware:write`
     * @param {BoltApiEraseMeasurementV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BoltApi
     */
    public eraseMeasurementV2(requestParameters: BoltApiEraseMeasurementV2Request, options?: RawAxiosRequestConfig) {
        return BoltApiFp(this.configuration).eraseMeasurementV2(requestParameters.boltId, requestParameters.measurementId, requestParameters.tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: `hardware:read`
     * @param {BoltApiGetAllBoltsV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BoltApi
     */
    public getAllBoltsV2(requestParameters: BoltApiGetAllBoltsV2Request, options?: RawAxiosRequestConfig) {
        return BoltApiFp(this.configuration).getAllBoltsV2(requestParameters.tenantId, requestParameters.sortBy, requestParameters.ascending, requestParameters.nominalLengthStart, requestParameters.nominalLengthEnd, requestParameters.ultrasonicLengthEnd, requestParameters.ultrasonicLengthStart, requestParameters.boltDiameter, requestParameters.material, requestParameters.boltType, requestParameters.includeArchived, requestParameters.onlyArchived, requestParameters.includeArchivedAfter, requestParameters.createdAtStart, requestParameters.createdAtEnd, requestParameters.updatedAtStart, requestParameters.updatedAtEnd, requestParameters.archivedAtStart, requestParameters.archivedAtEnd, requestParameters.skip, requestParameters.take, requestParameters.includeMeasurements, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: `hardware:read`
     * @param {BoltApiGetBoltByTagGlobalV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof BoltApi
     */
    public getBoltByTagGlobalV2(requestParameters: BoltApiGetBoltByTagGlobalV2Request, options?: RawAxiosRequestConfig) {
        return BoltApiFp(this.configuration).getBoltByTagGlobalV2(requestParameters.tagId, requestParameters.includeArchived, requestParameters.includeMeasurements, requestParameters.generateWaveForm, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: [`hardware:read` OR `device-app:*`]
     * @param {BoltApiGetBoltByTagV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof BoltApi
     */
    public getBoltByTagV2(requestParameters: BoltApiGetBoltByTagV2Request, options?: RawAxiosRequestConfig) {
        return BoltApiFp(this.configuration).getBoltByTagV2(requestParameters.tagId, requestParameters.tenantId, requestParameters.includeArchived, requestParameters.includeMeasurements, requestParameters.generateWaveForm, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: [`hardware:read` OR `device-app:*`]
     * @param {BoltApiGetBoltConnectionBoltDetailsV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BoltApi
     */
    public getBoltConnectionBoltDetailsV2(requestParameters: BoltApiGetBoltConnectionBoltDetailsV2Request, options?: RawAxiosRequestConfig) {
        return BoltApiFp(this.configuration).getBoltConnectionBoltDetailsV2(requestParameters.boltConnectionId, requestParameters.tenantId, requestParameters.measuredAtStart, requestParameters.measuredAtEnd, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: `hardware:read`
     * @param {BoltApiGetBoltGlobalV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BoltApi
     */
    public getBoltGlobalV2(requestParameters: BoltApiGetBoltGlobalV2Request, options?: RawAxiosRequestConfig) {
        return BoltApiFp(this.configuration).getBoltGlobalV2(requestParameters.boltId, requestParameters.includeArchived, requestParameters.includeMeasurements, requestParameters.generateWaveForm, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: [`hardware:read` OR `device-app:*`]
     * @param {BoltApiGetBoltV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BoltApi
     */
    public getBoltV2(requestParameters: BoltApiGetBoltV2Request, options?: RawAxiosRequestConfig) {
        return BoltApiFp(this.configuration).getBoltV2(requestParameters.boltId, requestParameters.tenantId, requestParameters.includeArchived, requestParameters.includeMeasurements, requestParameters.generateWaveForm, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: [`hardware:read` OR `device-app:*`]
     * @param {BoltApiGetBoltsByIdsV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BoltApi
     */
    public getBoltsByIdsV2(requestParameters: BoltApiGetBoltsByIdsV2Request, options?: RawAxiosRequestConfig) {
        return BoltApiFp(this.configuration).getBoltsByIdsV2(requestParameters.tenantId, requestParameters.includeArchived, requestParameters.ids, requestParameters.includeMeasurements, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: [`hardware:read` OR `device-app:*`]
     * @param {BoltApiGetBoltsOfBoltConnectionV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BoltApi
     */
    public getBoltsOfBoltConnectionV2(requestParameters: BoltApiGetBoltsOfBoltConnectionV2Request, options?: RawAxiosRequestConfig) {
        return BoltApiFp(this.configuration).getBoltsOfBoltConnectionV2(requestParameters.boltConnectionId, requestParameters.tenantId, requestParameters.sortBy, requestParameters.ascending, requestParameters.nominalLengthStart, requestParameters.nominalLengthEnd, requestParameters.ultrasonicLengthEnd, requestParameters.ultrasonicLengthStart, requestParameters.boltDiameter, requestParameters.material, requestParameters.boltType, requestParameters.includeArchived, requestParameters.onlyArchived, requestParameters.includeArchivedAfter, requestParameters.createdAtStart, requestParameters.createdAtEnd, requestParameters.updatedAtStart, requestParameters.updatedAtEnd, requestParameters.archivedAtStart, requestParameters.archivedAtEnd, requestParameters.skip, requestParameters.take, requestParameters.includeMeasurements, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: `hardware:read`
     * @param {BoltApiGetBoltsOfManufacturerV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BoltApi
     */
    public getBoltsOfManufacturerV2(requestParameters: BoltApiGetBoltsOfManufacturerV2Request, options?: RawAxiosRequestConfig) {
        return BoltApiFp(this.configuration).getBoltsOfManufacturerV2(requestParameters.tenantId, requestParameters.sortBy, requestParameters.ascending, requestParameters.nominalLengthStart, requestParameters.nominalLengthEnd, requestParameters.ultrasonicLengthEnd, requestParameters.ultrasonicLengthStart, requestParameters.boltDiameter, requestParameters.material, requestParameters.boltType, requestParameters.includeArchived, requestParameters.onlyArchived, requestParameters.includeArchivedAfter, requestParameters.createdAtStart, requestParameters.createdAtEnd, requestParameters.updatedAtStart, requestParameters.updatedAtEnd, requestParameters.archivedAtStart, requestParameters.archivedAtEnd, requestParameters.skip, requestParameters.take, requestParameters.includeMeasurements, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: [`hardware:read` OR `device-app:*`]
     * @param {BoltApiGetCharacteristicPretensionOfBoltConnectionV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof BoltApi
     */
    public getCharacteristicPretensionOfBoltConnectionV2(requestParameters: BoltApiGetCharacteristicPretensionOfBoltConnectionV2Request, options?: RawAxiosRequestConfig) {
        return BoltApiFp(this.configuration).getCharacteristicPretensionOfBoltConnectionV2(requestParameters.boltConnectionId, requestParameters.tenantId, requestParameters.measuredAtStart, requestParameters.measuredAtEnd, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BoltApiGetUnassignedBoltsGlobalV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BoltApi
     */
    public getUnassignedBoltsGlobalV2(requestParameters: BoltApiGetUnassignedBoltsGlobalV2Request = {}, options?: RawAxiosRequestConfig) {
        return BoltApiFp(this.configuration).getUnassignedBoltsGlobalV2(requestParameters.sortBy, requestParameters.ascending, requestParameters.nominalLengthStart, requestParameters.nominalLengthEnd, requestParameters.ultrasonicLengthEnd, requestParameters.ultrasonicLengthStart, requestParameters.boltDiameter, requestParameters.material, requestParameters.boltType, requestParameters.skip, requestParameters.take, requestParameters.includeArchived, requestParameters.onlyArchived, requestParameters.includeArchivedAfter, requestParameters.createdAtStart, requestParameters.createdAtEnd, requestParameters.updatedAtStart, requestParameters.updatedAtEnd, requestParameters.archivedAtStart, requestParameters.archivedAtEnd, requestParameters.includeMeasurements, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: [`hardware:read` OR `device-app:*`]
     * @param {BoltApiGetUnassignedBoltsV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BoltApi
     */
    public getUnassignedBoltsV2(requestParameters: BoltApiGetUnassignedBoltsV2Request, options?: RawAxiosRequestConfig) {
        return BoltApiFp(this.configuration).getUnassignedBoltsV2(requestParameters.tenantId, requestParameters.sortBy, requestParameters.ascending, requestParameters.nominalLengthStart, requestParameters.nominalLengthEnd, requestParameters.ultrasonicLengthEnd, requestParameters.ultrasonicLengthStart, requestParameters.boltDiameter, requestParameters.material, requestParameters.boltType, requestParameters.includeArchived, requestParameters.onlyArchived, requestParameters.includeArchivedAfter, requestParameters.createdAtStart, requestParameters.createdAtEnd, requestParameters.updatedAtStart, requestParameters.updatedAtEnd, requestParameters.archivedAtStart, requestParameters.archivedAtEnd, requestParameters.skip, requestParameters.take, requestParameters.includeMeasurements, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: `hardware:write` (global scope)
     * @param {BoltApiInvalidateBoltTagV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof BoltApi
     */
    public invalidateBoltTagV2(requestParameters: BoltApiInvalidateBoltTagV2Request, options?: RawAxiosRequestConfig) {
        return BoltApiFp(this.configuration).invalidateBoltTagV2(requestParameters.boltId, requestParameters.tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: `device-app:*`
     * @param {BoltApiRecordElongationBoltMeasurementV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BoltApi
     */
    public recordElongationBoltMeasurementV2(requestParameters: BoltApiRecordElongationBoltMeasurementV2Request, options?: RawAxiosRequestConfig) {
        return BoltApiFp(this.configuration).recordElongationBoltMeasurementV2(requestParameters.boltId, requestParameters.tenantId, requestParameters.recordMeasurementDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: `hardware:write`
     * @param {BoltApiRecordManualBoltMeasurementV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BoltApi
     */
    public recordManualBoltMeasurementV2(requestParameters: BoltApiRecordManualBoltMeasurementV2Request, options?: RawAxiosRequestConfig) {
        return BoltApiFp(this.configuration).recordManualBoltMeasurementV2(requestParameters.boltId, requestParameters.tenantId, requestParameters.recordManualMeasurementDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: `device-app:*`
     * @param {BoltApiRecordReferenceBoltMeasurementV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BoltApi
     */
    public recordReferenceBoltMeasurementV2(requestParameters: BoltApiRecordReferenceBoltMeasurementV2Request, options?: RawAxiosRequestConfig) {
        return BoltApiFp(this.configuration).recordReferenceBoltMeasurementV2(requestParameters.boltId, requestParameters.tenantId, requestParameters.recordMeasurementDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: `device-app:*`
     * @param {BoltApiRegisterBoltV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BoltApi
     */
    public registerBoltV2(requestParameters: BoltApiRegisterBoltV2Request, options?: RawAxiosRequestConfig) {
        return BoltApiFp(this.configuration).registerBoltV2(requestParameters.tenantId, requestParameters.boltRegisterDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: [`hardware:write` OR `device-app:*`]
     * @param {BoltApiReplaceBoltTagV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof BoltApi
     */
    public replaceBoltTagV2(requestParameters: BoltApiReplaceBoltTagV2Request, options?: RawAxiosRequestConfig) {
        return BoltApiFp(this.configuration).replaceBoltTagV2(requestParameters.boltId, requestParameters.tenantId, requestParameters.replaceTagDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: `hardware:write`
     * @param {BoltApiRestoreBoltV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BoltApi
     */
    public restoreBoltV2(requestParameters: BoltApiRestoreBoltV2Request, options?: RawAxiosRequestConfig) {
        return BoltApiFp(this.configuration).restoreBoltV2(requestParameters.boltId, requestParameters.tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: `hardware:write`
     * @param {BoltApiRestoreMeasurementV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BoltApi
     */
    public restoreMeasurementV2(requestParameters: BoltApiRestoreMeasurementV2Request, options?: RawAxiosRequestConfig) {
        return BoltApiFp(this.configuration).restoreMeasurementV2(requestParameters.boltId, requestParameters.measurementId, requestParameters.tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: `hardware:write`
     * @param {BoltApiSetActiveReferenceMeasurementOnBoltV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BoltApi
     */
    public setActiveReferenceMeasurementOnBoltV2(requestParameters: BoltApiSetActiveReferenceMeasurementOnBoltV2Request, options?: RawAxiosRequestConfig) {
        return BoltApiFp(this.configuration).setActiveReferenceMeasurementOnBoltV2(requestParameters.boltId, requestParameters.measurementId, requestParameters.tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: [`hardware:write` OR `device-app:*`]
     * @param {BoltApiUnassignBoltV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BoltApi
     */
    public unassignBoltV2(requestParameters: BoltApiUnassignBoltV2Request, options?: RawAxiosRequestConfig) {
        return BoltApiFp(this.configuration).unassignBoltV2(requestParameters.boltId, requestParameters.tenantId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CalibrationApi - axios parameter creator
 * @export
 */
export const CalibrationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Required permissions: [`hardware:read` OR `device-app:*`]
         * @param {string} tenantId 
         * @param {Array<string>} [calibrationIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalibrationByIdsV2: async (tenantId: string, calibrationIds?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getCalibrationByIdsV2', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/tagged-hardware/v2/calibration/ids`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (calibrationIds) {
                localVarQueryParameter['calibrationIds'] = calibrationIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: [`hardware:read` OR `device-app:*`]
         * @param {string} calibrationId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalibrationV2: async (calibrationId: string, tenantId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'calibrationId' is not null or undefined
            assertParamExists('getCalibrationV2', 'calibrationId', calibrationId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getCalibrationV2', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/tagged-hardware/v2/calibration/{calibrationId}`
                .replace(`{${"calibrationId"}}`, encodeURIComponent(String(calibrationId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: [`hardware:read` OR `device-app:*`]
         * @param {string} tenantId 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {string} [deviceId] 
         * @param {string} [sensorId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalibrationsV2: async (tenantId: string, skip?: number, take?: number, deviceId?: string, sensorId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getCalibrationsV2', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/tagged-hardware/v2/calibration`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (skip !== undefined) {
                localVarQueryParameter['Skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['Take'] = take;
            }

            if (deviceId !== undefined) {
                localVarQueryParameter['DeviceId'] = deviceId;
            }

            if (sensorId !== undefined) {
                localVarQueryParameter['SensorId'] = sensorId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: [`hardware:read` OR `device-app:*`]
         * @param {string} deviceId 
         * @param {string} sensorId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNewestCalibrationOfDeviceAndSensorV2: async (deviceId: string, sensorId: string, tenantId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceId' is not null or undefined
            assertParamExists('getNewestCalibrationOfDeviceAndSensorV2', 'deviceId', deviceId)
            // verify required parameter 'sensorId' is not null or undefined
            assertParamExists('getNewestCalibrationOfDeviceAndSensorV2', 'sensorId', sensorId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getNewestCalibrationOfDeviceAndSensorV2', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/tagged-hardware/v2/device/{deviceId}/sensor/{sensorId}/calibration/newest`
                .replace(`{${"deviceId"}}`, encodeURIComponent(String(deviceId)))
                .replace(`{${"sensorId"}}`, encodeURIComponent(String(sensorId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: [`hardware:read` OR `device-app:*`]
         * @param {string} deviceId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNewestCalibrationOfDeviceV2: async (deviceId: string, tenantId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceId' is not null or undefined
            assertParamExists('getNewestCalibrationOfDeviceV2', 'deviceId', deviceId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getNewestCalibrationOfDeviceV2', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/tagged-hardware/v2/device/{deviceId}/calibration/newest`
                .replace(`{${"deviceId"}}`, encodeURIComponent(String(deviceId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: `device-app:*`
         * @param {string} tenantId 
         * @param {RecordCalibrationDto} [recordCalibrationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recordCalibrationV2: async (tenantId: string, recordCalibrationDto?: RecordCalibrationDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('recordCalibrationV2', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/tagged-hardware/v2/calibration`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(recordCalibrationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CalibrationApi - functional programming interface
 * @export
 */
export const CalibrationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CalibrationApiAxiosParamCreator(configuration)
    return {
        /**
         * Required permissions: [`hardware:read` OR `device-app:*`]
         * @param {string} tenantId 
         * @param {Array<string>} [calibrationIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCalibrationByIdsV2(tenantId: string, calibrationIds?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CalibrationReadDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCalibrationByIdsV2(tenantId, calibrationIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalibrationApi.getCalibrationByIdsV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: [`hardware:read` OR `device-app:*`]
         * @param {string} calibrationId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCalibrationV2(calibrationId: string, tenantId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalibrationReadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCalibrationV2(calibrationId, tenantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalibrationApi.getCalibrationV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: [`hardware:read` OR `device-app:*`]
         * @param {string} tenantId 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {string} [deviceId] 
         * @param {string} [sensorId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCalibrationsV2(tenantId: string, skip?: number, take?: number, deviceId?: string, sensorId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalibrationWithRelatedHardwareReadDtoPageDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCalibrationsV2(tenantId, skip, take, deviceId, sensorId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalibrationApi.getCalibrationsV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: [`hardware:read` OR `device-app:*`]
         * @param {string} deviceId 
         * @param {string} sensorId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNewestCalibrationOfDeviceAndSensorV2(deviceId: string, sensorId: string, tenantId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalibrationReadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNewestCalibrationOfDeviceAndSensorV2(deviceId, sensorId, tenantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalibrationApi.getNewestCalibrationOfDeviceAndSensorV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: [`hardware:read` OR `device-app:*`]
         * @param {string} deviceId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNewestCalibrationOfDeviceV2(deviceId: string, tenantId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CalibrationReadDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNewestCalibrationOfDeviceV2(deviceId, tenantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalibrationApi.getNewestCalibrationOfDeviceV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: `device-app:*`
         * @param {string} tenantId 
         * @param {RecordCalibrationDto} [recordCalibrationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async recordCalibrationV2(tenantId: string, recordCalibrationDto?: RecordCalibrationDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalibrationReadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.recordCalibrationV2(tenantId, recordCalibrationDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalibrationApi.recordCalibrationV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CalibrationApi - factory interface
 * @export
 */
export const CalibrationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CalibrationApiFp(configuration)
    return {
        /**
         * Required permissions: [`hardware:read` OR `device-app:*`]
         * @param {CalibrationApiGetCalibrationByIdsV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalibrationByIdsV2(requestParameters: CalibrationApiGetCalibrationByIdsV2Request, options?: RawAxiosRequestConfig): AxiosPromise<Array<CalibrationReadDto>> {
            return localVarFp.getCalibrationByIdsV2(requestParameters.tenantId, requestParameters.calibrationIds, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: [`hardware:read` OR `device-app:*`]
         * @param {CalibrationApiGetCalibrationV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalibrationV2(requestParameters: CalibrationApiGetCalibrationV2Request, options?: RawAxiosRequestConfig): AxiosPromise<CalibrationReadDto> {
            return localVarFp.getCalibrationV2(requestParameters.calibrationId, requestParameters.tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: [`hardware:read` OR `device-app:*`]
         * @param {CalibrationApiGetCalibrationsV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalibrationsV2(requestParameters: CalibrationApiGetCalibrationsV2Request, options?: RawAxiosRequestConfig): AxiosPromise<CalibrationWithRelatedHardwareReadDtoPageDto> {
            return localVarFp.getCalibrationsV2(requestParameters.tenantId, requestParameters.skip, requestParameters.take, requestParameters.deviceId, requestParameters.sensorId, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: [`hardware:read` OR `device-app:*`]
         * @param {CalibrationApiGetNewestCalibrationOfDeviceAndSensorV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNewestCalibrationOfDeviceAndSensorV2(requestParameters: CalibrationApiGetNewestCalibrationOfDeviceAndSensorV2Request, options?: RawAxiosRequestConfig): AxiosPromise<CalibrationReadDto> {
            return localVarFp.getNewestCalibrationOfDeviceAndSensorV2(requestParameters.deviceId, requestParameters.sensorId, requestParameters.tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: [`hardware:read` OR `device-app:*`]
         * @param {CalibrationApiGetNewestCalibrationOfDeviceV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNewestCalibrationOfDeviceV2(requestParameters: CalibrationApiGetNewestCalibrationOfDeviceV2Request, options?: RawAxiosRequestConfig): AxiosPromise<Array<CalibrationReadDto>> {
            return localVarFp.getNewestCalibrationOfDeviceV2(requestParameters.deviceId, requestParameters.tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: `device-app:*`
         * @param {CalibrationApiRecordCalibrationV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recordCalibrationV2(requestParameters: CalibrationApiRecordCalibrationV2Request, options?: RawAxiosRequestConfig): AxiosPromise<CalibrationReadDto> {
            return localVarFp.recordCalibrationV2(requestParameters.tenantId, requestParameters.recordCalibrationDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getCalibrationByIdsV2 operation in CalibrationApi.
 * @export
 * @interface CalibrationApiGetCalibrationByIdsV2Request
 */
export interface CalibrationApiGetCalibrationByIdsV2Request {
    /**
     * 
     * @type {string}
     * @memberof CalibrationApiGetCalibrationByIdsV2
     */
    readonly tenantId: string

    /**
     * 
     * @type {Array<string>}
     * @memberof CalibrationApiGetCalibrationByIdsV2
     */
    readonly calibrationIds?: Array<string>
}

/**
 * Request parameters for getCalibrationV2 operation in CalibrationApi.
 * @export
 * @interface CalibrationApiGetCalibrationV2Request
 */
export interface CalibrationApiGetCalibrationV2Request {
    /**
     * 
     * @type {string}
     * @memberof CalibrationApiGetCalibrationV2
     */
    readonly calibrationId: string

    /**
     * 
     * @type {string}
     * @memberof CalibrationApiGetCalibrationV2
     */
    readonly tenantId: string
}

/**
 * Request parameters for getCalibrationsV2 operation in CalibrationApi.
 * @export
 * @interface CalibrationApiGetCalibrationsV2Request
 */
export interface CalibrationApiGetCalibrationsV2Request {
    /**
     * 
     * @type {string}
     * @memberof CalibrationApiGetCalibrationsV2
     */
    readonly tenantId: string

    /**
     * 
     * @type {number}
     * @memberof CalibrationApiGetCalibrationsV2
     */
    readonly skip?: number

    /**
     * 
     * @type {number}
     * @memberof CalibrationApiGetCalibrationsV2
     */
    readonly take?: number

    /**
     * 
     * @type {string}
     * @memberof CalibrationApiGetCalibrationsV2
     */
    readonly deviceId?: string

    /**
     * 
     * @type {string}
     * @memberof CalibrationApiGetCalibrationsV2
     */
    readonly sensorId?: string
}

/**
 * Request parameters for getNewestCalibrationOfDeviceAndSensorV2 operation in CalibrationApi.
 * @export
 * @interface CalibrationApiGetNewestCalibrationOfDeviceAndSensorV2Request
 */
export interface CalibrationApiGetNewestCalibrationOfDeviceAndSensorV2Request {
    /**
     * 
     * @type {string}
     * @memberof CalibrationApiGetNewestCalibrationOfDeviceAndSensorV2
     */
    readonly deviceId: string

    /**
     * 
     * @type {string}
     * @memberof CalibrationApiGetNewestCalibrationOfDeviceAndSensorV2
     */
    readonly sensorId: string

    /**
     * 
     * @type {string}
     * @memberof CalibrationApiGetNewestCalibrationOfDeviceAndSensorV2
     */
    readonly tenantId: string
}

/**
 * Request parameters for getNewestCalibrationOfDeviceV2 operation in CalibrationApi.
 * @export
 * @interface CalibrationApiGetNewestCalibrationOfDeviceV2Request
 */
export interface CalibrationApiGetNewestCalibrationOfDeviceV2Request {
    /**
     * 
     * @type {string}
     * @memberof CalibrationApiGetNewestCalibrationOfDeviceV2
     */
    readonly deviceId: string

    /**
     * 
     * @type {string}
     * @memberof CalibrationApiGetNewestCalibrationOfDeviceV2
     */
    readonly tenantId: string
}

/**
 * Request parameters for recordCalibrationV2 operation in CalibrationApi.
 * @export
 * @interface CalibrationApiRecordCalibrationV2Request
 */
export interface CalibrationApiRecordCalibrationV2Request {
    /**
     * 
     * @type {string}
     * @memberof CalibrationApiRecordCalibrationV2
     */
    readonly tenantId: string

    /**
     * 
     * @type {RecordCalibrationDto}
     * @memberof CalibrationApiRecordCalibrationV2
     */
    readonly recordCalibrationDto?: RecordCalibrationDto
}

/**
 * CalibrationApi - object-oriented interface
 * @export
 * @class CalibrationApi
 * @extends {BaseAPI}
 */
export class CalibrationApi extends BaseAPI {
    /**
     * Required permissions: [`hardware:read` OR `device-app:*`]
     * @param {CalibrationApiGetCalibrationByIdsV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalibrationApi
     */
    public getCalibrationByIdsV2(requestParameters: CalibrationApiGetCalibrationByIdsV2Request, options?: RawAxiosRequestConfig) {
        return CalibrationApiFp(this.configuration).getCalibrationByIdsV2(requestParameters.tenantId, requestParameters.calibrationIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: [`hardware:read` OR `device-app:*`]
     * @param {CalibrationApiGetCalibrationV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalibrationApi
     */
    public getCalibrationV2(requestParameters: CalibrationApiGetCalibrationV2Request, options?: RawAxiosRequestConfig) {
        return CalibrationApiFp(this.configuration).getCalibrationV2(requestParameters.calibrationId, requestParameters.tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: [`hardware:read` OR `device-app:*`]
     * @param {CalibrationApiGetCalibrationsV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalibrationApi
     */
    public getCalibrationsV2(requestParameters: CalibrationApiGetCalibrationsV2Request, options?: RawAxiosRequestConfig) {
        return CalibrationApiFp(this.configuration).getCalibrationsV2(requestParameters.tenantId, requestParameters.skip, requestParameters.take, requestParameters.deviceId, requestParameters.sensorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: [`hardware:read` OR `device-app:*`]
     * @param {CalibrationApiGetNewestCalibrationOfDeviceAndSensorV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalibrationApi
     */
    public getNewestCalibrationOfDeviceAndSensorV2(requestParameters: CalibrationApiGetNewestCalibrationOfDeviceAndSensorV2Request, options?: RawAxiosRequestConfig) {
        return CalibrationApiFp(this.configuration).getNewestCalibrationOfDeviceAndSensorV2(requestParameters.deviceId, requestParameters.sensorId, requestParameters.tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: [`hardware:read` OR `device-app:*`]
     * @param {CalibrationApiGetNewestCalibrationOfDeviceV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalibrationApi
     */
    public getNewestCalibrationOfDeviceV2(requestParameters: CalibrationApiGetNewestCalibrationOfDeviceV2Request, options?: RawAxiosRequestConfig) {
        return CalibrationApiFp(this.configuration).getNewestCalibrationOfDeviceV2(requestParameters.deviceId, requestParameters.tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: `device-app:*`
     * @param {CalibrationApiRecordCalibrationV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalibrationApi
     */
    public recordCalibrationV2(requestParameters: CalibrationApiRecordCalibrationV2Request, options?: RawAxiosRequestConfig) {
        return CalibrationApiFp(this.configuration).recordCalibrationV2(requestParameters.tenantId, requestParameters.recordCalibrationDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CalibrationRodApi - axios parameter creator
 * @export
 */
export const CalibrationRodApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Required permissions: [`hardware:write` OR `device-app:*`] (global scope)
         * @param {string} rodId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveCalibrationRodV2: async (rodId: string, tenantId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rodId' is not null or undefined
            assertParamExists('archiveCalibrationRodV2', 'rodId', rodId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('archiveCalibrationRodV2', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/tagged-hardware/v2/calibration-rod/{rodId}/archive`
                .replace(`{${"rodId"}}`, encodeURIComponent(String(rodId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: [`hardware:write` OR `device-app:*`] (global scope)
         * @param {string} rodId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eraseCalibrationRodV2: async (rodId: string, tenantId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rodId' is not null or undefined
            assertParamExists('eraseCalibrationRodV2', 'rodId', rodId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('eraseCalibrationRodV2', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/tagged-hardware/v2/calibration-rod/{rodId}`
                .replace(`{${"rodId"}}`, encodeURIComponent(String(rodId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: [`hardware:read` OR `device-app:*`]
         * @param {string} tenantId 
         * @param {string} [sortBy] 
         * @param {boolean} [ascending] 
         * @param {boolean} [includeArchived] 
         * @param {boolean} [onlyArchived] 
         * @param {string} [includeArchivedAfter] 
         * @param {string} [createdAtStart] 
         * @param {string} [createdAtEnd] 
         * @param {string} [updatedAtStart] 
         * @param {string} [updatedAtEnd] 
         * @param {string} [archivedAtStart] 
         * @param {string} [archivedAtEnd] 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCalibrationRodsV2: async (tenantId: string, sortBy?: string, ascending?: boolean, includeArchived?: boolean, onlyArchived?: boolean, includeArchivedAfter?: string, createdAtStart?: string, createdAtEnd?: string, updatedAtStart?: string, updatedAtEnd?: string, archivedAtStart?: string, archivedAtEnd?: string, skip?: number, take?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getAllCalibrationRodsV2', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/tagged-hardware/v2/calibration-rod`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (sortBy !== undefined) {
                localVarQueryParameter['SortBy'] = sortBy;
            }

            if (ascending !== undefined) {
                localVarQueryParameter['Ascending'] = ascending;
            }

            if (includeArchived !== undefined) {
                localVarQueryParameter['IncludeArchived'] = includeArchived;
            }

            if (onlyArchived !== undefined) {
                localVarQueryParameter['OnlyArchived'] = onlyArchived;
            }

            if (includeArchivedAfter !== undefined) {
                localVarQueryParameter['IncludeArchivedAfter'] = (includeArchivedAfter as any instanceof Date) ?
                    (includeArchivedAfter as any).toISOString() :
                    includeArchivedAfter;
            }

            if (createdAtStart !== undefined) {
                localVarQueryParameter['CreatedAtStart'] = (createdAtStart as any instanceof Date) ?
                    (createdAtStart as any).toISOString() :
                    createdAtStart;
            }

            if (createdAtEnd !== undefined) {
                localVarQueryParameter['CreatedAtEnd'] = (createdAtEnd as any instanceof Date) ?
                    (createdAtEnd as any).toISOString() :
                    createdAtEnd;
            }

            if (updatedAtStart !== undefined) {
                localVarQueryParameter['UpdatedAtStart'] = (updatedAtStart as any instanceof Date) ?
                    (updatedAtStart as any).toISOString() :
                    updatedAtStart;
            }

            if (updatedAtEnd !== undefined) {
                localVarQueryParameter['UpdatedAtEnd'] = (updatedAtEnd as any instanceof Date) ?
                    (updatedAtEnd as any).toISOString() :
                    updatedAtEnd;
            }

            if (archivedAtStart !== undefined) {
                localVarQueryParameter['ArchivedAtStart'] = (archivedAtStart as any instanceof Date) ?
                    (archivedAtStart as any).toISOString() :
                    archivedAtStart;
            }

            if (archivedAtEnd !== undefined) {
                localVarQueryParameter['ArchivedAtEnd'] = (archivedAtEnd as any instanceof Date) ?
                    (archivedAtEnd as any).toISOString() :
                    archivedAtEnd;
            }

            if (skip !== undefined) {
                localVarQueryParameter['Skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['Take'] = take;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: [`hardware:read` OR `device-app:*`]
         * @param {string} tag 
         * @param {string} tenantId 
         * @param {boolean} [includeArchived] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getCalibrationRodByTagV2: async (tag: string, tenantId: string, includeArchived?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tag' is not null or undefined
            assertParamExists('getCalibrationRodByTagV2', 'tag', tag)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getCalibrationRodByTagV2', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/tagged-hardware/v2/calibration-rod/tag/{tag}`
                .replace(`{${"tag"}}`, encodeURIComponent(String(tag)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (includeArchived !== undefined) {
                localVarQueryParameter['includeArchived'] = includeArchived;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: [`hardware:read` OR `device-app:*`]
         * @param {string} rodId 
         * @param {string} tenantId 
         * @param {boolean} [includeArchived] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalibrationRodV2: async (rodId: string, tenantId: string, includeArchived?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rodId' is not null or undefined
            assertParamExists('getCalibrationRodV2', 'rodId', rodId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getCalibrationRodV2', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/tagged-hardware/v2/calibration-rod/{rodId}`
                .replace(`{${"rodId"}}`, encodeURIComponent(String(rodId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (includeArchived !== undefined) {
                localVarQueryParameter['includeArchived'] = includeArchived;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: [`hardware:read` OR `device-app:*`]
         * @param {string} tenantId 
         * @param {Array<string>} [rodIds] 
         * @param {boolean} [includeArchived] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalibrationRodsByIdsV2: async (tenantId: string, rodIds?: Array<string>, includeArchived?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getCalibrationRodsByIdsV2', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/tagged-hardware/v2/calibration-rod/ids`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (rodIds) {
                localVarQueryParameter['rodIds'] = rodIds;
            }

            if (includeArchived !== undefined) {
                localVarQueryParameter['includeArchived'] = includeArchived;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: [`hardware:write` OR `device-app:*`] (global scope)
         * @param {string} rodId 
         * @param {string} tenantId 
         * @param {RecordMeasurementDto} [recordMeasurementDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recordCalibrationRodReferenceMeasurementV2: async (rodId: string, tenantId: string, recordMeasurementDto?: RecordMeasurementDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rodId' is not null or undefined
            assertParamExists('recordCalibrationRodReferenceMeasurementV2', 'rodId', rodId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('recordCalibrationRodReferenceMeasurementV2', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/tagged-hardware/v2/calibration-rod/{rodId}/reference-measurement`
                .replace(`{${"rodId"}}`, encodeURIComponent(String(rodId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(recordMeasurementDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: [`hardware:write` OR `device-app:*`] (global scope)
         * @param {string} tenantId 
         * @param {RegisterCalibrationRodDto} [registerCalibrationRodDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerCalibrationRodV2: async (tenantId: string, registerCalibrationRodDto?: RegisterCalibrationRodDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('registerCalibrationRodV2', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/tagged-hardware/v2/calibration-rod`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registerCalibrationRodDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: [`hardware:write` OR `device-app:*`] (global scope)
         * @param {string} rodId 
         * @param {string} tenantId 
         * @param {ReplaceTagDto} [replaceTagDto] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        replaceCalibrationRodTagV2: async (rodId: string, tenantId: string, replaceTagDto?: ReplaceTagDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rodId' is not null or undefined
            assertParamExists('replaceCalibrationRodTagV2', 'rodId', rodId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('replaceCalibrationRodTagV2', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/tagged-hardware/v2/calibration-rod/{rodId}/replace-tag`
                .replace(`{${"rodId"}}`, encodeURIComponent(String(rodId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(replaceTagDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: [`hardware:write` OR `device-app:*`] (global scope)
         * @param {string} rodId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreCalibrationRodV2: async (rodId: string, tenantId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rodId' is not null or undefined
            assertParamExists('restoreCalibrationRodV2', 'rodId', rodId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('restoreCalibrationRodV2', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/tagged-hardware/v2/calibration-rod/{rodId}/restore`
                .replace(`{${"rodId"}}`, encodeURIComponent(String(rodId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CalibrationRodApi - functional programming interface
 * @export
 */
export const CalibrationRodApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CalibrationRodApiAxiosParamCreator(configuration)
    return {
        /**
         * Required permissions: [`hardware:write` OR `device-app:*`] (global scope)
         * @param {string} rodId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async archiveCalibrationRodV2(rodId: string, tenantId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalibrationRodReadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.archiveCalibrationRodV2(rodId, tenantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalibrationRodApi.archiveCalibrationRodV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: [`hardware:write` OR `device-app:*`] (global scope)
         * @param {string} rodId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async eraseCalibrationRodV2(rodId: string, tenantId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalibrationRodReadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.eraseCalibrationRodV2(rodId, tenantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalibrationRodApi.eraseCalibrationRodV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: [`hardware:read` OR `device-app:*`]
         * @param {string} tenantId 
         * @param {string} [sortBy] 
         * @param {boolean} [ascending] 
         * @param {boolean} [includeArchived] 
         * @param {boolean} [onlyArchived] 
         * @param {string} [includeArchivedAfter] 
         * @param {string} [createdAtStart] 
         * @param {string} [createdAtEnd] 
         * @param {string} [updatedAtStart] 
         * @param {string} [updatedAtEnd] 
         * @param {string} [archivedAtStart] 
         * @param {string} [archivedAtEnd] 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllCalibrationRodsV2(tenantId: string, sortBy?: string, ascending?: boolean, includeArchived?: boolean, onlyArchived?: boolean, includeArchivedAfter?: string, createdAtStart?: string, createdAtEnd?: string, updatedAtStart?: string, updatedAtEnd?: string, archivedAtStart?: string, archivedAtEnd?: string, skip?: number, take?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalibrationRodReadDtoPageDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllCalibrationRodsV2(tenantId, sortBy, ascending, includeArchived, onlyArchived, includeArchivedAfter, createdAtStart, createdAtEnd, updatedAtStart, updatedAtEnd, archivedAtStart, archivedAtEnd, skip, take, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalibrationRodApi.getAllCalibrationRodsV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: [`hardware:read` OR `device-app:*`]
         * @param {string} tag 
         * @param {string} tenantId 
         * @param {boolean} [includeArchived] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async getCalibrationRodByTagV2(tag: string, tenantId: string, includeArchived?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalibrationRodReadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCalibrationRodByTagV2(tag, tenantId, includeArchived, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalibrationRodApi.getCalibrationRodByTagV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: [`hardware:read` OR `device-app:*`]
         * @param {string} rodId 
         * @param {string} tenantId 
         * @param {boolean} [includeArchived] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCalibrationRodV2(rodId: string, tenantId: string, includeArchived?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalibrationRodReadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCalibrationRodV2(rodId, tenantId, includeArchived, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalibrationRodApi.getCalibrationRodV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: [`hardware:read` OR `device-app:*`]
         * @param {string} tenantId 
         * @param {Array<string>} [rodIds] 
         * @param {boolean} [includeArchived] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCalibrationRodsByIdsV2(tenantId: string, rodIds?: Array<string>, includeArchived?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CalibrationRodReadDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCalibrationRodsByIdsV2(tenantId, rodIds, includeArchived, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalibrationRodApi.getCalibrationRodsByIdsV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: [`hardware:write` OR `device-app:*`] (global scope)
         * @param {string} rodId 
         * @param {string} tenantId 
         * @param {RecordMeasurementDto} [recordMeasurementDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async recordCalibrationRodReferenceMeasurementV2(rodId: string, tenantId: string, recordMeasurementDto?: RecordMeasurementDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalibrationRodReadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.recordCalibrationRodReferenceMeasurementV2(rodId, tenantId, recordMeasurementDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalibrationRodApi.recordCalibrationRodReferenceMeasurementV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: [`hardware:write` OR `device-app:*`] (global scope)
         * @param {string} tenantId 
         * @param {RegisterCalibrationRodDto} [registerCalibrationRodDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registerCalibrationRodV2(tenantId: string, registerCalibrationRodDto?: RegisterCalibrationRodDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalibrationRodReadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registerCalibrationRodV2(tenantId, registerCalibrationRodDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalibrationRodApi.registerCalibrationRodV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: [`hardware:write` OR `device-app:*`] (global scope)
         * @param {string} rodId 
         * @param {string} tenantId 
         * @param {ReplaceTagDto} [replaceTagDto] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async replaceCalibrationRodTagV2(rodId: string, tenantId: string, replaceTagDto?: ReplaceTagDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalibrationRodReadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.replaceCalibrationRodTagV2(rodId, tenantId, replaceTagDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalibrationRodApi.replaceCalibrationRodTagV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: [`hardware:write` OR `device-app:*`] (global scope)
         * @param {string} rodId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restoreCalibrationRodV2(rodId: string, tenantId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalibrationRodReadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restoreCalibrationRodV2(rodId, tenantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalibrationRodApi.restoreCalibrationRodV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CalibrationRodApi - factory interface
 * @export
 */
export const CalibrationRodApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CalibrationRodApiFp(configuration)
    return {
        /**
         * Required permissions: [`hardware:write` OR `device-app:*`] (global scope)
         * @param {CalibrationRodApiArchiveCalibrationRodV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveCalibrationRodV2(requestParameters: CalibrationRodApiArchiveCalibrationRodV2Request, options?: RawAxiosRequestConfig): AxiosPromise<CalibrationRodReadDto> {
            return localVarFp.archiveCalibrationRodV2(requestParameters.rodId, requestParameters.tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: [`hardware:write` OR `device-app:*`] (global scope)
         * @param {CalibrationRodApiEraseCalibrationRodV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eraseCalibrationRodV2(requestParameters: CalibrationRodApiEraseCalibrationRodV2Request, options?: RawAxiosRequestConfig): AxiosPromise<CalibrationRodReadDto> {
            return localVarFp.eraseCalibrationRodV2(requestParameters.rodId, requestParameters.tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: [`hardware:read` OR `device-app:*`]
         * @param {CalibrationRodApiGetAllCalibrationRodsV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCalibrationRodsV2(requestParameters: CalibrationRodApiGetAllCalibrationRodsV2Request, options?: RawAxiosRequestConfig): AxiosPromise<CalibrationRodReadDtoPageDto> {
            return localVarFp.getAllCalibrationRodsV2(requestParameters.tenantId, requestParameters.sortBy, requestParameters.ascending, requestParameters.includeArchived, requestParameters.onlyArchived, requestParameters.includeArchivedAfter, requestParameters.createdAtStart, requestParameters.createdAtEnd, requestParameters.updatedAtStart, requestParameters.updatedAtEnd, requestParameters.archivedAtStart, requestParameters.archivedAtEnd, requestParameters.skip, requestParameters.take, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: [`hardware:read` OR `device-app:*`]
         * @param {CalibrationRodApiGetCalibrationRodByTagV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getCalibrationRodByTagV2(requestParameters: CalibrationRodApiGetCalibrationRodByTagV2Request, options?: RawAxiosRequestConfig): AxiosPromise<CalibrationRodReadDto> {
            return localVarFp.getCalibrationRodByTagV2(requestParameters.tag, requestParameters.tenantId, requestParameters.includeArchived, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: [`hardware:read` OR `device-app:*`]
         * @param {CalibrationRodApiGetCalibrationRodV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalibrationRodV2(requestParameters: CalibrationRodApiGetCalibrationRodV2Request, options?: RawAxiosRequestConfig): AxiosPromise<CalibrationRodReadDto> {
            return localVarFp.getCalibrationRodV2(requestParameters.rodId, requestParameters.tenantId, requestParameters.includeArchived, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: [`hardware:read` OR `device-app:*`]
         * @param {CalibrationRodApiGetCalibrationRodsByIdsV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalibrationRodsByIdsV2(requestParameters: CalibrationRodApiGetCalibrationRodsByIdsV2Request, options?: RawAxiosRequestConfig): AxiosPromise<Array<CalibrationRodReadDto>> {
            return localVarFp.getCalibrationRodsByIdsV2(requestParameters.tenantId, requestParameters.rodIds, requestParameters.includeArchived, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: [`hardware:write` OR `device-app:*`] (global scope)
         * @param {CalibrationRodApiRecordCalibrationRodReferenceMeasurementV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recordCalibrationRodReferenceMeasurementV2(requestParameters: CalibrationRodApiRecordCalibrationRodReferenceMeasurementV2Request, options?: RawAxiosRequestConfig): AxiosPromise<CalibrationRodReadDto> {
            return localVarFp.recordCalibrationRodReferenceMeasurementV2(requestParameters.rodId, requestParameters.tenantId, requestParameters.recordMeasurementDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: [`hardware:write` OR `device-app:*`] (global scope)
         * @param {CalibrationRodApiRegisterCalibrationRodV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerCalibrationRodV2(requestParameters: CalibrationRodApiRegisterCalibrationRodV2Request, options?: RawAxiosRequestConfig): AxiosPromise<CalibrationRodReadDto> {
            return localVarFp.registerCalibrationRodV2(requestParameters.tenantId, requestParameters.registerCalibrationRodDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: [`hardware:write` OR `device-app:*`] (global scope)
         * @param {CalibrationRodApiReplaceCalibrationRodTagV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        replaceCalibrationRodTagV2(requestParameters: CalibrationRodApiReplaceCalibrationRodTagV2Request, options?: RawAxiosRequestConfig): AxiosPromise<CalibrationRodReadDto> {
            return localVarFp.replaceCalibrationRodTagV2(requestParameters.rodId, requestParameters.tenantId, requestParameters.replaceTagDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: [`hardware:write` OR `device-app:*`] (global scope)
         * @param {CalibrationRodApiRestoreCalibrationRodV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreCalibrationRodV2(requestParameters: CalibrationRodApiRestoreCalibrationRodV2Request, options?: RawAxiosRequestConfig): AxiosPromise<CalibrationRodReadDto> {
            return localVarFp.restoreCalibrationRodV2(requestParameters.rodId, requestParameters.tenantId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for archiveCalibrationRodV2 operation in CalibrationRodApi.
 * @export
 * @interface CalibrationRodApiArchiveCalibrationRodV2Request
 */
export interface CalibrationRodApiArchiveCalibrationRodV2Request {
    /**
     * 
     * @type {string}
     * @memberof CalibrationRodApiArchiveCalibrationRodV2
     */
    readonly rodId: string

    /**
     * 
     * @type {string}
     * @memberof CalibrationRodApiArchiveCalibrationRodV2
     */
    readonly tenantId: string
}

/**
 * Request parameters for eraseCalibrationRodV2 operation in CalibrationRodApi.
 * @export
 * @interface CalibrationRodApiEraseCalibrationRodV2Request
 */
export interface CalibrationRodApiEraseCalibrationRodV2Request {
    /**
     * 
     * @type {string}
     * @memberof CalibrationRodApiEraseCalibrationRodV2
     */
    readonly rodId: string

    /**
     * 
     * @type {string}
     * @memberof CalibrationRodApiEraseCalibrationRodV2
     */
    readonly tenantId: string
}

/**
 * Request parameters for getAllCalibrationRodsV2 operation in CalibrationRodApi.
 * @export
 * @interface CalibrationRodApiGetAllCalibrationRodsV2Request
 */
export interface CalibrationRodApiGetAllCalibrationRodsV2Request {
    /**
     * 
     * @type {string}
     * @memberof CalibrationRodApiGetAllCalibrationRodsV2
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof CalibrationRodApiGetAllCalibrationRodsV2
     */
    readonly sortBy?: string

    /**
     * 
     * @type {boolean}
     * @memberof CalibrationRodApiGetAllCalibrationRodsV2
     */
    readonly ascending?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof CalibrationRodApiGetAllCalibrationRodsV2
     */
    readonly includeArchived?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof CalibrationRodApiGetAllCalibrationRodsV2
     */
    readonly onlyArchived?: boolean

    /**
     * 
     * @type {string}
     * @memberof CalibrationRodApiGetAllCalibrationRodsV2
     */
    readonly includeArchivedAfter?: string

    /**
     * 
     * @type {string}
     * @memberof CalibrationRodApiGetAllCalibrationRodsV2
     */
    readonly createdAtStart?: string

    /**
     * 
     * @type {string}
     * @memberof CalibrationRodApiGetAllCalibrationRodsV2
     */
    readonly createdAtEnd?: string

    /**
     * 
     * @type {string}
     * @memberof CalibrationRodApiGetAllCalibrationRodsV2
     */
    readonly updatedAtStart?: string

    /**
     * 
     * @type {string}
     * @memberof CalibrationRodApiGetAllCalibrationRodsV2
     */
    readonly updatedAtEnd?: string

    /**
     * 
     * @type {string}
     * @memberof CalibrationRodApiGetAllCalibrationRodsV2
     */
    readonly archivedAtStart?: string

    /**
     * 
     * @type {string}
     * @memberof CalibrationRodApiGetAllCalibrationRodsV2
     */
    readonly archivedAtEnd?: string

    /**
     * 
     * @type {number}
     * @memberof CalibrationRodApiGetAllCalibrationRodsV2
     */
    readonly skip?: number

    /**
     * 
     * @type {number}
     * @memberof CalibrationRodApiGetAllCalibrationRodsV2
     */
    readonly take?: number
}

/**
 * Request parameters for getCalibrationRodByTagV2 operation in CalibrationRodApi.
 * @export
 * @interface CalibrationRodApiGetCalibrationRodByTagV2Request
 */
export interface CalibrationRodApiGetCalibrationRodByTagV2Request {
    /**
     * 
     * @type {string}
     * @memberof CalibrationRodApiGetCalibrationRodByTagV2
     */
    readonly tag: string

    /**
     * 
     * @type {string}
     * @memberof CalibrationRodApiGetCalibrationRodByTagV2
     */
    readonly tenantId: string

    /**
     * 
     * @type {boolean}
     * @memberof CalibrationRodApiGetCalibrationRodByTagV2
     */
    readonly includeArchived?: boolean
}

/**
 * Request parameters for getCalibrationRodV2 operation in CalibrationRodApi.
 * @export
 * @interface CalibrationRodApiGetCalibrationRodV2Request
 */
export interface CalibrationRodApiGetCalibrationRodV2Request {
    /**
     * 
     * @type {string}
     * @memberof CalibrationRodApiGetCalibrationRodV2
     */
    readonly rodId: string

    /**
     * 
     * @type {string}
     * @memberof CalibrationRodApiGetCalibrationRodV2
     */
    readonly tenantId: string

    /**
     * 
     * @type {boolean}
     * @memberof CalibrationRodApiGetCalibrationRodV2
     */
    readonly includeArchived?: boolean
}

/**
 * Request parameters for getCalibrationRodsByIdsV2 operation in CalibrationRodApi.
 * @export
 * @interface CalibrationRodApiGetCalibrationRodsByIdsV2Request
 */
export interface CalibrationRodApiGetCalibrationRodsByIdsV2Request {
    /**
     * 
     * @type {string}
     * @memberof CalibrationRodApiGetCalibrationRodsByIdsV2
     */
    readonly tenantId: string

    /**
     * 
     * @type {Array<string>}
     * @memberof CalibrationRodApiGetCalibrationRodsByIdsV2
     */
    readonly rodIds?: Array<string>

    /**
     * 
     * @type {boolean}
     * @memberof CalibrationRodApiGetCalibrationRodsByIdsV2
     */
    readonly includeArchived?: boolean
}

/**
 * Request parameters for recordCalibrationRodReferenceMeasurementV2 operation in CalibrationRodApi.
 * @export
 * @interface CalibrationRodApiRecordCalibrationRodReferenceMeasurementV2Request
 */
export interface CalibrationRodApiRecordCalibrationRodReferenceMeasurementV2Request {
    /**
     * 
     * @type {string}
     * @memberof CalibrationRodApiRecordCalibrationRodReferenceMeasurementV2
     */
    readonly rodId: string

    /**
     * 
     * @type {string}
     * @memberof CalibrationRodApiRecordCalibrationRodReferenceMeasurementV2
     */
    readonly tenantId: string

    /**
     * 
     * @type {RecordMeasurementDto}
     * @memberof CalibrationRodApiRecordCalibrationRodReferenceMeasurementV2
     */
    readonly recordMeasurementDto?: RecordMeasurementDto
}

/**
 * Request parameters for registerCalibrationRodV2 operation in CalibrationRodApi.
 * @export
 * @interface CalibrationRodApiRegisterCalibrationRodV2Request
 */
export interface CalibrationRodApiRegisterCalibrationRodV2Request {
    /**
     * 
     * @type {string}
     * @memberof CalibrationRodApiRegisterCalibrationRodV2
     */
    readonly tenantId: string

    /**
     * 
     * @type {RegisterCalibrationRodDto}
     * @memberof CalibrationRodApiRegisterCalibrationRodV2
     */
    readonly registerCalibrationRodDto?: RegisterCalibrationRodDto
}

/**
 * Request parameters for replaceCalibrationRodTagV2 operation in CalibrationRodApi.
 * @export
 * @interface CalibrationRodApiReplaceCalibrationRodTagV2Request
 */
export interface CalibrationRodApiReplaceCalibrationRodTagV2Request {
    /**
     * 
     * @type {string}
     * @memberof CalibrationRodApiReplaceCalibrationRodTagV2
     */
    readonly rodId: string

    /**
     * 
     * @type {string}
     * @memberof CalibrationRodApiReplaceCalibrationRodTagV2
     */
    readonly tenantId: string

    /**
     * 
     * @type {ReplaceTagDto}
     * @memberof CalibrationRodApiReplaceCalibrationRodTagV2
     */
    readonly replaceTagDto?: ReplaceTagDto
}

/**
 * Request parameters for restoreCalibrationRodV2 operation in CalibrationRodApi.
 * @export
 * @interface CalibrationRodApiRestoreCalibrationRodV2Request
 */
export interface CalibrationRodApiRestoreCalibrationRodV2Request {
    /**
     * 
     * @type {string}
     * @memberof CalibrationRodApiRestoreCalibrationRodV2
     */
    readonly rodId: string

    /**
     * 
     * @type {string}
     * @memberof CalibrationRodApiRestoreCalibrationRodV2
     */
    readonly tenantId: string
}

/**
 * CalibrationRodApi - object-oriented interface
 * @export
 * @class CalibrationRodApi
 * @extends {BaseAPI}
 */
export class CalibrationRodApi extends BaseAPI {
    /**
     * Required permissions: [`hardware:write` OR `device-app:*`] (global scope)
     * @param {CalibrationRodApiArchiveCalibrationRodV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalibrationRodApi
     */
    public archiveCalibrationRodV2(requestParameters: CalibrationRodApiArchiveCalibrationRodV2Request, options?: RawAxiosRequestConfig) {
        return CalibrationRodApiFp(this.configuration).archiveCalibrationRodV2(requestParameters.rodId, requestParameters.tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: [`hardware:write` OR `device-app:*`] (global scope)
     * @param {CalibrationRodApiEraseCalibrationRodV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalibrationRodApi
     */
    public eraseCalibrationRodV2(requestParameters: CalibrationRodApiEraseCalibrationRodV2Request, options?: RawAxiosRequestConfig) {
        return CalibrationRodApiFp(this.configuration).eraseCalibrationRodV2(requestParameters.rodId, requestParameters.tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: [`hardware:read` OR `device-app:*`]
     * @param {CalibrationRodApiGetAllCalibrationRodsV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalibrationRodApi
     */
    public getAllCalibrationRodsV2(requestParameters: CalibrationRodApiGetAllCalibrationRodsV2Request, options?: RawAxiosRequestConfig) {
        return CalibrationRodApiFp(this.configuration).getAllCalibrationRodsV2(requestParameters.tenantId, requestParameters.sortBy, requestParameters.ascending, requestParameters.includeArchived, requestParameters.onlyArchived, requestParameters.includeArchivedAfter, requestParameters.createdAtStart, requestParameters.createdAtEnd, requestParameters.updatedAtStart, requestParameters.updatedAtEnd, requestParameters.archivedAtStart, requestParameters.archivedAtEnd, requestParameters.skip, requestParameters.take, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: [`hardware:read` OR `device-app:*`]
     * @param {CalibrationRodApiGetCalibrationRodByTagV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof CalibrationRodApi
     */
    public getCalibrationRodByTagV2(requestParameters: CalibrationRodApiGetCalibrationRodByTagV2Request, options?: RawAxiosRequestConfig) {
        return CalibrationRodApiFp(this.configuration).getCalibrationRodByTagV2(requestParameters.tag, requestParameters.tenantId, requestParameters.includeArchived, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: [`hardware:read` OR `device-app:*`]
     * @param {CalibrationRodApiGetCalibrationRodV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalibrationRodApi
     */
    public getCalibrationRodV2(requestParameters: CalibrationRodApiGetCalibrationRodV2Request, options?: RawAxiosRequestConfig) {
        return CalibrationRodApiFp(this.configuration).getCalibrationRodV2(requestParameters.rodId, requestParameters.tenantId, requestParameters.includeArchived, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: [`hardware:read` OR `device-app:*`]
     * @param {CalibrationRodApiGetCalibrationRodsByIdsV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalibrationRodApi
     */
    public getCalibrationRodsByIdsV2(requestParameters: CalibrationRodApiGetCalibrationRodsByIdsV2Request, options?: RawAxiosRequestConfig) {
        return CalibrationRodApiFp(this.configuration).getCalibrationRodsByIdsV2(requestParameters.tenantId, requestParameters.rodIds, requestParameters.includeArchived, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: [`hardware:write` OR `device-app:*`] (global scope)
     * @param {CalibrationRodApiRecordCalibrationRodReferenceMeasurementV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalibrationRodApi
     */
    public recordCalibrationRodReferenceMeasurementV2(requestParameters: CalibrationRodApiRecordCalibrationRodReferenceMeasurementV2Request, options?: RawAxiosRequestConfig) {
        return CalibrationRodApiFp(this.configuration).recordCalibrationRodReferenceMeasurementV2(requestParameters.rodId, requestParameters.tenantId, requestParameters.recordMeasurementDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: [`hardware:write` OR `device-app:*`] (global scope)
     * @param {CalibrationRodApiRegisterCalibrationRodV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalibrationRodApi
     */
    public registerCalibrationRodV2(requestParameters: CalibrationRodApiRegisterCalibrationRodV2Request, options?: RawAxiosRequestConfig) {
        return CalibrationRodApiFp(this.configuration).registerCalibrationRodV2(requestParameters.tenantId, requestParameters.registerCalibrationRodDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: [`hardware:write` OR `device-app:*`] (global scope)
     * @param {CalibrationRodApiReplaceCalibrationRodTagV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof CalibrationRodApi
     */
    public replaceCalibrationRodTagV2(requestParameters: CalibrationRodApiReplaceCalibrationRodTagV2Request, options?: RawAxiosRequestConfig) {
        return CalibrationRodApiFp(this.configuration).replaceCalibrationRodTagV2(requestParameters.rodId, requestParameters.tenantId, requestParameters.replaceTagDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: [`hardware:write` OR `device-app:*`] (global scope)
     * @param {CalibrationRodApiRestoreCalibrationRodV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalibrationRodApi
     */
    public restoreCalibrationRodV2(requestParameters: CalibrationRodApiRestoreCalibrationRodV2Request, options?: RawAxiosRequestConfig) {
        return CalibrationRodApiFp(this.configuration).restoreCalibrationRodV2(requestParameters.rodId, requestParameters.tenantId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DeviceApi - axios parameter creator
 * @export
 */
export const DeviceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Required permissions: `hardware:write` (global scope)
         * @param {string} deviceId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveDeviceV2: async (deviceId: string, tenantId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceId' is not null or undefined
            assertParamExists('archiveDeviceV2', 'deviceId', deviceId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('archiveDeviceV2', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/tagged-hardware/v2/device/{deviceId}/archive`
                .replace(`{${"deviceId"}}`, encodeURIComponent(String(deviceId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: `device-app:*`
         * @param {string} tenantId 
         * @param {DeviceSelfRegisterDto} [deviceSelfRegisterDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDeviceV2: async (tenantId: string, deviceSelfRegisterDto?: DeviceSelfRegisterDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('createDeviceV2', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/tagged-hardware/v2/device`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deviceSelfRegisterDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: `hardware:write` (global scope)
         * @param {string} deviceId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eraseDeviceV2: async (deviceId: string, tenantId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceId' is not null or undefined
            assertParamExists('eraseDeviceV2', 'deviceId', deviceId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('eraseDeviceV2', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/tagged-hardware/v2/device/{deviceId}`
                .replace(`{${"deviceId"}}`, encodeURIComponent(String(deviceId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: `hardware:read`
         * @param {string} tenantId 
         * @param {string} [sortBy] 
         * @param {boolean} [ascending] 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {boolean} [includeArchived] 
         * @param {boolean} [onlyArchived] 
         * @param {string} [includeArchivedAfter] 
         * @param {string} [createdAtStart] 
         * @param {string} [createdAtEnd] 
         * @param {string} [updatedAtStart] 
         * @param {string} [updatedAtEnd] 
         * @param {string} [archivedAtStart] 
         * @param {string} [archivedAtEnd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllByOrganizationUsageV2: async (tenantId: string, sortBy?: string, ascending?: boolean, skip?: number, take?: number, includeArchived?: boolean, onlyArchived?: boolean, includeArchivedAfter?: string, createdAtStart?: string, createdAtEnd?: string, updatedAtStart?: string, updatedAtEnd?: string, archivedAtStart?: string, archivedAtEnd?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getAllByOrganizationUsageV2', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/tagged-hardware/v2/device`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (sortBy !== undefined) {
                localVarQueryParameter['SortBy'] = sortBy;
            }

            if (ascending !== undefined) {
                localVarQueryParameter['Ascending'] = ascending;
            }

            if (skip !== undefined) {
                localVarQueryParameter['Skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['Take'] = take;
            }

            if (includeArchived !== undefined) {
                localVarQueryParameter['IncludeArchived'] = includeArchived;
            }

            if (onlyArchived !== undefined) {
                localVarQueryParameter['OnlyArchived'] = onlyArchived;
            }

            if (includeArchivedAfter !== undefined) {
                localVarQueryParameter['IncludeArchivedAfter'] = (includeArchivedAfter as any instanceof Date) ?
                    (includeArchivedAfter as any).toISOString() :
                    includeArchivedAfter;
            }

            if (createdAtStart !== undefined) {
                localVarQueryParameter['CreatedAtStart'] = (createdAtStart as any instanceof Date) ?
                    (createdAtStart as any).toISOString() :
                    createdAtStart;
            }

            if (createdAtEnd !== undefined) {
                localVarQueryParameter['CreatedAtEnd'] = (createdAtEnd as any instanceof Date) ?
                    (createdAtEnd as any).toISOString() :
                    createdAtEnd;
            }

            if (updatedAtStart !== undefined) {
                localVarQueryParameter['UpdatedAtStart'] = (updatedAtStart as any instanceof Date) ?
                    (updatedAtStart as any).toISOString() :
                    updatedAtStart;
            }

            if (updatedAtEnd !== undefined) {
                localVarQueryParameter['UpdatedAtEnd'] = (updatedAtEnd as any instanceof Date) ?
                    (updatedAtEnd as any).toISOString() :
                    updatedAtEnd;
            }

            if (archivedAtStart !== undefined) {
                localVarQueryParameter['ArchivedAtStart'] = (archivedAtStart as any instanceof Date) ?
                    (archivedAtStart as any).toISOString() :
                    archivedAtStart;
            }

            if (archivedAtEnd !== undefined) {
                localVarQueryParameter['ArchivedAtEnd'] = (archivedAtEnd as any instanceof Date) ?
                    (archivedAtEnd as any).toISOString() :
                    archivedAtEnd;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: `hardware:read`
         * @param {string} [sortBy] 
         * @param {boolean} [ascending] 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {boolean} [includeArchived] 
         * @param {boolean} [onlyArchived] 
         * @param {string} [includeArchivedAfter] 
         * @param {string} [createdAtStart] 
         * @param {string} [createdAtEnd] 
         * @param {string} [updatedAtStart] 
         * @param {string} [updatedAtEnd] 
         * @param {string} [archivedAtStart] 
         * @param {string} [archivedAtEnd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDevicesV2: async (sortBy?: string, ascending?: boolean, skip?: number, take?: number, includeArchived?: boolean, onlyArchived?: boolean, includeArchivedAfter?: string, createdAtStart?: string, createdAtEnd?: string, updatedAtStart?: string, updatedAtEnd?: string, archivedAtStart?: string, archivedAtEnd?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/tagged-hardware/v2/device`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (sortBy !== undefined) {
                localVarQueryParameter['SortBy'] = sortBy;
            }

            if (ascending !== undefined) {
                localVarQueryParameter['Ascending'] = ascending;
            }

            if (skip !== undefined) {
                localVarQueryParameter['Skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['Take'] = take;
            }

            if (includeArchived !== undefined) {
                localVarQueryParameter['IncludeArchived'] = includeArchived;
            }

            if (onlyArchived !== undefined) {
                localVarQueryParameter['OnlyArchived'] = onlyArchived;
            }

            if (includeArchivedAfter !== undefined) {
                localVarQueryParameter['IncludeArchivedAfter'] = (includeArchivedAfter as any instanceof Date) ?
                    (includeArchivedAfter as any).toISOString() :
                    includeArchivedAfter;
            }

            if (createdAtStart !== undefined) {
                localVarQueryParameter['CreatedAtStart'] = (createdAtStart as any instanceof Date) ?
                    (createdAtStart as any).toISOString() :
                    createdAtStart;
            }

            if (createdAtEnd !== undefined) {
                localVarQueryParameter['CreatedAtEnd'] = (createdAtEnd as any instanceof Date) ?
                    (createdAtEnd as any).toISOString() :
                    createdAtEnd;
            }

            if (updatedAtStart !== undefined) {
                localVarQueryParameter['UpdatedAtStart'] = (updatedAtStart as any instanceof Date) ?
                    (updatedAtStart as any).toISOString() :
                    updatedAtStart;
            }

            if (updatedAtEnd !== undefined) {
                localVarQueryParameter['UpdatedAtEnd'] = (updatedAtEnd as any instanceof Date) ?
                    (updatedAtEnd as any).toISOString() :
                    updatedAtEnd;
            }

            if (archivedAtStart !== undefined) {
                localVarQueryParameter['ArchivedAtStart'] = (archivedAtStart as any instanceof Date) ?
                    (archivedAtStart as any).toISOString() :
                    archivedAtStart;
            }

            if (archivedAtEnd !== undefined) {
                localVarQueryParameter['ArchivedAtEnd'] = (archivedAtEnd as any instanceof Date) ?
                    (archivedAtEnd as any).toISOString() :
                    archivedAtEnd;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: [`hardware:read` OR `device-app:*`]
         * @param {string} machineId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeviceByMachineIdV2: async (machineId: string, tenantId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'machineId' is not null or undefined
            assertParamExists('getDeviceByMachineIdV2', 'machineId', machineId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getDeviceByMachineIdV2', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/tagged-hardware/v2/device/machine/{machineId}`
                .replace(`{${"machineId"}}`, encodeURIComponent(String(machineId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: [`hardware:read` OR `device-app:*`]
         * @param {string} deviceId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeviceV2: async (deviceId: string, tenantId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceId' is not null or undefined
            assertParamExists('getDeviceV2', 'deviceId', deviceId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getDeviceV2', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/tagged-hardware/v2/device/{deviceId}`
                .replace(`{${"deviceId"}}`, encodeURIComponent(String(deviceId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: `hardware:write` (global scope)
         * @param {string} deviceId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreDeviceV2: async (deviceId: string, tenantId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceId' is not null or undefined
            assertParamExists('restoreDeviceV2', 'deviceId', deviceId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('restoreDeviceV2', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/tagged-hardware/v2/device/{deviceId}/restore`
                .replace(`{${"deviceId"}}`, encodeURIComponent(String(deviceId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: `device-app:*`
         * @param {string} deviceId 
         * @param {string} tenantId 
         * @param {DeviceVersionPatchDto} [deviceVersionPatchDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVersionsV2: async (deviceId: string, tenantId: string, deviceVersionPatchDto?: DeviceVersionPatchDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceId' is not null or undefined
            assertParamExists('updateVersionsV2', 'deviceId', deviceId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('updateVersionsV2', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/tagged-hardware/v2/device/{deviceId}/version`
                .replace(`{${"deviceId"}}`, encodeURIComponent(String(deviceId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deviceVersionPatchDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DeviceApi - functional programming interface
 * @export
 */
export const DeviceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DeviceApiAxiosParamCreator(configuration)
    return {
        /**
         * Required permissions: `hardware:write` (global scope)
         * @param {string} deviceId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async archiveDeviceV2(deviceId: string, tenantId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeviceReadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.archiveDeviceV2(deviceId, tenantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeviceApi.archiveDeviceV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: `device-app:*`
         * @param {string} tenantId 
         * @param {DeviceSelfRegisterDto} [deviceSelfRegisterDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDeviceV2(tenantId: string, deviceSelfRegisterDto?: DeviceSelfRegisterDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeviceReadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDeviceV2(tenantId, deviceSelfRegisterDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeviceApi.createDeviceV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: `hardware:write` (global scope)
         * @param {string} deviceId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async eraseDeviceV2(deviceId: string, tenantId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.eraseDeviceV2(deviceId, tenantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeviceApi.eraseDeviceV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: `hardware:read`
         * @param {string} tenantId 
         * @param {string} [sortBy] 
         * @param {boolean} [ascending] 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {boolean} [includeArchived] 
         * @param {boolean} [onlyArchived] 
         * @param {string} [includeArchivedAfter] 
         * @param {string} [createdAtStart] 
         * @param {string} [createdAtEnd] 
         * @param {string} [updatedAtStart] 
         * @param {string} [updatedAtEnd] 
         * @param {string} [archivedAtStart] 
         * @param {string} [archivedAtEnd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllByOrganizationUsageV2(tenantId: string, sortBy?: string, ascending?: boolean, skip?: number, take?: number, includeArchived?: boolean, onlyArchived?: boolean, includeArchivedAfter?: string, createdAtStart?: string, createdAtEnd?: string, updatedAtStart?: string, updatedAtEnd?: string, archivedAtStart?: string, archivedAtEnd?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeviceReadDtoPageDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllByOrganizationUsageV2(tenantId, sortBy, ascending, skip, take, includeArchived, onlyArchived, includeArchivedAfter, createdAtStart, createdAtEnd, updatedAtStart, updatedAtEnd, archivedAtStart, archivedAtEnd, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeviceApi.getAllByOrganizationUsageV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: `hardware:read`
         * @param {string} [sortBy] 
         * @param {boolean} [ascending] 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {boolean} [includeArchived] 
         * @param {boolean} [onlyArchived] 
         * @param {string} [includeArchivedAfter] 
         * @param {string} [createdAtStart] 
         * @param {string} [createdAtEnd] 
         * @param {string} [updatedAtStart] 
         * @param {string} [updatedAtEnd] 
         * @param {string} [archivedAtStart] 
         * @param {string} [archivedAtEnd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllDevicesV2(sortBy?: string, ascending?: boolean, skip?: number, take?: number, includeArchived?: boolean, onlyArchived?: boolean, includeArchivedAfter?: string, createdAtStart?: string, createdAtEnd?: string, updatedAtStart?: string, updatedAtEnd?: string, archivedAtStart?: string, archivedAtEnd?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeviceReadDtoPageDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllDevicesV2(sortBy, ascending, skip, take, includeArchived, onlyArchived, includeArchivedAfter, createdAtStart, createdAtEnd, updatedAtStart, updatedAtEnd, archivedAtStart, archivedAtEnd, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeviceApi.getAllDevicesV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: [`hardware:read` OR `device-app:*`]
         * @param {string} machineId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDeviceByMachineIdV2(machineId: string, tenantId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeviceReadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDeviceByMachineIdV2(machineId, tenantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeviceApi.getDeviceByMachineIdV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: [`hardware:read` OR `device-app:*`]
         * @param {string} deviceId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDeviceV2(deviceId: string, tenantId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeviceReadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDeviceV2(deviceId, tenantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeviceApi.getDeviceV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: `hardware:write` (global scope)
         * @param {string} deviceId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restoreDeviceV2(deviceId: string, tenantId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeviceReadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restoreDeviceV2(deviceId, tenantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeviceApi.restoreDeviceV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: `device-app:*`
         * @param {string} deviceId 
         * @param {string} tenantId 
         * @param {DeviceVersionPatchDto} [deviceVersionPatchDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateVersionsV2(deviceId: string, tenantId: string, deviceVersionPatchDto?: DeviceVersionPatchDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeviceReadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateVersionsV2(deviceId, tenantId, deviceVersionPatchDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeviceApi.updateVersionsV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DeviceApi - factory interface
 * @export
 */
export const DeviceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DeviceApiFp(configuration)
    return {
        /**
         * Required permissions: `hardware:write` (global scope)
         * @param {DeviceApiArchiveDeviceV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveDeviceV2(requestParameters: DeviceApiArchiveDeviceV2Request, options?: RawAxiosRequestConfig): AxiosPromise<DeviceReadDto> {
            return localVarFp.archiveDeviceV2(requestParameters.deviceId, requestParameters.tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: `device-app:*`
         * @param {DeviceApiCreateDeviceV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDeviceV2(requestParameters: DeviceApiCreateDeviceV2Request, options?: RawAxiosRequestConfig): AxiosPromise<DeviceReadDto> {
            return localVarFp.createDeviceV2(requestParameters.tenantId, requestParameters.deviceSelfRegisterDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: `hardware:write` (global scope)
         * @param {DeviceApiEraseDeviceV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eraseDeviceV2(requestParameters: DeviceApiEraseDeviceV2Request, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.eraseDeviceV2(requestParameters.deviceId, requestParameters.tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: `hardware:read`
         * @param {DeviceApiGetAllByOrganizationUsageV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllByOrganizationUsageV2(requestParameters: DeviceApiGetAllByOrganizationUsageV2Request, options?: RawAxiosRequestConfig): AxiosPromise<DeviceReadDtoPageDto> {
            return localVarFp.getAllByOrganizationUsageV2(requestParameters.tenantId, requestParameters.sortBy, requestParameters.ascending, requestParameters.skip, requestParameters.take, requestParameters.includeArchived, requestParameters.onlyArchived, requestParameters.includeArchivedAfter, requestParameters.createdAtStart, requestParameters.createdAtEnd, requestParameters.updatedAtStart, requestParameters.updatedAtEnd, requestParameters.archivedAtStart, requestParameters.archivedAtEnd, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: `hardware:read`
         * @param {DeviceApiGetAllDevicesV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDevicesV2(requestParameters: DeviceApiGetAllDevicesV2Request = {}, options?: RawAxiosRequestConfig): AxiosPromise<DeviceReadDtoPageDto> {
            return localVarFp.getAllDevicesV2(requestParameters.sortBy, requestParameters.ascending, requestParameters.skip, requestParameters.take, requestParameters.includeArchived, requestParameters.onlyArchived, requestParameters.includeArchivedAfter, requestParameters.createdAtStart, requestParameters.createdAtEnd, requestParameters.updatedAtStart, requestParameters.updatedAtEnd, requestParameters.archivedAtStart, requestParameters.archivedAtEnd, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: [`hardware:read` OR `device-app:*`]
         * @param {DeviceApiGetDeviceByMachineIdV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeviceByMachineIdV2(requestParameters: DeviceApiGetDeviceByMachineIdV2Request, options?: RawAxiosRequestConfig): AxiosPromise<DeviceReadDto> {
            return localVarFp.getDeviceByMachineIdV2(requestParameters.machineId, requestParameters.tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: [`hardware:read` OR `device-app:*`]
         * @param {DeviceApiGetDeviceV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeviceV2(requestParameters: DeviceApiGetDeviceV2Request, options?: RawAxiosRequestConfig): AxiosPromise<DeviceReadDto> {
            return localVarFp.getDeviceV2(requestParameters.deviceId, requestParameters.tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: `hardware:write` (global scope)
         * @param {DeviceApiRestoreDeviceV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreDeviceV2(requestParameters: DeviceApiRestoreDeviceV2Request, options?: RawAxiosRequestConfig): AxiosPromise<DeviceReadDto> {
            return localVarFp.restoreDeviceV2(requestParameters.deviceId, requestParameters.tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: `device-app:*`
         * @param {DeviceApiUpdateVersionsV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVersionsV2(requestParameters: DeviceApiUpdateVersionsV2Request, options?: RawAxiosRequestConfig): AxiosPromise<DeviceReadDto> {
            return localVarFp.updateVersionsV2(requestParameters.deviceId, requestParameters.tenantId, requestParameters.deviceVersionPatchDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for archiveDeviceV2 operation in DeviceApi.
 * @export
 * @interface DeviceApiArchiveDeviceV2Request
 */
export interface DeviceApiArchiveDeviceV2Request {
    /**
     * 
     * @type {string}
     * @memberof DeviceApiArchiveDeviceV2
     */
    readonly deviceId: string

    /**
     * 
     * @type {string}
     * @memberof DeviceApiArchiveDeviceV2
     */
    readonly tenantId: string
}

/**
 * Request parameters for createDeviceV2 operation in DeviceApi.
 * @export
 * @interface DeviceApiCreateDeviceV2Request
 */
export interface DeviceApiCreateDeviceV2Request {
    /**
     * 
     * @type {string}
     * @memberof DeviceApiCreateDeviceV2
     */
    readonly tenantId: string

    /**
     * 
     * @type {DeviceSelfRegisterDto}
     * @memberof DeviceApiCreateDeviceV2
     */
    readonly deviceSelfRegisterDto?: DeviceSelfRegisterDto
}

/**
 * Request parameters for eraseDeviceV2 operation in DeviceApi.
 * @export
 * @interface DeviceApiEraseDeviceV2Request
 */
export interface DeviceApiEraseDeviceV2Request {
    /**
     * 
     * @type {string}
     * @memberof DeviceApiEraseDeviceV2
     */
    readonly deviceId: string

    /**
     * 
     * @type {string}
     * @memberof DeviceApiEraseDeviceV2
     */
    readonly tenantId: string
}

/**
 * Request parameters for getAllByOrganizationUsageV2 operation in DeviceApi.
 * @export
 * @interface DeviceApiGetAllByOrganizationUsageV2Request
 */
export interface DeviceApiGetAllByOrganizationUsageV2Request {
    /**
     * 
     * @type {string}
     * @memberof DeviceApiGetAllByOrganizationUsageV2
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof DeviceApiGetAllByOrganizationUsageV2
     */
    readonly sortBy?: string

    /**
     * 
     * @type {boolean}
     * @memberof DeviceApiGetAllByOrganizationUsageV2
     */
    readonly ascending?: boolean

    /**
     * 
     * @type {number}
     * @memberof DeviceApiGetAllByOrganizationUsageV2
     */
    readonly skip?: number

    /**
     * 
     * @type {number}
     * @memberof DeviceApiGetAllByOrganizationUsageV2
     */
    readonly take?: number

    /**
     * 
     * @type {boolean}
     * @memberof DeviceApiGetAllByOrganizationUsageV2
     */
    readonly includeArchived?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof DeviceApiGetAllByOrganizationUsageV2
     */
    readonly onlyArchived?: boolean

    /**
     * 
     * @type {string}
     * @memberof DeviceApiGetAllByOrganizationUsageV2
     */
    readonly includeArchivedAfter?: string

    /**
     * 
     * @type {string}
     * @memberof DeviceApiGetAllByOrganizationUsageV2
     */
    readonly createdAtStart?: string

    /**
     * 
     * @type {string}
     * @memberof DeviceApiGetAllByOrganizationUsageV2
     */
    readonly createdAtEnd?: string

    /**
     * 
     * @type {string}
     * @memberof DeviceApiGetAllByOrganizationUsageV2
     */
    readonly updatedAtStart?: string

    /**
     * 
     * @type {string}
     * @memberof DeviceApiGetAllByOrganizationUsageV2
     */
    readonly updatedAtEnd?: string

    /**
     * 
     * @type {string}
     * @memberof DeviceApiGetAllByOrganizationUsageV2
     */
    readonly archivedAtStart?: string

    /**
     * 
     * @type {string}
     * @memberof DeviceApiGetAllByOrganizationUsageV2
     */
    readonly archivedAtEnd?: string
}

/**
 * Request parameters for getAllDevicesV2 operation in DeviceApi.
 * @export
 * @interface DeviceApiGetAllDevicesV2Request
 */
export interface DeviceApiGetAllDevicesV2Request {
    /**
     * 
     * @type {string}
     * @memberof DeviceApiGetAllDevicesV2
     */
    readonly sortBy?: string

    /**
     * 
     * @type {boolean}
     * @memberof DeviceApiGetAllDevicesV2
     */
    readonly ascending?: boolean

    /**
     * 
     * @type {number}
     * @memberof DeviceApiGetAllDevicesV2
     */
    readonly skip?: number

    /**
     * 
     * @type {number}
     * @memberof DeviceApiGetAllDevicesV2
     */
    readonly take?: number

    /**
     * 
     * @type {boolean}
     * @memberof DeviceApiGetAllDevicesV2
     */
    readonly includeArchived?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof DeviceApiGetAllDevicesV2
     */
    readonly onlyArchived?: boolean

    /**
     * 
     * @type {string}
     * @memberof DeviceApiGetAllDevicesV2
     */
    readonly includeArchivedAfter?: string

    /**
     * 
     * @type {string}
     * @memberof DeviceApiGetAllDevicesV2
     */
    readonly createdAtStart?: string

    /**
     * 
     * @type {string}
     * @memberof DeviceApiGetAllDevicesV2
     */
    readonly createdAtEnd?: string

    /**
     * 
     * @type {string}
     * @memberof DeviceApiGetAllDevicesV2
     */
    readonly updatedAtStart?: string

    /**
     * 
     * @type {string}
     * @memberof DeviceApiGetAllDevicesV2
     */
    readonly updatedAtEnd?: string

    /**
     * 
     * @type {string}
     * @memberof DeviceApiGetAllDevicesV2
     */
    readonly archivedAtStart?: string

    /**
     * 
     * @type {string}
     * @memberof DeviceApiGetAllDevicesV2
     */
    readonly archivedAtEnd?: string
}

/**
 * Request parameters for getDeviceByMachineIdV2 operation in DeviceApi.
 * @export
 * @interface DeviceApiGetDeviceByMachineIdV2Request
 */
export interface DeviceApiGetDeviceByMachineIdV2Request {
    /**
     * 
     * @type {string}
     * @memberof DeviceApiGetDeviceByMachineIdV2
     */
    readonly machineId: string

    /**
     * 
     * @type {string}
     * @memberof DeviceApiGetDeviceByMachineIdV2
     */
    readonly tenantId: string
}

/**
 * Request parameters for getDeviceV2 operation in DeviceApi.
 * @export
 * @interface DeviceApiGetDeviceV2Request
 */
export interface DeviceApiGetDeviceV2Request {
    /**
     * 
     * @type {string}
     * @memberof DeviceApiGetDeviceV2
     */
    readonly deviceId: string

    /**
     * 
     * @type {string}
     * @memberof DeviceApiGetDeviceV2
     */
    readonly tenantId: string
}

/**
 * Request parameters for restoreDeviceV2 operation in DeviceApi.
 * @export
 * @interface DeviceApiRestoreDeviceV2Request
 */
export interface DeviceApiRestoreDeviceV2Request {
    /**
     * 
     * @type {string}
     * @memberof DeviceApiRestoreDeviceV2
     */
    readonly deviceId: string

    /**
     * 
     * @type {string}
     * @memberof DeviceApiRestoreDeviceV2
     */
    readonly tenantId: string
}

/**
 * Request parameters for updateVersionsV2 operation in DeviceApi.
 * @export
 * @interface DeviceApiUpdateVersionsV2Request
 */
export interface DeviceApiUpdateVersionsV2Request {
    /**
     * 
     * @type {string}
     * @memberof DeviceApiUpdateVersionsV2
     */
    readonly deviceId: string

    /**
     * 
     * @type {string}
     * @memberof DeviceApiUpdateVersionsV2
     */
    readonly tenantId: string

    /**
     * 
     * @type {DeviceVersionPatchDto}
     * @memberof DeviceApiUpdateVersionsV2
     */
    readonly deviceVersionPatchDto?: DeviceVersionPatchDto
}

/**
 * DeviceApi - object-oriented interface
 * @export
 * @class DeviceApi
 * @extends {BaseAPI}
 */
export class DeviceApi extends BaseAPI {
    /**
     * Required permissions: `hardware:write` (global scope)
     * @param {DeviceApiArchiveDeviceV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceApi
     */
    public archiveDeviceV2(requestParameters: DeviceApiArchiveDeviceV2Request, options?: RawAxiosRequestConfig) {
        return DeviceApiFp(this.configuration).archiveDeviceV2(requestParameters.deviceId, requestParameters.tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: `device-app:*`
     * @param {DeviceApiCreateDeviceV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceApi
     */
    public createDeviceV2(requestParameters: DeviceApiCreateDeviceV2Request, options?: RawAxiosRequestConfig) {
        return DeviceApiFp(this.configuration).createDeviceV2(requestParameters.tenantId, requestParameters.deviceSelfRegisterDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: `hardware:write` (global scope)
     * @param {DeviceApiEraseDeviceV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceApi
     */
    public eraseDeviceV2(requestParameters: DeviceApiEraseDeviceV2Request, options?: RawAxiosRequestConfig) {
        return DeviceApiFp(this.configuration).eraseDeviceV2(requestParameters.deviceId, requestParameters.tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: `hardware:read`
     * @param {DeviceApiGetAllByOrganizationUsageV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceApi
     */
    public getAllByOrganizationUsageV2(requestParameters: DeviceApiGetAllByOrganizationUsageV2Request, options?: RawAxiosRequestConfig) {
        return DeviceApiFp(this.configuration).getAllByOrganizationUsageV2(requestParameters.tenantId, requestParameters.sortBy, requestParameters.ascending, requestParameters.skip, requestParameters.take, requestParameters.includeArchived, requestParameters.onlyArchived, requestParameters.includeArchivedAfter, requestParameters.createdAtStart, requestParameters.createdAtEnd, requestParameters.updatedAtStart, requestParameters.updatedAtEnd, requestParameters.archivedAtStart, requestParameters.archivedAtEnd, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: `hardware:read`
     * @param {DeviceApiGetAllDevicesV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceApi
     */
    public getAllDevicesV2(requestParameters: DeviceApiGetAllDevicesV2Request = {}, options?: RawAxiosRequestConfig) {
        return DeviceApiFp(this.configuration).getAllDevicesV2(requestParameters.sortBy, requestParameters.ascending, requestParameters.skip, requestParameters.take, requestParameters.includeArchived, requestParameters.onlyArchived, requestParameters.includeArchivedAfter, requestParameters.createdAtStart, requestParameters.createdAtEnd, requestParameters.updatedAtStart, requestParameters.updatedAtEnd, requestParameters.archivedAtStart, requestParameters.archivedAtEnd, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: [`hardware:read` OR `device-app:*`]
     * @param {DeviceApiGetDeviceByMachineIdV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceApi
     */
    public getDeviceByMachineIdV2(requestParameters: DeviceApiGetDeviceByMachineIdV2Request, options?: RawAxiosRequestConfig) {
        return DeviceApiFp(this.configuration).getDeviceByMachineIdV2(requestParameters.machineId, requestParameters.tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: [`hardware:read` OR `device-app:*`]
     * @param {DeviceApiGetDeviceV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceApi
     */
    public getDeviceV2(requestParameters: DeviceApiGetDeviceV2Request, options?: RawAxiosRequestConfig) {
        return DeviceApiFp(this.configuration).getDeviceV2(requestParameters.deviceId, requestParameters.tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: `hardware:write` (global scope)
     * @param {DeviceApiRestoreDeviceV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceApi
     */
    public restoreDeviceV2(requestParameters: DeviceApiRestoreDeviceV2Request, options?: RawAxiosRequestConfig) {
        return DeviceApiFp(this.configuration).restoreDeviceV2(requestParameters.deviceId, requestParameters.tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: `device-app:*`
     * @param {DeviceApiUpdateVersionsV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceApi
     */
    public updateVersionsV2(requestParameters: DeviceApiUpdateVersionsV2Request, options?: RawAxiosRequestConfig) {
        return DeviceApiFp(this.configuration).updateVersionsV2(requestParameters.deviceId, requestParameters.tenantId, requestParameters.deviceVersionPatchDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SensorApi - axios parameter creator
 * @export
 */
export const SensorApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Required permissions: `hardware:write` (global scope)
         * @param {string} sensorId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveSensorV2: async (sensorId: string, tenantId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sensorId' is not null or undefined
            assertParamExists('archiveSensorV2', 'sensorId', sensorId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('archiveSensorV2', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/tagged-hardware/v2/sensor/{sensorId}/archive`
                .replace(`{${"sensorId"}}`, encodeURIComponent(String(sensorId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: `device-app:*` (global scope)
         * @param {string} tenantId 
         * @param {SensorPostDto} [sensorPostDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSensorV2: async (tenantId: string, sensorPostDto?: SensorPostDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('createSensorV2', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/tagged-hardware/v2/sensor`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sensorPostDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: `hardware:write` (global scope)
         * @param {string} sensorId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eraseSensorV2: async (sensorId: string, tenantId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sensorId' is not null or undefined
            assertParamExists('eraseSensorV2', 'sensorId', sensorId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('eraseSensorV2', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/tagged-hardware/v2/sensor/{sensorId}`
                .replace(`{${"sensorId"}}`, encodeURIComponent(String(sensorId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: [`hardware:read` OR `device-app:*`]
         * @param {Array<string>} [sensorIds] 
         * @param {string} [sortBy] 
         * @param {boolean} [ascending] 
         * @param {SensorSize} [size] 
         * @param {SensorFrequency} [frequency] 
         * @param {boolean} [includeArchived] 
         * @param {boolean} [onlyArchived] 
         * @param {string} [includeArchivedAfter] 
         * @param {string} [createdAtStart] 
         * @param {string} [createdAtEnd] 
         * @param {string} [updatedAtStart] 
         * @param {string} [updatedAtEnd] 
         * @param {string} [archivedAtStart] 
         * @param {string} [archivedAtEnd] 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSensorsV2: async (sensorIds?: Array<string>, sortBy?: string, ascending?: boolean, size?: SensorSize, frequency?: SensorFrequency, includeArchived?: boolean, onlyArchived?: boolean, includeArchivedAfter?: string, createdAtStart?: string, createdAtEnd?: string, updatedAtStart?: string, updatedAtEnd?: string, archivedAtStart?: string, archivedAtEnd?: string, skip?: number, take?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/tagged-hardware/v2/sensor`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (sensorIds) {
                localVarQueryParameter['sensorIds'] = sensorIds;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['SortBy'] = sortBy;
            }

            if (ascending !== undefined) {
                localVarQueryParameter['Ascending'] = ascending;
            }

            if (size !== undefined) {
                localVarQueryParameter['Size'] = size;
            }

            if (frequency !== undefined) {
                localVarQueryParameter['Frequency'] = frequency;
            }

            if (includeArchived !== undefined) {
                localVarQueryParameter['IncludeArchived'] = includeArchived;
            }

            if (onlyArchived !== undefined) {
                localVarQueryParameter['OnlyArchived'] = onlyArchived;
            }

            if (includeArchivedAfter !== undefined) {
                localVarQueryParameter['IncludeArchivedAfter'] = (includeArchivedAfter as any instanceof Date) ?
                    (includeArchivedAfter as any).toISOString() :
                    includeArchivedAfter;
            }

            if (createdAtStart !== undefined) {
                localVarQueryParameter['CreatedAtStart'] = (createdAtStart as any instanceof Date) ?
                    (createdAtStart as any).toISOString() :
                    createdAtStart;
            }

            if (createdAtEnd !== undefined) {
                localVarQueryParameter['CreatedAtEnd'] = (createdAtEnd as any instanceof Date) ?
                    (createdAtEnd as any).toISOString() :
                    createdAtEnd;
            }

            if (updatedAtStart !== undefined) {
                localVarQueryParameter['UpdatedAtStart'] = (updatedAtStart as any instanceof Date) ?
                    (updatedAtStart as any).toISOString() :
                    updatedAtStart;
            }

            if (updatedAtEnd !== undefined) {
                localVarQueryParameter['UpdatedAtEnd'] = (updatedAtEnd as any instanceof Date) ?
                    (updatedAtEnd as any).toISOString() :
                    updatedAtEnd;
            }

            if (archivedAtStart !== undefined) {
                localVarQueryParameter['ArchivedAtStart'] = (archivedAtStart as any instanceof Date) ?
                    (archivedAtStart as any).toISOString() :
                    archivedAtStart;
            }

            if (archivedAtEnd !== undefined) {
                localVarQueryParameter['ArchivedAtEnd'] = (archivedAtEnd as any instanceof Date) ?
                    (archivedAtEnd as any).toISOString() :
                    archivedAtEnd;
            }

            if (skip !== undefined) {
                localVarQueryParameter['Skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['Take'] = take;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: [`hardware:read` OR `device-app:*`]
         * @param {string} tagId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getSensorByTagV2: async (tagId: string, tenantId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tagId' is not null or undefined
            assertParamExists('getSensorByTagV2', 'tagId', tagId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getSensorByTagV2', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/tagged-hardware/v2/sensor/tag/{tagId}`
                .replace(`{${"tagId"}}`, encodeURIComponent(String(tagId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSensorSettingsV2: async (tenantId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getSensorSettingsV2', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/tagged-hardware/v2/sensor/settings`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: [`hardware:read` OR `device-app:*`]
         * @param {string} sensorId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSensorV2: async (sensorId: string, tenantId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sensorId' is not null or undefined
            assertParamExists('getSensorV2', 'sensorId', sensorId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getSensorV2', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/tagged-hardware/v2/sensor/{sensorId}`
                .replace(`{${"sensorId"}}`, encodeURIComponent(String(sensorId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: [`hardware:read` OR `device-app:*`]
         * @param {string} deviceId 
         * @param {string} tenantId 
         * @param {string} [sortBy] 
         * @param {boolean} [ascending] 
         * @param {SensorSize} [size] 
         * @param {SensorFrequency} [frequency] 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSensorsOfDeviceV2: async (deviceId: string, tenantId: string, sortBy?: string, ascending?: boolean, size?: SensorSize, frequency?: SensorFrequency, skip?: number, take?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceId' is not null or undefined
            assertParamExists('getSensorsOfDeviceV2', 'deviceId', deviceId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getSensorsOfDeviceV2', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/tagged-hardware/v2/device/{deviceId}/sensor`
                .replace(`{${"deviceId"}}`, encodeURIComponent(String(deviceId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (sortBy !== undefined) {
                localVarQueryParameter['SortBy'] = sortBy;
            }

            if (ascending !== undefined) {
                localVarQueryParameter['Ascending'] = ascending;
            }

            if (size !== undefined) {
                localVarQueryParameter['Size'] = size;
            }

            if (frequency !== undefined) {
                localVarQueryParameter['Frequency'] = frequency;
            }

            if (skip !== undefined) {
                localVarQueryParameter['Skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['Take'] = take;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: [`hardware:read` OR `device-app:*`]
         * @param {string} tenantId 
         * @param {string} [sortBy] 
         * @param {boolean} [ascending] 
         * @param {SensorSize} [size] 
         * @param {SensorFrequency} [frequency] 
         * @param {boolean} [includeArchived] 
         * @param {boolean} [onlyArchived] 
         * @param {string} [includeArchivedAfter] 
         * @param {string} [createdAtStart] 
         * @param {string} [createdAtEnd] 
         * @param {string} [updatedAtStart] 
         * @param {string} [updatedAtEnd] 
         * @param {string} [archivedAtStart] 
         * @param {string} [archivedAtEnd] 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSensorsOfTenantV2: async (tenantId: string, sortBy?: string, ascending?: boolean, size?: SensorSize, frequency?: SensorFrequency, includeArchived?: boolean, onlyArchived?: boolean, includeArchivedAfter?: string, createdAtStart?: string, createdAtEnd?: string, updatedAtStart?: string, updatedAtEnd?: string, archivedAtStart?: string, archivedAtEnd?: string, skip?: number, take?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getSensorsOfTenantV2', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/tagged-hardware/v2/sensor`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (sortBy !== undefined) {
                localVarQueryParameter['SortBy'] = sortBy;
            }

            if (ascending !== undefined) {
                localVarQueryParameter['Ascending'] = ascending;
            }

            if (size !== undefined) {
                localVarQueryParameter['Size'] = size;
            }

            if (frequency !== undefined) {
                localVarQueryParameter['Frequency'] = frequency;
            }

            if (includeArchived !== undefined) {
                localVarQueryParameter['IncludeArchived'] = includeArchived;
            }

            if (onlyArchived !== undefined) {
                localVarQueryParameter['OnlyArchived'] = onlyArchived;
            }

            if (includeArchivedAfter !== undefined) {
                localVarQueryParameter['IncludeArchivedAfter'] = (includeArchivedAfter as any instanceof Date) ?
                    (includeArchivedAfter as any).toISOString() :
                    includeArchivedAfter;
            }

            if (createdAtStart !== undefined) {
                localVarQueryParameter['CreatedAtStart'] = (createdAtStart as any instanceof Date) ?
                    (createdAtStart as any).toISOString() :
                    createdAtStart;
            }

            if (createdAtEnd !== undefined) {
                localVarQueryParameter['CreatedAtEnd'] = (createdAtEnd as any instanceof Date) ?
                    (createdAtEnd as any).toISOString() :
                    createdAtEnd;
            }

            if (updatedAtStart !== undefined) {
                localVarQueryParameter['UpdatedAtStart'] = (updatedAtStart as any instanceof Date) ?
                    (updatedAtStart as any).toISOString() :
                    updatedAtStart;
            }

            if (updatedAtEnd !== undefined) {
                localVarQueryParameter['UpdatedAtEnd'] = (updatedAtEnd as any instanceof Date) ?
                    (updatedAtEnd as any).toISOString() :
                    updatedAtEnd;
            }

            if (archivedAtStart !== undefined) {
                localVarQueryParameter['ArchivedAtStart'] = (archivedAtStart as any instanceof Date) ?
                    (archivedAtStart as any).toISOString() :
                    archivedAtStart;
            }

            if (archivedAtEnd !== undefined) {
                localVarQueryParameter['ArchivedAtEnd'] = (archivedAtEnd as any instanceof Date) ?
                    (archivedAtEnd as any).toISOString() :
                    archivedAtEnd;
            }

            if (skip !== undefined) {
                localVarQueryParameter['Skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['Take'] = take;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: `hardware:write` (global scope)
         * @param {string} sensorId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreSensorV2: async (sensorId: string, tenantId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sensorId' is not null or undefined
            assertParamExists('restoreSensorV2', 'sensorId', sensorId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('restoreSensorV2', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/tagged-hardware/v2/sensor/{sensorId}/restore`
                .replace(`{${"sensorId"}}`, encodeURIComponent(String(sensorId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: `device-app:*` (global scope)
         * @param {string} sensorId 
         * @param {string} tenantId 
         * @param {ReplaceTagDto} [replaceTagDto] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        sensorReplaceTagV2: async (sensorId: string, tenantId: string, replaceTagDto?: ReplaceTagDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sensorId' is not null or undefined
            assertParamExists('sensorReplaceTagV2', 'sensorId', sensorId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('sensorReplaceTagV2', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/tagged-hardware/v2/sensor/{sensorId}/current-tag`
                .replace(`{${"sensorId"}}`, encodeURIComponent(String(sensorId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(replaceTagDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: [`hardware:write` OR `device-app:*`] (global scope)
         * @param {string} sensorId 
         * @param {string} tenantId 
         * @param {SensorPutDto} [sensorPutDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSensorV2: async (sensorId: string, tenantId: string, sensorPutDto?: SensorPutDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sensorId' is not null or undefined
            assertParamExists('updateSensorV2', 'sensorId', sensorId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('updateSensorV2', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/tagged-hardware/v2/sensor/{sensorId}`
                .replace(`{${"sensorId"}}`, encodeURIComponent(String(sensorId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sensorPutDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SensorApi - functional programming interface
 * @export
 */
export const SensorApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SensorApiAxiosParamCreator(configuration)
    return {
        /**
         * Required permissions: `hardware:write` (global scope)
         * @param {string} sensorId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async archiveSensorV2(sensorId: string, tenantId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SensorReadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.archiveSensorV2(sensorId, tenantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SensorApi.archiveSensorV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: `device-app:*` (global scope)
         * @param {string} tenantId 
         * @param {SensorPostDto} [sensorPostDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSensorV2(tenantId: string, sensorPostDto?: SensorPostDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SensorReadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSensorV2(tenantId, sensorPostDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SensorApi.createSensorV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: `hardware:write` (global scope)
         * @param {string} sensorId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async eraseSensorV2(sensorId: string, tenantId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.eraseSensorV2(sensorId, tenantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SensorApi.eraseSensorV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: [`hardware:read` OR `device-app:*`]
         * @param {Array<string>} [sensorIds] 
         * @param {string} [sortBy] 
         * @param {boolean} [ascending] 
         * @param {SensorSize} [size] 
         * @param {SensorFrequency} [frequency] 
         * @param {boolean} [includeArchived] 
         * @param {boolean} [onlyArchived] 
         * @param {string} [includeArchivedAfter] 
         * @param {string} [createdAtStart] 
         * @param {string} [createdAtEnd] 
         * @param {string} [updatedAtStart] 
         * @param {string} [updatedAtEnd] 
         * @param {string} [archivedAtStart] 
         * @param {string} [archivedAtEnd] 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllSensorsV2(sensorIds?: Array<string>, sortBy?: string, ascending?: boolean, size?: SensorSize, frequency?: SensorFrequency, includeArchived?: boolean, onlyArchived?: boolean, includeArchivedAfter?: string, createdAtStart?: string, createdAtEnd?: string, updatedAtStart?: string, updatedAtEnd?: string, archivedAtStart?: string, archivedAtEnd?: string, skip?: number, take?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SensorReadDtoPageDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllSensorsV2(sensorIds, sortBy, ascending, size, frequency, includeArchived, onlyArchived, includeArchivedAfter, createdAtStart, createdAtEnd, updatedAtStart, updatedAtEnd, archivedAtStart, archivedAtEnd, skip, take, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SensorApi.getAllSensorsV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: [`hardware:read` OR `device-app:*`]
         * @param {string} tagId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async getSensorByTagV2(tagId: string, tenantId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SensorReadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSensorByTagV2(tagId, tenantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SensorApi.getSensorByTagV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSensorSettingsV2(tenantId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SensorSettingsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSensorSettingsV2(tenantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SensorApi.getSensorSettingsV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: [`hardware:read` OR `device-app:*`]
         * @param {string} sensorId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSensorV2(sensorId: string, tenantId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SensorReadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSensorV2(sensorId, tenantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SensorApi.getSensorV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: [`hardware:read` OR `device-app:*`]
         * @param {string} deviceId 
         * @param {string} tenantId 
         * @param {string} [sortBy] 
         * @param {boolean} [ascending] 
         * @param {SensorSize} [size] 
         * @param {SensorFrequency} [frequency] 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSensorsOfDeviceV2(deviceId: string, tenantId: string, sortBy?: string, ascending?: boolean, size?: SensorSize, frequency?: SensorFrequency, skip?: number, take?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SensorReadDtoPageDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSensorsOfDeviceV2(deviceId, tenantId, sortBy, ascending, size, frequency, skip, take, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SensorApi.getSensorsOfDeviceV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: [`hardware:read` OR `device-app:*`]
         * @param {string} tenantId 
         * @param {string} [sortBy] 
         * @param {boolean} [ascending] 
         * @param {SensorSize} [size] 
         * @param {SensorFrequency} [frequency] 
         * @param {boolean} [includeArchived] 
         * @param {boolean} [onlyArchived] 
         * @param {string} [includeArchivedAfter] 
         * @param {string} [createdAtStart] 
         * @param {string} [createdAtEnd] 
         * @param {string} [updatedAtStart] 
         * @param {string} [updatedAtEnd] 
         * @param {string} [archivedAtStart] 
         * @param {string} [archivedAtEnd] 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSensorsOfTenantV2(tenantId: string, sortBy?: string, ascending?: boolean, size?: SensorSize, frequency?: SensorFrequency, includeArchived?: boolean, onlyArchived?: boolean, includeArchivedAfter?: string, createdAtStart?: string, createdAtEnd?: string, updatedAtStart?: string, updatedAtEnd?: string, archivedAtStart?: string, archivedAtEnd?: string, skip?: number, take?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SensorReadDtoPageDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSensorsOfTenantV2(tenantId, sortBy, ascending, size, frequency, includeArchived, onlyArchived, includeArchivedAfter, createdAtStart, createdAtEnd, updatedAtStart, updatedAtEnd, archivedAtStart, archivedAtEnd, skip, take, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SensorApi.getSensorsOfTenantV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: `hardware:write` (global scope)
         * @param {string} sensorId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restoreSensorV2(sensorId: string, tenantId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SensorReadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restoreSensorV2(sensorId, tenantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SensorApi.restoreSensorV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: `device-app:*` (global scope)
         * @param {string} sensorId 
         * @param {string} tenantId 
         * @param {ReplaceTagDto} [replaceTagDto] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async sensorReplaceTagV2(sensorId: string, tenantId: string, replaceTagDto?: ReplaceTagDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SensorReadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sensorReplaceTagV2(sensorId, tenantId, replaceTagDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SensorApi.sensorReplaceTagV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: [`hardware:write` OR `device-app:*`] (global scope)
         * @param {string} sensorId 
         * @param {string} tenantId 
         * @param {SensorPutDto} [sensorPutDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSensorV2(sensorId: string, tenantId: string, sensorPutDto?: SensorPutDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SensorReadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSensorV2(sensorId, tenantId, sensorPutDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SensorApi.updateSensorV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SensorApi - factory interface
 * @export
 */
export const SensorApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SensorApiFp(configuration)
    return {
        /**
         * Required permissions: `hardware:write` (global scope)
         * @param {SensorApiArchiveSensorV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveSensorV2(requestParameters: SensorApiArchiveSensorV2Request, options?: RawAxiosRequestConfig): AxiosPromise<SensorReadDto> {
            return localVarFp.archiveSensorV2(requestParameters.sensorId, requestParameters.tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: `device-app:*` (global scope)
         * @param {SensorApiCreateSensorV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSensorV2(requestParameters: SensorApiCreateSensorV2Request, options?: RawAxiosRequestConfig): AxiosPromise<SensorReadDto> {
            return localVarFp.createSensorV2(requestParameters.tenantId, requestParameters.sensorPostDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: `hardware:write` (global scope)
         * @param {SensorApiEraseSensorV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eraseSensorV2(requestParameters: SensorApiEraseSensorV2Request, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.eraseSensorV2(requestParameters.sensorId, requestParameters.tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: [`hardware:read` OR `device-app:*`]
         * @param {SensorApiGetAllSensorsV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSensorsV2(requestParameters: SensorApiGetAllSensorsV2Request = {}, options?: RawAxiosRequestConfig): AxiosPromise<SensorReadDtoPageDto> {
            return localVarFp.getAllSensorsV2(requestParameters.sensorIds, requestParameters.sortBy, requestParameters.ascending, requestParameters.size, requestParameters.frequency, requestParameters.includeArchived, requestParameters.onlyArchived, requestParameters.includeArchivedAfter, requestParameters.createdAtStart, requestParameters.createdAtEnd, requestParameters.updatedAtStart, requestParameters.updatedAtEnd, requestParameters.archivedAtStart, requestParameters.archivedAtEnd, requestParameters.skip, requestParameters.take, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: [`hardware:read` OR `device-app:*`]
         * @param {SensorApiGetSensorByTagV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getSensorByTagV2(requestParameters: SensorApiGetSensorByTagV2Request, options?: RawAxiosRequestConfig): AxiosPromise<SensorReadDto> {
            return localVarFp.getSensorByTagV2(requestParameters.tagId, requestParameters.tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SensorApiGetSensorSettingsV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSensorSettingsV2(requestParameters: SensorApiGetSensorSettingsV2Request, options?: RawAxiosRequestConfig): AxiosPromise<SensorSettingsDto> {
            return localVarFp.getSensorSettingsV2(requestParameters.tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: [`hardware:read` OR `device-app:*`]
         * @param {SensorApiGetSensorV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSensorV2(requestParameters: SensorApiGetSensorV2Request, options?: RawAxiosRequestConfig): AxiosPromise<SensorReadDto> {
            return localVarFp.getSensorV2(requestParameters.sensorId, requestParameters.tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: [`hardware:read` OR `device-app:*`]
         * @param {SensorApiGetSensorsOfDeviceV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSensorsOfDeviceV2(requestParameters: SensorApiGetSensorsOfDeviceV2Request, options?: RawAxiosRequestConfig): AxiosPromise<SensorReadDtoPageDto> {
            return localVarFp.getSensorsOfDeviceV2(requestParameters.deviceId, requestParameters.tenantId, requestParameters.sortBy, requestParameters.ascending, requestParameters.size, requestParameters.frequency, requestParameters.skip, requestParameters.take, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: [`hardware:read` OR `device-app:*`]
         * @param {SensorApiGetSensorsOfTenantV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSensorsOfTenantV2(requestParameters: SensorApiGetSensorsOfTenantV2Request, options?: RawAxiosRequestConfig): AxiosPromise<SensorReadDtoPageDto> {
            return localVarFp.getSensorsOfTenantV2(requestParameters.tenantId, requestParameters.sortBy, requestParameters.ascending, requestParameters.size, requestParameters.frequency, requestParameters.includeArchived, requestParameters.onlyArchived, requestParameters.includeArchivedAfter, requestParameters.createdAtStart, requestParameters.createdAtEnd, requestParameters.updatedAtStart, requestParameters.updatedAtEnd, requestParameters.archivedAtStart, requestParameters.archivedAtEnd, requestParameters.skip, requestParameters.take, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: `hardware:write` (global scope)
         * @param {SensorApiRestoreSensorV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreSensorV2(requestParameters: SensorApiRestoreSensorV2Request, options?: RawAxiosRequestConfig): AxiosPromise<SensorReadDto> {
            return localVarFp.restoreSensorV2(requestParameters.sensorId, requestParameters.tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: `device-app:*` (global scope)
         * @param {SensorApiSensorReplaceTagV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        sensorReplaceTagV2(requestParameters: SensorApiSensorReplaceTagV2Request, options?: RawAxiosRequestConfig): AxiosPromise<SensorReadDto> {
            return localVarFp.sensorReplaceTagV2(requestParameters.sensorId, requestParameters.tenantId, requestParameters.replaceTagDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: [`hardware:write` OR `device-app:*`] (global scope)
         * @param {SensorApiUpdateSensorV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSensorV2(requestParameters: SensorApiUpdateSensorV2Request, options?: RawAxiosRequestConfig): AxiosPromise<SensorReadDto> {
            return localVarFp.updateSensorV2(requestParameters.sensorId, requestParameters.tenantId, requestParameters.sensorPutDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for archiveSensorV2 operation in SensorApi.
 * @export
 * @interface SensorApiArchiveSensorV2Request
 */
export interface SensorApiArchiveSensorV2Request {
    /**
     * 
     * @type {string}
     * @memberof SensorApiArchiveSensorV2
     */
    readonly sensorId: string

    /**
     * 
     * @type {string}
     * @memberof SensorApiArchiveSensorV2
     */
    readonly tenantId: string
}

/**
 * Request parameters for createSensorV2 operation in SensorApi.
 * @export
 * @interface SensorApiCreateSensorV2Request
 */
export interface SensorApiCreateSensorV2Request {
    /**
     * 
     * @type {string}
     * @memberof SensorApiCreateSensorV2
     */
    readonly tenantId: string

    /**
     * 
     * @type {SensorPostDto}
     * @memberof SensorApiCreateSensorV2
     */
    readonly sensorPostDto?: SensorPostDto
}

/**
 * Request parameters for eraseSensorV2 operation in SensorApi.
 * @export
 * @interface SensorApiEraseSensorV2Request
 */
export interface SensorApiEraseSensorV2Request {
    /**
     * 
     * @type {string}
     * @memberof SensorApiEraseSensorV2
     */
    readonly sensorId: string

    /**
     * 
     * @type {string}
     * @memberof SensorApiEraseSensorV2
     */
    readonly tenantId: string
}

/**
 * Request parameters for getAllSensorsV2 operation in SensorApi.
 * @export
 * @interface SensorApiGetAllSensorsV2Request
 */
export interface SensorApiGetAllSensorsV2Request {
    /**
     * 
     * @type {Array<string>}
     * @memberof SensorApiGetAllSensorsV2
     */
    readonly sensorIds?: Array<string>

    /**
     * 
     * @type {string}
     * @memberof SensorApiGetAllSensorsV2
     */
    readonly sortBy?: string

    /**
     * 
     * @type {boolean}
     * @memberof SensorApiGetAllSensorsV2
     */
    readonly ascending?: boolean

    /**
     * 
     * @type {SensorSize}
     * @memberof SensorApiGetAllSensorsV2
     */
    readonly size?: SensorSize

    /**
     * 
     * @type {SensorFrequency}
     * @memberof SensorApiGetAllSensorsV2
     */
    readonly frequency?: SensorFrequency

    /**
     * 
     * @type {boolean}
     * @memberof SensorApiGetAllSensorsV2
     */
    readonly includeArchived?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof SensorApiGetAllSensorsV2
     */
    readonly onlyArchived?: boolean

    /**
     * 
     * @type {string}
     * @memberof SensorApiGetAllSensorsV2
     */
    readonly includeArchivedAfter?: string

    /**
     * 
     * @type {string}
     * @memberof SensorApiGetAllSensorsV2
     */
    readonly createdAtStart?: string

    /**
     * 
     * @type {string}
     * @memberof SensorApiGetAllSensorsV2
     */
    readonly createdAtEnd?: string

    /**
     * 
     * @type {string}
     * @memberof SensorApiGetAllSensorsV2
     */
    readonly updatedAtStart?: string

    /**
     * 
     * @type {string}
     * @memberof SensorApiGetAllSensorsV2
     */
    readonly updatedAtEnd?: string

    /**
     * 
     * @type {string}
     * @memberof SensorApiGetAllSensorsV2
     */
    readonly archivedAtStart?: string

    /**
     * 
     * @type {string}
     * @memberof SensorApiGetAllSensorsV2
     */
    readonly archivedAtEnd?: string

    /**
     * 
     * @type {number}
     * @memberof SensorApiGetAllSensorsV2
     */
    readonly skip?: number

    /**
     * 
     * @type {number}
     * @memberof SensorApiGetAllSensorsV2
     */
    readonly take?: number
}

/**
 * Request parameters for getSensorByTagV2 operation in SensorApi.
 * @export
 * @interface SensorApiGetSensorByTagV2Request
 */
export interface SensorApiGetSensorByTagV2Request {
    /**
     * 
     * @type {string}
     * @memberof SensorApiGetSensorByTagV2
     */
    readonly tagId: string

    /**
     * 
     * @type {string}
     * @memberof SensorApiGetSensorByTagV2
     */
    readonly tenantId: string
}

/**
 * Request parameters for getSensorSettingsV2 operation in SensorApi.
 * @export
 * @interface SensorApiGetSensorSettingsV2Request
 */
export interface SensorApiGetSensorSettingsV2Request {
    /**
     * 
     * @type {string}
     * @memberof SensorApiGetSensorSettingsV2
     */
    readonly tenantId: string
}

/**
 * Request parameters for getSensorV2 operation in SensorApi.
 * @export
 * @interface SensorApiGetSensorV2Request
 */
export interface SensorApiGetSensorV2Request {
    /**
     * 
     * @type {string}
     * @memberof SensorApiGetSensorV2
     */
    readonly sensorId: string

    /**
     * 
     * @type {string}
     * @memberof SensorApiGetSensorV2
     */
    readonly tenantId: string
}

/**
 * Request parameters for getSensorsOfDeviceV2 operation in SensorApi.
 * @export
 * @interface SensorApiGetSensorsOfDeviceV2Request
 */
export interface SensorApiGetSensorsOfDeviceV2Request {
    /**
     * 
     * @type {string}
     * @memberof SensorApiGetSensorsOfDeviceV2
     */
    readonly deviceId: string

    /**
     * 
     * @type {string}
     * @memberof SensorApiGetSensorsOfDeviceV2
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof SensorApiGetSensorsOfDeviceV2
     */
    readonly sortBy?: string

    /**
     * 
     * @type {boolean}
     * @memberof SensorApiGetSensorsOfDeviceV2
     */
    readonly ascending?: boolean

    /**
     * 
     * @type {SensorSize}
     * @memberof SensorApiGetSensorsOfDeviceV2
     */
    readonly size?: SensorSize

    /**
     * 
     * @type {SensorFrequency}
     * @memberof SensorApiGetSensorsOfDeviceV2
     */
    readonly frequency?: SensorFrequency

    /**
     * 
     * @type {number}
     * @memberof SensorApiGetSensorsOfDeviceV2
     */
    readonly skip?: number

    /**
     * 
     * @type {number}
     * @memberof SensorApiGetSensorsOfDeviceV2
     */
    readonly take?: number
}

/**
 * Request parameters for getSensorsOfTenantV2 operation in SensorApi.
 * @export
 * @interface SensorApiGetSensorsOfTenantV2Request
 */
export interface SensorApiGetSensorsOfTenantV2Request {
    /**
     * 
     * @type {string}
     * @memberof SensorApiGetSensorsOfTenantV2
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof SensorApiGetSensorsOfTenantV2
     */
    readonly sortBy?: string

    /**
     * 
     * @type {boolean}
     * @memberof SensorApiGetSensorsOfTenantV2
     */
    readonly ascending?: boolean

    /**
     * 
     * @type {SensorSize}
     * @memberof SensorApiGetSensorsOfTenantV2
     */
    readonly size?: SensorSize

    /**
     * 
     * @type {SensorFrequency}
     * @memberof SensorApiGetSensorsOfTenantV2
     */
    readonly frequency?: SensorFrequency

    /**
     * 
     * @type {boolean}
     * @memberof SensorApiGetSensorsOfTenantV2
     */
    readonly includeArchived?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof SensorApiGetSensorsOfTenantV2
     */
    readonly onlyArchived?: boolean

    /**
     * 
     * @type {string}
     * @memberof SensorApiGetSensorsOfTenantV2
     */
    readonly includeArchivedAfter?: string

    /**
     * 
     * @type {string}
     * @memberof SensorApiGetSensorsOfTenantV2
     */
    readonly createdAtStart?: string

    /**
     * 
     * @type {string}
     * @memberof SensorApiGetSensorsOfTenantV2
     */
    readonly createdAtEnd?: string

    /**
     * 
     * @type {string}
     * @memberof SensorApiGetSensorsOfTenantV2
     */
    readonly updatedAtStart?: string

    /**
     * 
     * @type {string}
     * @memberof SensorApiGetSensorsOfTenantV2
     */
    readonly updatedAtEnd?: string

    /**
     * 
     * @type {string}
     * @memberof SensorApiGetSensorsOfTenantV2
     */
    readonly archivedAtStart?: string

    /**
     * 
     * @type {string}
     * @memberof SensorApiGetSensorsOfTenantV2
     */
    readonly archivedAtEnd?: string

    /**
     * 
     * @type {number}
     * @memberof SensorApiGetSensorsOfTenantV2
     */
    readonly skip?: number

    /**
     * 
     * @type {number}
     * @memberof SensorApiGetSensorsOfTenantV2
     */
    readonly take?: number
}

/**
 * Request parameters for restoreSensorV2 operation in SensorApi.
 * @export
 * @interface SensorApiRestoreSensorV2Request
 */
export interface SensorApiRestoreSensorV2Request {
    /**
     * 
     * @type {string}
     * @memberof SensorApiRestoreSensorV2
     */
    readonly sensorId: string

    /**
     * 
     * @type {string}
     * @memberof SensorApiRestoreSensorV2
     */
    readonly tenantId: string
}

/**
 * Request parameters for sensorReplaceTagV2 operation in SensorApi.
 * @export
 * @interface SensorApiSensorReplaceTagV2Request
 */
export interface SensorApiSensorReplaceTagV2Request {
    /**
     * 
     * @type {string}
     * @memberof SensorApiSensorReplaceTagV2
     */
    readonly sensorId: string

    /**
     * 
     * @type {string}
     * @memberof SensorApiSensorReplaceTagV2
     */
    readonly tenantId: string

    /**
     * 
     * @type {ReplaceTagDto}
     * @memberof SensorApiSensorReplaceTagV2
     */
    readonly replaceTagDto?: ReplaceTagDto
}

/**
 * Request parameters for updateSensorV2 operation in SensorApi.
 * @export
 * @interface SensorApiUpdateSensorV2Request
 */
export interface SensorApiUpdateSensorV2Request {
    /**
     * 
     * @type {string}
     * @memberof SensorApiUpdateSensorV2
     */
    readonly sensorId: string

    /**
     * 
     * @type {string}
     * @memberof SensorApiUpdateSensorV2
     */
    readonly tenantId: string

    /**
     * 
     * @type {SensorPutDto}
     * @memberof SensorApiUpdateSensorV2
     */
    readonly sensorPutDto?: SensorPutDto
}

/**
 * SensorApi - object-oriented interface
 * @export
 * @class SensorApi
 * @extends {BaseAPI}
 */
export class SensorApi extends BaseAPI {
    /**
     * Required permissions: `hardware:write` (global scope)
     * @param {SensorApiArchiveSensorV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SensorApi
     */
    public archiveSensorV2(requestParameters: SensorApiArchiveSensorV2Request, options?: RawAxiosRequestConfig) {
        return SensorApiFp(this.configuration).archiveSensorV2(requestParameters.sensorId, requestParameters.tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: `device-app:*` (global scope)
     * @param {SensorApiCreateSensorV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SensorApi
     */
    public createSensorV2(requestParameters: SensorApiCreateSensorV2Request, options?: RawAxiosRequestConfig) {
        return SensorApiFp(this.configuration).createSensorV2(requestParameters.tenantId, requestParameters.sensorPostDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: `hardware:write` (global scope)
     * @param {SensorApiEraseSensorV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SensorApi
     */
    public eraseSensorV2(requestParameters: SensorApiEraseSensorV2Request, options?: RawAxiosRequestConfig) {
        return SensorApiFp(this.configuration).eraseSensorV2(requestParameters.sensorId, requestParameters.tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: [`hardware:read` OR `device-app:*`]
     * @param {SensorApiGetAllSensorsV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SensorApi
     */
    public getAllSensorsV2(requestParameters: SensorApiGetAllSensorsV2Request = {}, options?: RawAxiosRequestConfig) {
        return SensorApiFp(this.configuration).getAllSensorsV2(requestParameters.sensorIds, requestParameters.sortBy, requestParameters.ascending, requestParameters.size, requestParameters.frequency, requestParameters.includeArchived, requestParameters.onlyArchived, requestParameters.includeArchivedAfter, requestParameters.createdAtStart, requestParameters.createdAtEnd, requestParameters.updatedAtStart, requestParameters.updatedAtEnd, requestParameters.archivedAtStart, requestParameters.archivedAtEnd, requestParameters.skip, requestParameters.take, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: [`hardware:read` OR `device-app:*`]
     * @param {SensorApiGetSensorByTagV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof SensorApi
     */
    public getSensorByTagV2(requestParameters: SensorApiGetSensorByTagV2Request, options?: RawAxiosRequestConfig) {
        return SensorApiFp(this.configuration).getSensorByTagV2(requestParameters.tagId, requestParameters.tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SensorApiGetSensorSettingsV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SensorApi
     */
    public getSensorSettingsV2(requestParameters: SensorApiGetSensorSettingsV2Request, options?: RawAxiosRequestConfig) {
        return SensorApiFp(this.configuration).getSensorSettingsV2(requestParameters.tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: [`hardware:read` OR `device-app:*`]
     * @param {SensorApiGetSensorV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SensorApi
     */
    public getSensorV2(requestParameters: SensorApiGetSensorV2Request, options?: RawAxiosRequestConfig) {
        return SensorApiFp(this.configuration).getSensorV2(requestParameters.sensorId, requestParameters.tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: [`hardware:read` OR `device-app:*`]
     * @param {SensorApiGetSensorsOfDeviceV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SensorApi
     */
    public getSensorsOfDeviceV2(requestParameters: SensorApiGetSensorsOfDeviceV2Request, options?: RawAxiosRequestConfig) {
        return SensorApiFp(this.configuration).getSensorsOfDeviceV2(requestParameters.deviceId, requestParameters.tenantId, requestParameters.sortBy, requestParameters.ascending, requestParameters.size, requestParameters.frequency, requestParameters.skip, requestParameters.take, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: [`hardware:read` OR `device-app:*`]
     * @param {SensorApiGetSensorsOfTenantV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SensorApi
     */
    public getSensorsOfTenantV2(requestParameters: SensorApiGetSensorsOfTenantV2Request, options?: RawAxiosRequestConfig) {
        return SensorApiFp(this.configuration).getSensorsOfTenantV2(requestParameters.tenantId, requestParameters.sortBy, requestParameters.ascending, requestParameters.size, requestParameters.frequency, requestParameters.includeArchived, requestParameters.onlyArchived, requestParameters.includeArchivedAfter, requestParameters.createdAtStart, requestParameters.createdAtEnd, requestParameters.updatedAtStart, requestParameters.updatedAtEnd, requestParameters.archivedAtStart, requestParameters.archivedAtEnd, requestParameters.skip, requestParameters.take, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: `hardware:write` (global scope)
     * @param {SensorApiRestoreSensorV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SensorApi
     */
    public restoreSensorV2(requestParameters: SensorApiRestoreSensorV2Request, options?: RawAxiosRequestConfig) {
        return SensorApiFp(this.configuration).restoreSensorV2(requestParameters.sensorId, requestParameters.tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: `device-app:*` (global scope)
     * @param {SensorApiSensorReplaceTagV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof SensorApi
     */
    public sensorReplaceTagV2(requestParameters: SensorApiSensorReplaceTagV2Request, options?: RawAxiosRequestConfig) {
        return SensorApiFp(this.configuration).sensorReplaceTagV2(requestParameters.sensorId, requestParameters.tenantId, requestParameters.replaceTagDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: [`hardware:write` OR `device-app:*`] (global scope)
     * @param {SensorApiUpdateSensorV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SensorApi
     */
    public updateSensorV2(requestParameters: SensorApiUpdateSensorV2Request, options?: RawAxiosRequestConfig) {
        return SensorApiFp(this.configuration).updateSensorV2(requestParameters.sensorId, requestParameters.tenantId, requestParameters.sensorPutDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TagsApi - axios parameter creator
 * @export
 */
export const TagsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Required permissions: `hardware:read`
         * @param {string} tagId 
         * @param {boolean} [includeArchived] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaggedHardwareByTagGlobalV2: async (tagId: string, includeArchived?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tagId' is not null or undefined
            assertParamExists('getTaggedHardwareByTagGlobalV2', 'tagId', tagId)
            const localVarPath = `/tagged-hardware/v2/tags/{tagId}`
                .replace(`{${"tagId"}}`, encodeURIComponent(String(tagId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (includeArchived !== undefined) {
                localVarQueryParameter['includeArchived'] = includeArchived;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: [`hardware:read` OR `device-app:*`]
         * @param {string} tagId 
         * @param {string} tenantId 
         * @param {boolean} [includeArchived] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaggedHardwareByTagV2: async (tagId: string, tenantId: string, includeArchived?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tagId' is not null or undefined
            assertParamExists('getTaggedHardwareByTagV2', 'tagId', tagId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getTaggedHardwareByTagV2', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/tagged-hardware/v2/tags/{tagId}`
                .replace(`{${"tagId"}}`, encodeURIComponent(String(tagId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (includeArchived !== undefined) {
                localVarQueryParameter['includeArchived'] = includeArchived;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: `hardware:write` (global scope)
         * @param {string} tagId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invalidateTaggedHardwareByTagV2: async (tagId: string, tenantId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tagId' is not null or undefined
            assertParamExists('invalidateTaggedHardwareByTagV2', 'tagId', tagId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('invalidateTaggedHardwareByTagV2', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/tagged-hardware/v2/tags/{tagId}/invalidate-tag`
                .replace(`{${"tagId"}}`, encodeURIComponent(String(tagId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Required permissions: [`hardware:write` OR `device-app:*`]
         * @param {string} tagId 
         * @param {string} tenantId 
         * @param {ReplaceTagDto} [replaceTagDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceTaggedHardwareByTagV2: async (tagId: string, tenantId: string, replaceTagDto?: ReplaceTagDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tagId' is not null or undefined
            assertParamExists('replaceTaggedHardwareByTagV2', 'tagId', tagId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('replaceTaggedHardwareByTagV2', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/tagged-hardware/v2/tags/{tagId}/replace-tag`
                .replace(`{${"tagId"}}`, encodeURIComponent(String(tagId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(replaceTagDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TagsApi - functional programming interface
 * @export
 */
export const TagsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TagsApiAxiosParamCreator(configuration)
    return {
        /**
         * Required permissions: `hardware:read`
         * @param {string} tagId 
         * @param {boolean} [includeArchived] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTaggedHardwareByTagGlobalV2(tagId: string, includeArchived?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaggedHardwareLookupByTagReadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTaggedHardwareByTagGlobalV2(tagId, includeArchived, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TagsApi.getTaggedHardwareByTagGlobalV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: [`hardware:read` OR `device-app:*`]
         * @param {string} tagId 
         * @param {string} tenantId 
         * @param {boolean} [includeArchived] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTaggedHardwareByTagV2(tagId: string, tenantId: string, includeArchived?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaggedHardwareLookupByTagReadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTaggedHardwareByTagV2(tagId, tenantId, includeArchived, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TagsApi.getTaggedHardwareByTagV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: `hardware:write` (global scope)
         * @param {string} tagId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async invalidateTaggedHardwareByTagV2(tagId: string, tenantId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaggedHardwareLookupByTagReadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.invalidateTaggedHardwareByTagV2(tagId, tenantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TagsApi.invalidateTaggedHardwareByTagV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Required permissions: [`hardware:write` OR `device-app:*`]
         * @param {string} tagId 
         * @param {string} tenantId 
         * @param {ReplaceTagDto} [replaceTagDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async replaceTaggedHardwareByTagV2(tagId: string, tenantId: string, replaceTagDto?: ReplaceTagDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaggedHardwareLookupByTagReadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.replaceTaggedHardwareByTagV2(tagId, tenantId, replaceTagDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TagsApi.replaceTaggedHardwareByTagV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TagsApi - factory interface
 * @export
 */
export const TagsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TagsApiFp(configuration)
    return {
        /**
         * Required permissions: `hardware:read`
         * @param {TagsApiGetTaggedHardwareByTagGlobalV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaggedHardwareByTagGlobalV2(requestParameters: TagsApiGetTaggedHardwareByTagGlobalV2Request, options?: RawAxiosRequestConfig): AxiosPromise<TaggedHardwareLookupByTagReadDto> {
            return localVarFp.getTaggedHardwareByTagGlobalV2(requestParameters.tagId, requestParameters.includeArchived, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: [`hardware:read` OR `device-app:*`]
         * @param {TagsApiGetTaggedHardwareByTagV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaggedHardwareByTagV2(requestParameters: TagsApiGetTaggedHardwareByTagV2Request, options?: RawAxiosRequestConfig): AxiosPromise<TaggedHardwareLookupByTagReadDto> {
            return localVarFp.getTaggedHardwareByTagV2(requestParameters.tagId, requestParameters.tenantId, requestParameters.includeArchived, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: `hardware:write` (global scope)
         * @param {TagsApiInvalidateTaggedHardwareByTagV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invalidateTaggedHardwareByTagV2(requestParameters: TagsApiInvalidateTaggedHardwareByTagV2Request, options?: RawAxiosRequestConfig): AxiosPromise<TaggedHardwareLookupByTagReadDto> {
            return localVarFp.invalidateTaggedHardwareByTagV2(requestParameters.tagId, requestParameters.tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * Required permissions: [`hardware:write` OR `device-app:*`]
         * @param {TagsApiReplaceTaggedHardwareByTagV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceTaggedHardwareByTagV2(requestParameters: TagsApiReplaceTaggedHardwareByTagV2Request, options?: RawAxiosRequestConfig): AxiosPromise<TaggedHardwareLookupByTagReadDto> {
            return localVarFp.replaceTaggedHardwareByTagV2(requestParameters.tagId, requestParameters.tenantId, requestParameters.replaceTagDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getTaggedHardwareByTagGlobalV2 operation in TagsApi.
 * @export
 * @interface TagsApiGetTaggedHardwareByTagGlobalV2Request
 */
export interface TagsApiGetTaggedHardwareByTagGlobalV2Request {
    /**
     * 
     * @type {string}
     * @memberof TagsApiGetTaggedHardwareByTagGlobalV2
     */
    readonly tagId: string

    /**
     * 
     * @type {boolean}
     * @memberof TagsApiGetTaggedHardwareByTagGlobalV2
     */
    readonly includeArchived?: boolean
}

/**
 * Request parameters for getTaggedHardwareByTagV2 operation in TagsApi.
 * @export
 * @interface TagsApiGetTaggedHardwareByTagV2Request
 */
export interface TagsApiGetTaggedHardwareByTagV2Request {
    /**
     * 
     * @type {string}
     * @memberof TagsApiGetTaggedHardwareByTagV2
     */
    readonly tagId: string

    /**
     * 
     * @type {string}
     * @memberof TagsApiGetTaggedHardwareByTagV2
     */
    readonly tenantId: string

    /**
     * 
     * @type {boolean}
     * @memberof TagsApiGetTaggedHardwareByTagV2
     */
    readonly includeArchived?: boolean
}

/**
 * Request parameters for invalidateTaggedHardwareByTagV2 operation in TagsApi.
 * @export
 * @interface TagsApiInvalidateTaggedHardwareByTagV2Request
 */
export interface TagsApiInvalidateTaggedHardwareByTagV2Request {
    /**
     * 
     * @type {string}
     * @memberof TagsApiInvalidateTaggedHardwareByTagV2
     */
    readonly tagId: string

    /**
     * 
     * @type {string}
     * @memberof TagsApiInvalidateTaggedHardwareByTagV2
     */
    readonly tenantId: string
}

/**
 * Request parameters for replaceTaggedHardwareByTagV2 operation in TagsApi.
 * @export
 * @interface TagsApiReplaceTaggedHardwareByTagV2Request
 */
export interface TagsApiReplaceTaggedHardwareByTagV2Request {
    /**
     * 
     * @type {string}
     * @memberof TagsApiReplaceTaggedHardwareByTagV2
     */
    readonly tagId: string

    /**
     * 
     * @type {string}
     * @memberof TagsApiReplaceTaggedHardwareByTagV2
     */
    readonly tenantId: string

    /**
     * 
     * @type {ReplaceTagDto}
     * @memberof TagsApiReplaceTaggedHardwareByTagV2
     */
    readonly replaceTagDto?: ReplaceTagDto
}

/**
 * TagsApi - object-oriented interface
 * @export
 * @class TagsApi
 * @extends {BaseAPI}
 */
export class TagsApi extends BaseAPI {
    /**
     * Required permissions: `hardware:read`
     * @param {TagsApiGetTaggedHardwareByTagGlobalV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagsApi
     */
    public getTaggedHardwareByTagGlobalV2(requestParameters: TagsApiGetTaggedHardwareByTagGlobalV2Request, options?: RawAxiosRequestConfig) {
        return TagsApiFp(this.configuration).getTaggedHardwareByTagGlobalV2(requestParameters.tagId, requestParameters.includeArchived, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: [`hardware:read` OR `device-app:*`]
     * @param {TagsApiGetTaggedHardwareByTagV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagsApi
     */
    public getTaggedHardwareByTagV2(requestParameters: TagsApiGetTaggedHardwareByTagV2Request, options?: RawAxiosRequestConfig) {
        return TagsApiFp(this.configuration).getTaggedHardwareByTagV2(requestParameters.tagId, requestParameters.tenantId, requestParameters.includeArchived, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: `hardware:write` (global scope)
     * @param {TagsApiInvalidateTaggedHardwareByTagV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagsApi
     */
    public invalidateTaggedHardwareByTagV2(requestParameters: TagsApiInvalidateTaggedHardwareByTagV2Request, options?: RawAxiosRequestConfig) {
        return TagsApiFp(this.configuration).invalidateTaggedHardwareByTagV2(requestParameters.tagId, requestParameters.tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Required permissions: [`hardware:write` OR `device-app:*`]
     * @param {TagsApiReplaceTaggedHardwareByTagV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagsApi
     */
    public replaceTaggedHardwareByTagV2(requestParameters: TagsApiReplaceTaggedHardwareByTagV2Request, options?: RawAxiosRequestConfig) {
        return TagsApiFp(this.configuration).replaceTaggedHardwareByTagV2(requestParameters.tagId, requestParameters.tenantId, requestParameters.replaceTagDto, options).then((request) => request(this.axios, this.basePath));
    }
}



